import styles from "./BundleBuilderBundle.module.css";
import {
    BBTierOptions,
    BundleBuilderConfigInterface,
    FixedBoxConfig,
    ProductObj,
    StepConditionType,
    StepsType,
    SubStepType,
    VariantsObj,
} from "../../Types";
import { TStoreContext } from "../../../../context/types";
import {
    createContext,
    Dispatch,
    SetStateAction,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import {
    CustomSwatches,
    Swatches,
    // VariantSelector,
    VariantSelectorV2,
} from "../../BundlePreviewWrapper/BundlePreviewWrapper";
import {
    AvailableBundleBuilderTemplates,
    buildMetafieldFromSwatchOptions,
    BundleTypes,
    DISCOUNT_TYPES,
    DiscountTypes,
    fetchCollectionProducts,
    filterInStockProducts,
    getDiscountValueWithSign,
    getDiscountValueWithSignString,
    getFinalPrice,
    getPixelsForImage,
    getPriceLabel,
    getWeightUnit,
    showWeightInfo,
    updateBundleConfigWithRealTimeProducts,
    updateBundleStats,
    trackAbVisitorEvent,
} from "../../constants";
import ProductImageWrapper from "../../BundlePreviewWrapper/ProductImageWrapper";
import useIsMobile from "../../../../hooks/useIsMobile";
import config, { BACKEND_URL } from "../../../../config";
import Spinner from "../../../../components/Icons/Spinner";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import ProductInfoModal from "./ProductInfoModal";
import SearchIcon from "./SearchIcon";
import cartWatcher from "../../../CartWatcherClass";
import {
    checkProductLimit,
    getCurrentPageSelectCount,
    getValidErrorMsg,
    renderErrorsOnButton,
    shouldDisableCta,
    removeConditionalProductIfAny,
    applyConditionsBB,
    getHiddenStepsBB,
    getUpdatedVariants,
    getBBCardWidth,
    getGapForSize,
    getCurrentPageSelectTotal,
    convertValueToLocal,
    shouldGoToNext,
    roundN,
} from "./BBConstants";
import StepsHeaderBar, { RenderSubStepBadges, RenderSubStepDropdown } from "./StepsHeader";
import CheckoutModal from "./CheckoutModal";
import { RenderVariantInfo } from "./BBProductCard";
import { checkForEmbedId, handleBundleCheckout } from "../../RenderOnStore/utilities";
import { currencyToSymbols, filterDuplicateStepConditions, normalizeStepConditions } from "../../../utilities";
import BundleProgressBar from "./BundleProgressBar";
import CapacityProgressBar from "./CapacityProgressBar";
import { InspectorEditableBlock } from "../../CommonFields/InspectorEditableBlock";
import {
    executeScopedJS,
    getProductId,
    injectScopedCSS,
    IS_CUSTOM_CLICK_TO_ADD_GRID_SHOPS,
    isDispensaryCoStore,
    isLilSweetTreatStore,
    METAL_BIRD_SHOPS,
    SPRAY_IT_SHOPS,
} from "../../../constants";
import { CiGift } from "react-icons/ci";
import ReviewAddOnCarousel from "./ReviewAddOnCarousel";
import PlusIcon from "../../../Cart/CartIcons/PlusIcon";
import PreviewBanner from "../../../../components/Banners/PreviewBanner";
import { LuPackage } from "react-icons/lu";
import AngleLeftIcon from "../../../../components/Icons/AngleLeftIcon";
import AngleRightIcon from "../../../../components/Icons/AngleRightIcon";
import { FiUpload, FiFile } from "react-icons/fi";

export interface ExtendedStepsType extends StepsType {
    review_step?: boolean;
    is_enabled: boolean;
}

type BundleBuilderBundleContextType = {
    steps: ExtendedStepsType[] | [];
    activeStep: number;
    setActiveStep: Dispatch<SetStateAction<number>>;
    activeSubStep: number;
    setActiveSubStep: Dispatch<SetStateAction<number>>;
    selectedProducts: ProductObj[] | [];
    selectedVariants: any[];
    setSelectedProducts: Dispatch<SetStateAction<ProductObj[] | []>>;
    expandProductList: boolean;
    setExpandProductList: Dispatch<SetStateAction<boolean>>;
    isMobile: boolean;
    bundleConfig: BundleBuilderConfigInterface;
    handleRemoveProduct: any;
    handleAddProduct: any;
    money_format: string;
    currency: string;
    handleBundleBuilderCheckout: () => Promise<void>;
    standAlone: boolean;
    previewType: number | null;
    productListRef: React.RefObject<HTMLDivElement>;
    checkingOut: boolean;
    isNextAllowed: any;
    boxQuantity: number;
    // messages related fields
    nextErrorMsg: string[];
    tierSuccessMessage: string;
    // fields related fields
    setFieldsData: React.Dispatch<React.SetStateAction<{ id: string; label: string; value: string }[]>>;
    // discount related fields
    discountType: DiscountTypes;
    discountValue: number;
    actualConfigDiscountType: DiscountTypes;
    // addon related fields
    handleAddAddonProduct: () => any;
    handleRemoveAddonProduct: () => any;
    addonProducts: any[];
    loadingAddons: boolean;
    // quantity related fields
    totalQuantity: number;
    normalTotalQuantity: number;
    addonTotalQuantity: number;
    freeGiftTotalQuantity: number;
    // price related fields
    totalPrice: number;
    totalCompareAtPrice: number;
    totalFreeGiftPrice: number;
    totalAddonPrice: number;
    addonsDiscountValue: number;
    baseSubtotal: number;
    baseSubtotalForDiscount: number;
    discountedBundleTotal: number;
    hasDiscount: boolean;
    showStrikePrice: boolean;
    discountAmount: number;
    discountAmountPercent: number;
    discountValueToShow: number;
    // misc
    containerRef: React.RefObject<HTMLDivElement>;
    autoFillFreeGift: any;
    disableNextOnFields: boolean;
    userShopname: string;
    maxBoxSize: number;
    isValidBoxSize: () => boolean;
    anyCardShowingDosageResults: boolean;
    setAnyCardShowingDosageResults: Dispatch<SetStateAction<boolean>>;
    dosageResultsHeight: number;
    setDosageResultsHeight: Dispatch<SetStateAction<number>>;
    dispensaryFilteredTotalQty: number;
    dispensaryFilteredTotalCapacity: number;
    isDispensaryProgressBarEnabled: boolean;
};

const fetchCount = 50;

export const removeFixedBreakingStyles = (el: HTMLElement | null) => {
    if (!el) return;
    let parent = el.parentElement;
    while (parent && parent !== document.body) {
        const style = window.getComputedStyle(parent);
        if (
            style.transform !== "none" ||
            style.perspective !== "none" ||
            style.filter !== "none" ||
            style.backdropFilter !== "none" ||
            style.willChange !== "auto"
        ) {
            parent.style.transform = "none";
            parent.style.perspective = "none";
            parent.style.filter = "none";
            parent.style.backdropFilter = "none";
            parent.style.willChange = "auto";
        }
        parent = parent.parentElement;
    }
};

export const CheckIcon = () => {
    return (
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.12841 10.2312L5.60299 13.7058C6.0722 14.1748 6.70851 14.4383 7.37197 14.4383C8.03544 14.4383 8.67174 14.1748 9.14095 13.7058L19.8716 2.97509C20.0235 2.81779 20.1076 2.60711 20.1057 2.38843C20.1038 2.16975 20.0161 1.96056 19.8615 1.80593C19.7068 1.65129 19.4976 1.56358 19.279 1.56168C19.0603 1.55978 18.8496 1.64384 18.6923 1.79577L7.96163 12.5264C7.80523 12.6828 7.59313 12.7706 7.37197 12.7706C7.15082 12.7706 6.93871 12.6828 6.78231 12.5264L3.30773 9.05185C3.15043 8.89992 2.93975 8.81586 2.72107 8.81776C2.50239 8.81966 2.29321 8.90737 2.13857 9.06201C1.98393 9.21665 1.89622 9.42583 1.89432 9.64451C1.89242 9.86319 1.97648 10.0739 2.12841 10.2312Z"
                fill="#FFFFDF"
                stroke="#FFFFDF"
                strokeWidth={2}
            />
        </svg>
    );
};

export const PlusMinus = ({ size = "1em", color = "currentColor" }: { size?: number | string; color?: string }) => {
    return (
        <svg
            stroke={color}
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 256 256"
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M208.49,64.49l-144,144a12,12,0,0,1-17-17l144-144a12,12,0,0,1,17,17ZM60,112a12,12,0,0,0,24,0V84h28a12,12,0,0,0,0-24H84V32a12,12,0,0,0-24,0V60H32a12,12,0,0,0,0,24H60Zm164,60H144a12,12,0,0,0,0,24h80a12,12,0,0,0,0-24Z"></path>
        </svg>
    );
};

export const CloseIcon = ({ size = 10 }: { size?: number }) => {
    return (
        <svg
            width="9"
            style={{ height: size, width: size, stroke: "none", fill: "#000000" }}
            height="10"
            viewBox="0 0 9 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.313904 7.89911L7.7453 0.467712L9.00638 1.7288L1.57499 9.16019L0.313904 7.89911ZM0.313904 1.7288L1.57499 0.467712L9.00638 7.89911L7.7453 9.16019L0.313904 1.7288Z"
                fill="black"
            />
            <path
                d="M0.313904 7.89911L7.7453 0.467712L9.00638 1.7288L1.57499 9.16019L0.313904 7.89911ZM0.313904 1.7288L1.57499 0.467712L9.00638 7.89911L7.7453 9.16019L0.313904 1.7288Z"
                fill="#3F3F3F"
            />
        </svg>
    );
};

export const LeftArrow = ({ color = "#5E5E5E", size = 14 }: { color?: string; size?: number }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.46938 0.969372L0.969376 5.46937C0.899455 5.53905 0.843979 5.62184 0.806125 5.71301C0.76827 5.80417 0.748784 5.90191 0.748784 6.00062C0.748784 6.09933 0.76827 6.19707 0.806125 6.28824C0.843979 6.3794 0.899455 6.46219 0.969376 6.53187L5.46938 11.0319C5.61027 11.1728 5.80137 11.2519 6.00063 11.2519C6.19988 11.2519 6.39098 11.1728 6.53188 11.0319C6.67277 10.891 6.75193 10.6999 6.75193 10.5006C6.75193 10.3014 6.67277 10.1103 6.53188 9.96937L3.3125 6.75L12.5 6.75C12.6989 6.75 12.8897 6.67098 13.0303 6.53033C13.171 6.38967 13.25 6.19891 13.25 6C13.25 5.80108 13.171 5.61032 13.0303 5.46967C12.8897 5.32901 12.6989 5.25 12.5 5.25L3.3125 5.25L6.5325 2.03062C6.6734 1.88973 6.75255 1.69863 6.75255 1.49937C6.75255 1.30011 6.6734 1.10902 6.5325 0.968123C6.3916 0.827227 6.20051 0.74807 6.00125 0.74807C5.80199 0.74807 5.6109 0.827227 5.47 0.968123L5.46938 0.969372Z"
                fill={color}
            />
        </svg>
    );
};

const flatProductAsVariants = (products: ProductObj[], asVariantTrue: boolean): ProductObj[] => {
    if (!asVariantTrue) return products;

    return products.flatMap((product) =>
        product.variants.map((variant) => ({
            ...product,
            title: variant?.displayName || product?.title,
            parentName: product?.title,
            variants: [{ ...variant }],
            selectedVariants: [{ ...variant }],
        })),
    );
};

const FileUploader = ({
    field,
    handleFields,
    fieldsData,
    styles,
    index,
    is_required,
    handleBlur,
    validateFieldsAndSetDisable,
    userShopname,
    stepIdx,
}: any) => {
    const { bundleConfig } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState("");

    const isMultiple = field.file_upload_settings?.allow_multiple || false;

    // Use a Ref to keep track of the latest fieldsData array to avoid stale closures in async handlers.
    const fieldsDataRef = useRef(fieldsData);
    useEffect(() => {
        fieldsDataRef.current = fieldsData;
    }, [fieldsData]);

    const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        setError("");

        if (!isMultiple) {
            const currentData = fieldsDataRef.current || [];
            const fieldId = `${stepIdx}-${index}`;
            const currentFieldValue = currentData.find((fd: any) => fd?.id === fieldId)?.value || "";
            const existingUrls = currentFieldValue.split(",").filter(Boolean);
            if (existingUrls.length > 0) {
                setError(
                    bundleConfig.file_upload_already_uploaded_error ||
                        "A file is already uploaded. Please remove it before uploading a new one.",
                );
                if (e.target) e.target.value = "";
                return;
            }
        }

        const settings = field.file_upload_settings || {
            max_file_size: 5,
            allowed_file_types: ["images"],
        };

        const maxSize = settings.max_file_size * 1024 * 1024;

        const allowedImages = [".jpg", ".jpeg", ".png", ".gif", ".svg"];
        const allowedDocs = [".pdf", ".doc", ".docx"];

        let allowedExts: string[] = [];

        if (settings.allowed_file_types.includes("images")) allowedExts = [...allowedExts, ...allowedImages];

        if (settings.allowed_file_types.includes("documents")) allowedExts = [...allowedExts, ...allowedDocs];

        const validFiles: File[] = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if (file.size > maxSize) {
                const subText = (bundleConfig.file_upload_max_size_text || "Max size: {maxSize}MB").replace(
                    "{maxSize}",
                    (settings.max_file_size || 5).toString(),
                );
                setError(`File "${file.name}" is too large. ` + subText);
                return;
            }

            const fileName = file.name.toLowerCase();

            const hasAllowedExt = allowedExts.some((ext) => fileName.endsWith(ext));

            if (!hasAllowedExt) {
                setError(`Invalid file type for "${file.name}". Allowed: ${settings.allowed_file_types.join(", ")}`);
                return;
            }

            validFiles.push(file);
        }

        setUploading(true);
        setProgress(10);

        try {
            const newUploadedUrls: string[] = [];

            for (let i = 0; i < validFiles.length; i++) {
                const file = validFiles[i];

                const formData = new FormData();
                formData.append("file", file);
                formData.append("onShopifyCDN", "true");

                setProgress(Math.round(((i + 1) / validFiles.length) * 90));
                const response = await fetch(`${BACKEND_URL}/public/${config.appName}/upload?shop=${userShopname}`, {
                    method: "POST",
                    body: formData,
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(errorText || `Upload failed with status ${response.status}`);
                }

                const responseData = await response.json();
                if (responseData?.url) {
                    newUploadedUrls.push(responseData?.url);
                } else {
                    const errorMsg = responseData?.error || `Upload failed for ${file.name}`;
                    throw new Error(errorMsg);
                }
            }

            setProgress(100);

            setTimeout(() => {
                setUploading(false);
                setProgress(0);

                // Fetch the absolute latest fieldValue from the Ref to handle multi-step uploads correctly.
                const currentData = fieldsDataRef.current || [];
                const fieldId = `${stepIdx}-${index}`;
                const fieldLabel = field.field_title;
                const currentFieldValue = currentData.find((fd: any) => fd?.id === fieldId)?.value || "";
                const existingUrls = currentFieldValue.split(",").filter(Boolean);
                let mergedUrls: string[] = [];

                if (isMultiple) {
                    mergedUrls = Array.from(new Set([...existingUrls, ...newUploadedUrls]));
                } else {
                    mergedUrls = [newUploadedUrls[newUploadedUrls.length - 1]]; // Only take the last one uploaded in this batch
                }

                const newValue = mergedUrls.join(",");

                handleFields({ id: fieldId, label: fieldLabel, value: newValue });
                handleBlur(fieldLabel, is_required, newValue, index);
                validateFieldsAndSetDisable();

                if (e.target) e.target.value = ""; // Reset input
            }, 500);
        } catch (err: any) {
            console.error("Upload error:", err);
            setError(err?.message || "Upload failed. Please try again.");
            setUploading(false);
        }
    };

    const removeFile = (urlToRemove: string) => {
        // Use prop directly for synchronous removals
        const fieldId = `${stepIdx}-${index}`;
        const fieldLabel = field.field_title;
        const currentFieldValue = fieldsData.find((fd: any) => fd?.id === fieldId)?.value || "";
        const existingUrls = currentFieldValue.split(",").filter(Boolean);
        const newValue = existingUrls.filter((url: string) => url !== urlToRemove).join(",");

        handleFields({ id: fieldId, label: fieldLabel, value: newValue });
        handleBlur(fieldLabel, is_required, newValue, index);
        validateFieldsAndSetDisable();
    };

    const fieldId = `${stepIdx}-${index}`;
    const currentFieldValue = fieldsData.find((fd: any) => fd?.id === fieldId)?.value || "";
    const uploadedUrls = currentFieldValue.split(",").filter(Boolean);
    return (
        <div className={styles.uploadWrapper}>
            <div className={`${styles.uploadBox} ${uploading ? styles.uploading : ""}`}>
                <input
                    type="file"
                    className={styles.fileInput}
                    onChange={onFileChange}
                    disabled={uploading}
                    multiple={isMultiple}
                    accept={
                        (field.file_upload_settings?.allowed_file_types?.includes("images") ? "image/*" : "") +
                        (field.file_upload_settings?.allowed_file_types?.includes("documents")
                            ? (field.file_upload_settings?.allowed_file_types?.includes("images") ? "," : "") +
                              ".pdf,.doc,.docx"
                            : "")
                    }
                />

                <div className={styles.uploadIcon}>
                    <FiUpload />
                </div>

                <div className={styles.uploadText}>
                    {uploading
                        ? bundleConfig.file_upload_uploading_text || "Uploading..."
                        : isMultiple
                          ? bundleConfig.file_upload_click_to_upload_multiple_text || "Click to upload files"
                          : bundleConfig.file_upload_click_to_upload_single_text || "Click to upload file"}
                </div>

                <div className={styles.uploadSubtext}>
                    {(bundleConfig.file_upload_max_size_text || "Max size: {maxSize}MB").replace(
                        "{maxSize}",
                        (field.file_upload_settings?.max_file_size || 5).toString(),
                    )}
                </div>

                {uploading && (
                    <div className={styles.progressBarContainer}>
                        <div className={styles.progressBar}>
                            <div className={styles.progressFill} style={{ width: `${progress}%` }} />
                        </div>
                        <div className={styles.progressLabel}>{progress}%</div>
                    </div>
                )}
            </div>

            {error && <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>{error}</div>}

            {uploadedUrls.length > 1 && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                    {bundleConfig.file_upload_only_one_file_error ||
                        "You can only upload one file. Please remove the existing one to upload a new one."}
                </div>
            )}

            {uploadedUrls.length > 0 && !uploading && (
                <div className={styles.uploadedFiles}>
                    {uploadedUrls.map((url: string, i: number) => (
                        <div key={i} className={styles.fileItem}>
                            <div className={styles.fileItemInfo}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    {url.match(/\.(jpeg|jpg|gif|png|svg)$/i) ? (
                                        <img
                                            src={url?.split("?")[0]}
                                            alt="upload-preview"
                                            className={styles.filePreview}
                                        />
                                    ) : (
                                        <FiFile />
                                    )}
                                    <span className={styles.fileName}>{url.split("/").pop()}</span>
                                </div>
                            </div>
                            <div className={styles.removeFileIcon} onClick={() => removeFile(url)}>
                                <CloseIcon size={12} />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const RenderFields = ({
    fields,
    bundleConfig,
    handleFields,
    fieldsData,
    setDisableNextOnFields,
    userShopname,
    stepIdx,
}: {
    fields: StepsType["fields"];
    bundleConfig: BundleBuilderConfigInterface;
    handleFields: any;
    fieldsData: any;
    setDisableNextOnFields: Dispatch<SetStateAction<boolean>>;
    userShopname: string;
    stepIdx: number;
}) => {
    const [errorMsg, setErrorMsg] = useState<string[]>([]);
    const handleBlur = (fieldTitle: string, isRequired: boolean, value: string, index: number) => {
        setErrorMsg((ps) => {
            const _errors = [...ps];

            if (isRequired && value.trim().length === 0) {
                _errors[index] = `${fieldTitle} is required`;
            } else {
                _errors[index] = "";
            }

            return _errors;
        });
    };

    useEffect(() => {
        setErrorMsg(fields.map(() => ""));
    }, [fields]);

    const validateFieldsAndSetDisable = () => {
        let shouldDisable = false;

        fields.forEach((field, idx) => {
            if (field.is_required) {
                const fieldId = `${stepIdx}-${idx}`;
                const fieldData = fieldsData.find((f: any) => f.id === fieldId);
                const value = fieldData?.value?.trim() || "";
                const errors = errorMsg[idx] || [];

                if (!value || errors.length > 0) {
                    shouldDisable = true;
                }
            }
        });

        setDisableNextOnFields(shouldDisable);
    };

    useEffect(() => {
        validateFieldsAndSetDisable();
    }, [fields, fieldsData, errorMsg]);

    const RenderError = (idx: number) => (
        <span
            style={{
                position: "absolute",
                bottom: 0,
                fontSize: 12,
                lineHeight: "normal",
                left: 0,
                color: "red",
                transform: "translateY(100%)",
            }}
        >
            {errorMsg[idx]}
        </span>
    );
    return fields.map((field, index) => {
        const { field_type, field_title, field_placeholder, is_required } = field;

        return (
            <div key={index} style={{ marginBottom: "25px", marginTop: 10 }}>
                <label
                    style={{
                        display: "flex",
                        fontSize: bundleConfig?.bundles_design.product_name_size,
                        color: bundleConfig?.bundles_design?.product_name_color,
                        fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                        fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                        lineHeight: "normal",
                        marginBottom: 10,
                        position: "relative",
                        flexWrap: "wrap",
                    }}
                >
                    {field_title}
                    {is_required && (
                        <Tooltip text={"This field is required"} position={"top"}>
                            <span style={{ color: "red", fontSize: 20, position: "absolute", right: -10, top: -3 }}>
                                *
                            </span>
                        </Tooltip>
                    )}
                </label>
                {field_type === "input" ? (
                    <span style={{ display: "flex", position: "relative" }}>
                        <input
                            className={styles.customInput}
                            type={"text"}
                            key={`${stepIdx}-${index}`}
                            placeholder={field_placeholder}
                            onChange={(e) => {
                                const fieldId = `${stepIdx}-${index}`;
                                handleFields({ id: fieldId, label: field_title, value: e?.target.value || "" });
                                handleBlur(field_title, is_required, e.target.value, index);
                                validateFieldsAndSetDisable();
                            }}
                            value={fieldsData.find((fd: any) => fd?.id === `${stepIdx}-${index}`)?.value}
                            onBlur={(e) => {
                                handleBlur(field_title, is_required, e.target.value, index);
                                validateFieldsAndSetDisable();
                            }}
                        />
                        {RenderError(index)}
                    </span>
                ) : field_type === "textarea" ? (
                    <span style={{ display: "flex", position: "relative" }}>
                        <textarea
                            className={styles.customTextarea}
                            placeholder={field_placeholder}
                            key={`${stepIdx}-${index}`}
                            style={{ minHeight: "100px" }}
                            onChange={(e) => {
                                const fieldId = `${stepIdx}-${index}`;
                                handleFields({ id: fieldId, label: field_title, value: e?.target.value || "" });
                                handleBlur(field_title, is_required, e.target.value, index);
                                validateFieldsAndSetDisable();
                            }}
                            value={fieldsData.find((fd: any) => fd?.id === `${stepIdx}-${index}`)?.value}
                            onBlur={(e) => {
                                handleBlur(field_title, is_required, e.target.value, index);
                                validateFieldsAndSetDisable();
                            }}
                        />
                        {RenderError(index)}
                    </span>
                ) : field_type === "dropdown" ? (
                    <span className={styles.customSelectWrapper}>
                        <select
                            className={styles.customSelect}
                            onChange={(e) => {
                                const fieldId = `${stepIdx}-${index}`;
                                handleFields({ id: fieldId, label: field_title, value: e?.target.value || "" });
                                handleBlur(field_title, is_required, e.target.value, index);
                                validateFieldsAndSetDisable();
                            }}
                            value={
                                fieldsData.find((fd: any) => fd?.id === `${stepIdx}-${index}`)?.value ||
                                field.default_value ||
                                ""
                            }
                            onBlur={(e) => {
                                handleBlur(field_title, is_required, e.target.value, index);
                                validateFieldsAndSetDisable();
                            }}
                        >
                            <option value="">{field_placeholder || "Select an option"}</option>
                            {field.dropdown_options?.map((opt, i) => {
                                const val =
                                    typeof opt === "string" ? opt : (opt as any)?.value || (opt as any)?.label || "";
                                const label =
                                    typeof opt === "string" ? opt : (opt as any)?.label || (opt as any)?.value || "";
                                return (
                                    <option key={i} value={val}>
                                        {label}
                                    </option>
                                );
                            })}
                        </select>
                        {RenderError(index)}
                    </span>
                ) : field_type === "file_upload" ? (
                    <span style={{ display: "flex", position: "relative" }}>
                        <FileUploader
                            field={field}
                            handleFields={handleFields}
                            fieldsData={fieldsData}
                            styles={styles}
                            index={index}
                            is_required={is_required}
                            handleBlur={handleBlur}
                            validateFieldsAndSetDisable={validateFieldsAndSetDisable}
                            userShopname={userShopname}
                            stepIdx={stepIdx}
                        />
                        {RenderError(index)}
                    </span>
                ) : null}
            </div>
        );
    });
};

const BundleBuilderBundle = (bundleConfig: BundleBuilderConfigInterface) => {
    return (
        !!bundleConfig && (
            <BundleBuilderPreview
                bundleConfig={{
                    ...bundleConfig,
                    steps: bundleConfig?.steps.map((step: StepsType) => ({
                        ...step,
                        step_conditions: filterDuplicateStepConditions(normalizeStepConditions(step)),
                    })),
                    fixed_boxes: [...(bundleConfig?.fixed_boxes || [])].sort((a, b) => a.itemsCount - b.itemsCount),
                }}
                standAlone={true}
                appConfigContext={
                    {
                        currency: window.kefi_bundles.localization.currency,
                        money_format: window.kefi_bundles.money_format,
                        sft: window.kefi_bundles.sft,
                    } as TStoreContext
                }
                previewType={null}
            />
        )
    );
};

type Props_BundleBuilderPreview = {
    bundleConfig: BundleBuilderConfigInterface;
    standAlone?: boolean;
    appConfigContext: TStoreContext;
    previewType: number | null; // 1 -> mobile, 2 -> desktop, null-> storefront view
    inspectMode?: boolean;
    isTemplate?: boolean;
};

const RenderPrice = ({
    product,
    bundleConfig,
    money_format,
    currency,
    disPrice,
    selectedVariants,
    origPrice,
    // isMobile,
    isBottomBar = false,
}: any) => {
    const getPrice = (type: any, price: any) => {
        const finalPrice = getFinalPrice(type, 0, price);
        return finalPrice <= 0 ? bundleConfig.free_text || "Free" : getPriceLabel(finalPrice, money_format, currency);
    };

    const getNewPriceLabel = () => {
        const discountedPrice = getFinalPrice("none", 0, disPrice);
        const compareAtPrice = getFinalPrice(
            "none",
            0,
            bundleConfig.use_compare_at_price
                ? selectedVariants.reduce((total: any, sv: any) => total + +sv.compareAtPrice, 0)
                : origPrice,
        );

        if (discountedPrice < compareAtPrice) {
            return getPriceLabel(compareAtPrice, money_format, currency);
        }
        if (!product.checked) {
            return null;
        }
        return null;
    };
    return (
        <div
            style={{
                width: isBottomBar ? "" : "100%",
                color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                fontWeight: bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                fontStyle: bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                display: "flex",
                flexDirection: "row",
                justifyContent: isBottomBar ? "flex-end" : "flex-start",
                flexWrap: "wrap",
                alignItems: "baseline",
                gap: 3,
                position: "relative",
            }}
            className={styles.productPriceWrapper}
        >
            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="productPrice">
                <div
                    style={{
                        width: "max-content",
                    }}
                >
                    {product?.isAddon
                        ? getPrice("none", origPrice)
                        : bundleConfig?.discount_type === "percentage"
                          ? getPrice("none", disPrice)
                          : getPrice("none", disPrice)}
                </div>
            </InspectorEditableBlock>
            {(bundleConfig.use_compare_at_price || bundleConfig.discount_type === "percentage") && !product?.isAddon ? (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="productCompareAtPrice">
                    <div
                        style={{
                            textDecoration: "line-through",
                            fontSize: bundleConfig?.bundles_design.product_price_size,
                            color: bundleConfig?.bundles_design.product_price_color,
                            fontWeight: bundleConfig?.bundles_design?.product_price_style?.split(" ")[0],
                            fontStyle: bundleConfig?.bundles_design?.product_price_style?.split(" ")[1],
                            width: "max-content",
                            lineHeight: "normal",
                        }}
                    >
                        {getNewPriceLabel()}
                    </div>
                </InspectorEditableBlock>
            ) : (
                ""
            )}
        </div>
    );
};

const CheckingOutLoader = ({ color = "#303030" }: { color: string }) => {
    return (
        <div className={styles.checkingOutLoader}>
            <div
                style={{
                    height: 130,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 2,
                }}
            >
                <Spinner size={"5vw"} color={color} />
            </div>
        </div>
    );
};

const BundleBuilderBottomSection = () => {
    const [showCheckoutCta, setShowCheckoutCta] = useState<boolean>(false);
    const [isFixed, setIsFixed] = useState<boolean>(false);
    const [footerHeight, setFooterHeight] = useState<number>(0);
    const sentinelRef = useRef<HTMLDivElement>(null);
    const {
        steps,
        setActiveStep,
        activeStep,
        selectedProducts,
        selectedVariants,
        totalPrice,
        isMobile,
        bundleConfig,
        handleRemoveProduct,
        money_format,
        currency,
        expandProductList,
        handleBundleBuilderCheckout,
        setExpandProductList,
        autoFillFreeGift,
        standAlone,
        isNextAllowed,
        disableNextOnFields,
        checkingOut,
        nextErrorMsg,
        totalQuantity,
        normalTotalQuantity,
        tierSuccessMessage,
        actualConfigDiscountType,
        containerRef,
        discountType,
        baseSubtotal,
        showStrikePrice,
        discountedBundleTotal,
        discountValueToShow,
        userShopname,
        isValidBoxSize,
        dispensaryFilteredTotalQty,
        isDispensaryProgressBarEnabled,
    } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    const showProgressBar = bundleConfig?.show_progress_bar && bundleConfig?.tier_discount_basis !== "product_based";

    const totalDailyDose = useMemo(() => {
        let sum = 0;
        selectedVariants?.forEach((v: any) => {
            const dose = parseFloat(v.dosage_daily_dose);
            if (!isNaN(dose)) {
                sum += dose;
            }
        });
        return sum;
    }, [selectedVariants]);

    const bottomFooterRef = useRef<HTMLDivElement>(null);

    // Update footer height whenever it changes
    useEffect(() => {
        if (bottomFooterRef.current) {
            const height = bottomFooterRef.current.offsetHeight;
            if (height !== footerHeight) {
                setFooterHeight(height);
            }
        }
    }, [expandProductList, selectedVariants, totalPrice, isMobile]);

    useEffect(() => {
        if (steps?.length) {
            const isReviewEnabled = !!steps.find((step: ExtendedStepsType) => step?.review_step)?.is_enabled;
            if (!isReviewEnabled && activeStep >= steps.length - 1) {
                setShowCheckoutCta(true);
            } else {
                setShowCheckoutCta(false);
            }
        }
    }, [steps, activeStep]);
    useEffect(() => {
        const footerEl = bottomFooterRef?.current;
        removeFixedBreakingStyles(footerEl);

        if (!standAlone) {
            if (footerEl) footerEl.style.position = "sticky";
            return;
        }

        const handleScroll = () => {
            if (!sentinelRef.current || !containerRef.current) return;
            const sentinelRect = sentinelRef.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();

            // Calculate how much of the container is visible from the bottom
            // The container is "20% visible" when its top is at (viewport height - 20% of container height)
            const visibilityThreshold = window.innerHeight;
            const isContainerVisibleEnough = containerRect.top < visibilityThreshold;

            const shouldBeFixed =
                [
                    "alpino-in.myshopify.com",
                    "dev-store-0124.myshopify.com",
                    "teststore20-2787.myshopify.com",
                    "atelierscents.myshopify.com",
                ].includes(userShopname) ||
                (isContainerVisibleEnough && sentinelRect.bottom > window.innerHeight + 5);

            setIsFixed(shouldBeFixed);
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [bundleConfig.bundle_embed_id, standAlone, footerHeight]);

    return (
        <div ref={sentinelRef} style={{ minHeight: isFixed ? footerHeight : "auto" }}>
            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="bottomSectionBar">
                <div
                    style={{
                        background: bundleConfig?.bundles_design?.total_footer_background_color,
                        position: isFixed ? "fixed" : standAlone ? "relative" : "sticky",
                        bottom: 0,
                        left: isFixed ? 0 : "auto",
                        width: isFixed ? "100%" : standAlone ? "" : "100%",
                        padding: 20,
                        zIndex: 100,
                        paddingTop:
                            !isMobile &&
                            ((showProgressBar &&
                                actualConfigDiscountType === "tier" &&
                                bundleConfig?.discount_options?.length > 0) ||
                                isDispensaryProgressBarEnabled) &&
                            expandProductList
                                ? 80
                                : 20,
                    }}
                    ref={bottomFooterRef}
                >
                    {actualConfigDiscountType === DISCOUNT_TYPES.FIXED_BOXES && (
                        <BoxStatusBar
                            fixedBoxes={bundleConfig?.fixed_boxes || []}
                            upsellMessage={bundleConfig?.fixed_boxes_upsell_message}
                            successMessage={bundleConfig?.fixed_boxes_success_message}
                        />
                    )}
                    <span
                        className={styles.bottomSectionWrapper}
                        style={{
                            flexDirection: isMobile ? "column" : "row",
                            maxWidth: isMobile ? "95%" : "85%",
                            position:
                                !isMobile &&
                                ((actualConfigDiscountType === "tier" && bundleConfig?.discount_options?.length > 0) ||
                                    isDispensaryProgressBarEnabled)
                                    ? "relative"
                                    : undefined,
                        }}
                    >
                        {isMobile && (
                            <div
                                className={styles.floatingButton}
                                style={{
                                    backgroundColor: bundleConfig?.bundles_design?.total_footer_text_color,
                                    color: bundleConfig?.bundles_design?.total_footer_background_color,
                                    border: `2px solid ${bundleConfig?.bundles_design?.total_footer_background_color}`,
                                }}
                                onClick={() =>
                                    setExpandProductList(
                                        (ps: BundleBuilderBundleContextType["expandProductList"]) => !ps,
                                    )
                                }
                            >
                                <span
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        transform: expandProductList ? "rotate(270deg)" : "rotate(90deg)",
                                    }}
                                >
                                    &#x3c;
                                </span>
                                {bundleConfig?.item_added_text
                                    ? bundleConfig?.item_added_text?.replace("{itemCount}", String(totalQuantity))
                                    : `${totalQuantity} item${totalQuantity > 1 ? "s" : ""} Added`}
                            </div>
                        )}
                        {expandProductList && (
                            <>
                                {!isMobile && isDispensaryProgressBarEnabled && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "-66px",
                                            left: "0",
                                            width: "100%",
                                            zIndex: 2,
                                            paddingLeft: "10%",
                                            paddingRight: "10%",
                                            boxSizing: "border-box",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            paddingTop: "20px",
                                        }}
                                    >
                                        <div style={{ width: "100%" }}>
                                            <CapacityProgressBar
                                                selectedProducts={selectedProducts}
                                                bundleConfig={bundleConfig}
                                                mergeTotalCapacity={steps[activeStep]?.merge_total_capacity ?? true}
                                            />
                                        </div>
                                    </div>
                                )}

                                {!isMobile && showProgressBar && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "-66px",
                                            left: "0",
                                            width: "100%",
                                            zIndex: 2,
                                            paddingLeft: "10%",
                                            paddingRight: "10%",
                                            boxSizing: "border-box",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                    >
                                        <div style={{ width: "100%" }}>
                                            <BundleProgressBar
                                                bundleConfig={bundleConfig}
                                                totalPrice={totalPrice}
                                                totalQuantity={normalTotalQuantity}
                                                currency={currency}
                                                money_format={money_format}
                                                tierSuccessMessage={tierSuccessMessage}
                                                actualConfigDiscountType={actualConfigDiscountType}
                                                messagePlacement="top"
                                            />
                                        </div>
                                    </div>
                                )}

                                <div
                                    className={styles.selectedProductsWrapper}
                                    style={{
                                        padding: 10,
                                        ...(isMobile
                                            ? { flexDirection: "column", maxHeight: 300, overflowY: "auto" }
                                            : {
                                                  overflowX: "auto",
                                                  flexGrow: 1,
                                              }),
                                        ...(([
                                            "alpino-in.myshopify.com",
                                            "dev-store-0124.myshopify.com",
                                            "teststore20-2787.myshopify.com",
                                            "atelierscents.myshopify.com",
                                        ].includes(userShopname) ||
                                            bundleConfig?.show_product_grid_view) && { width: "100%" }),
                                    }}
                                >
                                    {bundleConfig?.show_product_grid_view ? (
                                        <div className={styles.gridReviewProductCardBottomSectionParent}>
                                            <GridReviewProductCards
                                                bundleConfig={bundleConfig}
                                                selectedVariants={selectedVariants}
                                                showBrokenQuantity={!!bundleConfig?.show_broken_quantity_in_grid}
                                            />
                                        </div>
                                    ) : [
                                          "alpino-in.myshopify.com",
                                          "dev-store-0124.myshopify.com",
                                          "teststore20-2787.myshopify.com",
                                          "atelierscents.myshopify.com",
                                      ].includes(userShopname) ? (
                                        <SquareReviewProductCardWrapper
                                            bundleConfig={bundleConfig}
                                            selectedVariants={selectedVariants}
                                            handleRemoveProduct={handleRemoveProduct}
                                        />
                                    ) : selectedVariants?.length > 0 ? (
                                        selectedVariants
                                            ?.sort((a: any, b: any) => +a?.page - +b?.page)
                                            .map((sp: any, index: number) => (
                                                <ReviewProductCard
                                                    key={index + sp?.title}
                                                    product={sp}
                                                    index={index}
                                                    handleRemoveProduct={handleRemoveProduct}
                                                    isMobile={isMobile}
                                                    bundleConfig={bundleConfig}
                                                    activeStep={activeStep}
                                                    standAlone={standAlone}
                                                />
                                            ))
                                    ) : (
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="totalBottomBar"
                                        >
                                            <div
                                                className={styles.placeholderItemWrapper}
                                                style={{
                                                    borderColor: bundleConfig?.bundles_design?.total_footer_text_color,
                                                    color: bundleConfig?.bundles_design?.total_footer_text_color,
                                                }}
                                            >
                                                <PlusIcon
                                                    size={20}
                                                    color={bundleConfig?.bundles_design?.total_footer_text_color}
                                                />
                                                <p
                                                    className={styles.emptyCardFooterText}
                                                    style={{
                                                        fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                                        fontWeight:
                                                            bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                                " ",
                                                            )[0],
                                                        fontStyle:
                                                            bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                                " ",
                                                            )[1],
                                                        color: "inherit",
                                                    }}
                                                >
                                                    {bundleConfig?.empty_card_footer_text || "Add Product"}
                                                </p>
                                            </div>
                                        </InspectorEditableBlock>
                                    )}
                                    {/* {isMobile &&
                                        bundleConfig?.review_step?.enable_addon_products &&
                                        !loadingAddons &&
                                        addonProducts.length > 0 && (
                                            <div style={{ margin: "15px 0", width: "100%" }}>
                                                <ReviewAddOnCarousel
                                                    products={addonProducts}
                                                    bundleConfig={bundleConfig}
                                                    money_format={money_format}
                                                    currency={currency}
                                                    onAddProduct={handleAddAddonProduct}
                                                    onProductRemove={handleRemoveAddonProduct}
                                                    standAlone={standAlone}
                                                />
                                            </div>
                                        )}
                                    {loadingAddons && (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                padding: "20px",
                                                width: "100%",
                                            }}
                                        >
                                            <Spinner
                                                size={30}
                                                color={bundleConfig?.bundles_design?.total_footer_text_color}
                                            />
                                        </div>
                                    )} */}
                                </div>
                            </>
                        )}
                        <div
                            className={styles.bottomRightSection}
                            style={{
                                width:
                                    standAlone && isMobile && activeStep > 0
                                        ? "80vw"
                                        : isMobile &&
                                            ((actualConfigDiscountType === "tier" &&
                                                bundleConfig?.discount_options?.length > 0) ||
                                                isDispensaryProgressBarEnabled)
                                          ? "90%"
                                          : "",
                            }}
                        >
                            {isMobile && isDispensaryProgressBarEnabled && (
                                <div
                                    style={{
                                        width: "96%",
                                        minHeight: "32px",
                                        marginTop: "10px",
                                    }}
                                >
                                    <CapacityProgressBar
                                        selectedProducts={selectedProducts}
                                        bundleConfig={bundleConfig}
                                        mergeTotalCapacity={steps[activeStep]?.merge_total_capacity ?? true}
                                    />
                                </div>
                            )}

                            {isMobile && showProgressBar && (
                                <BundleProgressBar
                                    bundleConfig={bundleConfig}
                                    totalPrice={totalPrice}
                                    totalQuantity={normalTotalQuantity}
                                    currency={currency}
                                    money_format={money_format}
                                    tierSuccessMessage={tierSuccessMessage}
                                    actualConfigDiscountType={actualConfigDiscountType}
                                    messagePlacement="top"
                                />
                            )}

                            <div
                                className={styles.totalWrapper}
                                style={{
                                    ...(selectedProducts?.length == 0 && {
                                        display: "none",
                                    }),
                                }}
                            >
                                <InspectorEditableBlock
                                    bundleType={bundleConfig?.bundle_type}
                                    settingKey="totalBottomBar"
                                >
                                    <div
                                        className={styles.totalLabel}
                                        style={{
                                            color: bundleConfig?.bundles_design?.total_footer_text_color,
                                            fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                            fontWeight:
                                                bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[0],
                                            fontStyle:
                                                bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[1],
                                        }}
                                    >
                                        {bundleConfig?.footer_total_text}:
                                    </div>
                                </InspectorEditableBlock>

                                <div className={styles.priceWrapper}>
                                    <InspectorEditableBlock
                                        bundleType={bundleConfig?.bundle_type}
                                        settingKey="totalBottomBarPrice"
                                    >
                                        <span
                                            className={styles.finalPrice}
                                            style={{
                                                color: bundleConfig?.bundles_design?.total_footer_price_color,
                                                fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[1],
                                            }}
                                        >
                                            {getPriceLabel(discountedBundleTotal, money_format, currency)}
                                        </span>
                                    </InspectorEditableBlock>

                                    <InspectorEditableBlock
                                        bundleType={bundleConfig?.bundle_type}
                                        settingKey="totalBottomBarStrikeOffPrice"
                                    >
                                        <span
                                            className={styles.strikeOffPrice}
                                            style={{
                                                display:
                                                    showStrikePrice &&
                                                    !(bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED)
                                                        ? "inline"
                                                        : "none",
                                                fontSize: bundleConfig?.bundles_design.product_price_size,
                                                color: bundleConfig?.bundles_design.total_footer_strike_off_price_color,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.product_price_style?.split(" ")[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.product_price_style?.split(" ")[1],
                                            }}
                                        >
                                            {getPriceLabel(baseSubtotal, money_format, currency)}
                                        </span>
                                    </InspectorEditableBlock>
                                </div>

                                {!(bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED) && (
                                    <InspectorEditableBlock
                                        bundleType={bundleConfig?.bundle_type}
                                        settingKey="totalBottomBarDiscount"
                                    >
                                        <span
                                            className={styles.totalLabel}
                                            style={{
                                                color: bundleConfig?.bundles_design?.total_footer_discount_color,
                                                fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[1],
                                            }}
                                        >
                                            {getDiscountValueWithSign(
                                                discountType,
                                                discountValueToShow,
                                                currency,
                                                money_format,
                                                bundleConfig?.footer_text,
                                                bundleConfig?.free_text,
                                            )}
                                        </span>
                                    </InspectorEditableBlock>
                                )}
                            </div>

                            {!showProgressBar &&
                                !(isDispensaryCoStore && steps.some((step) => step?.enable_capacity_progress_bar)) && (
                                    <div style={{ maxWidth: 300 }}>
                                        <BundleProgressBar
                                            bundleConfig={bundleConfig}
                                            totalPrice={totalPrice}
                                            totalQuantity={normalTotalQuantity}
                                            currency={currency}
                                            money_format={money_format}
                                            tierSuccessMessage={tierSuccessMessage}
                                            actualConfigDiscountType={actualConfigDiscountType}
                                            messagePlacement="top"
                                        />
                                    </div>
                                )}

                            {dispensaryFilteredTotalQty > 0 && isDispensaryCoStore && (
                                <>
                                    {bundleConfig?.show_total_quantity_in_footer !== false && (
                                        <div
                                            className={styles.totalQtyInfo}
                                            style={{
                                                color: bundleConfig?.bundles_design?.total_footer_text_color,
                                                fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[1],
                                                marginRight: "10px",
                                            }}
                                        >
                                            Total Quantity: {dispensaryFilteredTotalQty}
                                        </div>
                                    )}
                                    {totalDailyDose > 0 && (
                                        <div
                                            className={styles.totalQtyInfo}
                                            style={{
                                                color: bundleConfig?.bundles_design?.total_footer_text_color,
                                                fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[1],
                                                marginRight: "10px",
                                            }}
                                        >
                                            Total Daily Dose: {parseFloat(totalDailyDose.toFixed(2))} g
                                        </div>
                                    )}
                                </>
                            )}

                            {!!steps?.length && (
                                <div className={styles.bottomCtasRow}>
                                    {activeStep > 0 && (
                                        <Tooltip text={""} tooltipWrapperStyle={{ width: "100%" }}>
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="previousCta"
                                                wrapWithDiv={true}
                                            >
                                                <button
                                                    onClick={() => {
                                                        sessionStorage.setItem("goToStep", "prev");
                                                        setActiveStep(
                                                            (ps: BundleBuilderBundleContextType["activeStep"]) =>
                                                                ps == 0 ? ps : ps - 1,
                                                        );
                                                    }}
                                                    className={`${styles.bottomCta} ${styles.tertiary}  ${styles.previous} `}
                                                    disabled={activeStep == 0}
                                                    style={{
                                                        background: bundleConfig?.bundles_design?.tertiary_cta_bg_color,
                                                        color: bundleConfig?.bundles_design?.tertiary_cta_text_color,
                                                        border: `1px solid ${bundleConfig?.bundles_design?.tertiary_cta_bg_color}`,
                                                    }}
                                                >
                                                    {bundleConfig?.previous_cta_text}
                                                </button>
                                            </InspectorEditableBlock>
                                        </Tooltip>
                                    )}
                                    {!showCheckoutCta && (
                                        <Tooltip
                                            text={
                                                renderErrorsOnButton(nextErrorMsg, true).map(
                                                    (line: string, idx: number) => <div key={idx}>{line}</div>,
                                                ) as string
                                            }
                                            position={"top"}
                                            tooltipWrapperStyle={{ width: "100%" }}
                                        >
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="nextCta"
                                            >
                                                <button
                                                    style={{
                                                        background:
                                                            bundleConfig?.bundles_design?.secondary_cta_bg_color,
                                                        color: bundleConfig?.bundles_design?.secondary_cta_text_color,
                                                        border: `1px solid ${bundleConfig?.bundles_design?.secondary_cta_bg_color}`,
                                                    }}
                                                    onClick={async () => {
                                                        const currentStep = steps[activeStep];
                                                        // Block next if current step conditions fail
                                                        if (!isNextAllowed(currentStep)) return;

                                                        const isMetalBird = METAL_BIRD_SHOPS.includes(
                                                            userShopname || "",
                                                        );

                                                        if (isMetalBird) {
                                                            // MetalBird auto-advance through all free gift steps
                                                            let nextIndex = activeStep + 1;
                                                            while (nextIndex < steps.length) {
                                                                const stepProducts = selectedProducts.filter(
                                                                    (sp: ProductObj) =>
                                                                        sp.page === nextIndex.toString() &&
                                                                        sp?.selectedVariants?.length > 0,
                                                                );
                                                                // Only auto-fill if nothing has been added yet
                                                                if (stepProducts.length === 0) {
                                                                    await autoFillFreeGift(steps[nextIndex], nextIndex);
                                                                }

                                                                nextIndex++;
                                                            }
                                                            // If last step is a free gift, make sure we move to that step
                                                            const finalStep = Math.min(nextIndex, steps.length - 1);
                                                            // Final navigation after clearing free gift steps
                                                            sessionStorage.setItem("goToStep", "next");
                                                            setActiveStep(finalStep);
                                                            return;
                                                        }

                                                        // Default
                                                        sessionStorage.setItem("goToStep", "next");
                                                        setActiveStep(
                                                            (ps: BundleBuilderBundleContextType["activeStep"]) =>
                                                                ps == steps?.length - 1 ? ps : ps + 1,
                                                        );
                                                    }}
                                                    disabled={
                                                        disableNextOnFields ||
                                                        !isNextAllowed(steps[activeStep]) ||
                                                        activeStep >= steps?.length - 1
                                                    }
                                                    className={`${styles.bottomCta} ${styles.secondary} ${styles.next} `}
                                                >
                                                    {bundleConfig?.next_cta_text}
                                                </button>
                                            </InspectorEditableBlock>
                                        </Tooltip>
                                    )}
                                    {showCheckoutCta && (
                                        <Tooltip
                                            text={
                                                renderErrorsOnButton(nextErrorMsg, true).map(
                                                    (line: string, idx: number) => <div key={idx}>{line}</div>,
                                                ) as string
                                            }
                                            position={"top"}
                                            tooltipWrapperStyle={{ width: "100%" }}
                                        >
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="addToCartCta"
                                            >
                                                <button
                                                    className={styles.bottomCta}
                                                    style={{
                                                        gap: 10,
                                                        minWidth: 175,
                                                        background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                                                        color: bundleConfig?.bundles_design?.add_to_cart_text_color,
                                                        border: `1px solid ${bundleConfig?.bundles_design?.secondary_cta_bg_color}`,
                                                    }}
                                                    onClick={() => {
                                                        if (isNextAllowed(steps[activeStep])) {
                                                            standAlone && handleBundleBuilderCheckout();
                                                        }
                                                    }}
                                                    disabled={
                                                        disableNextOnFields ||
                                                        !isNextAllowed(steps[activeStep]) ||
                                                        selectedProducts?.length == 0 ||
                                                        !isValidBoxSize()
                                                    }
                                                >
                                                    {checkingOut ? (
                                                        <Spinner
                                                            size={18}
                                                            color={bundleConfig?.bundles_design?.add_to_cart_text_color}
                                                        />
                                                    ) : (
                                                        <>
                                                            <span style={{ display: "flex", width: "100%" }}>
                                                                {bundleConfig?.checkout_cta_text}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    transform: "rotate(180deg)",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <LeftArrow color={"white"} size={18} />
                                                            </span>
                                                        </>
                                                    )}
                                                </button>
                                            </InspectorEditableBlock>
                                        </Tooltip>
                                    )}
                                </div>
                            )}
                        </div>
                    </span>
                </div>
            </InspectorEditableBlock>
        </div>
    );
};

const BoxTile = ({ box }: { box: FixedBoxConfig }) => {
    const { money_format, currency, normalTotalQuantity, bundleConfig } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    const isFull = normalTotalQuantity == box?.itemsCount;

    return (
        <div
            className={styles.boxTileCard}
            style={{
                border: isFull
                    ? `2px solid ${bundleConfig?.bundles_design?.fixed_boxes_selected_text_color || "#FFFFFF"}`
                    : `1px solid ${bundleConfig?.bundles_design?.fixed_boxes_text_color || "#000000"}`,
                backgroundColor: isFull
                    ? bundleConfig?.bundles_design?.fixed_boxes_selected_bg_color || "#000000"
                    : bundleConfig?.bundles_design?.fixed_boxes_bg_color || "#FFFFFF",
            }}
        >
            <div
                style={{
                    color: isFull
                        ? bundleConfig?.bundles_design?.fixed_boxes_selected_text_color || "#FFFFFF"
                        : bundleConfig?.bundles_design?.fixed_boxes_text_color || "#000000",
                }}
            >
                <LuPackage size={24} />
            </div>
            <p
                style={{
                    fontSize: (bundleConfig?.bundles_design?.fixed_boxes_text_size + 2 || 14) + "px",
                    fontWeight: "700",
                    color: isFull
                        ? bundleConfig?.bundles_design?.fixed_boxes_selected_text_color || "#FFFFFF"
                        : bundleConfig?.bundles_design?.fixed_boxes_text_color || "#000000",
                    margin: "0",
                    padding: "5px 0px",
                }}
            >
                {box?.boxName}
            </p>
            <span
                style={{
                    fontSize: (bundleConfig?.bundles_design?.fixed_boxes_text_size || 12) + "px",
                    color: isFull
                        ? bundleConfig?.bundles_design?.fixed_boxes_selected_text_color || "#FFFFFF"
                        : bundleConfig?.bundles_design?.fixed_boxes_text_color || "#000000",
                }}
            >
                @ {getPriceLabel(box?.fixedPrice || 0, money_format, currency)}
            </span>
        </div>
    );
};

const BoxTilesWrapper = ({ fixedBoxes }: { fixedBoxes: FixedBoxConfig[] }) => {
    const { actualConfigDiscountType, bundleConfig, isMobile, normalTotalQuantity } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const checkScroll = () => {
        if (scrollContainerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
        }
    };

    useEffect(() => {
        checkScroll();
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener("scroll", checkScroll);
            window.addEventListener("resize", checkScroll);
            return () => {
                container.removeEventListener("scroll", checkScroll);
                window.removeEventListener("resize", checkScroll);
            };
        }
    }, [fixedBoxes, isMobile, actualConfigDiscountType]);

    useEffect(() => {
        if (scrollContainerRef.current) {
            const selectedIdx = (fixedBoxes || []).findIndex((box) => box.itemsCount === normalTotalQuantity);
            if (selectedIdx !== -1) {
                const container = scrollContainerRef.current;
                const tile = container.children[selectedIdx] as HTMLElement;
                if (tile) {
                    const containerRect = container.getBoundingClientRect();
                    const tileRect = tile.getBoundingClientRect();
                    const targetScrollLeft =
                        container.scrollLeft +
                        (tileRect.left - containerRect.left) -
                        container.clientWidth / 2 +
                        tile.clientWidth / 2;
                    container.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
                }
            }
        }
    }, [normalTotalQuantity, fixedBoxes]);

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -120,
                behavior: "smooth",
            });
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 120,
                behavior: "smooth",
            });
        }
    };

    if (actualConfigDiscountType !== DISCOUNT_TYPES.FIXED_BOXES) return null;

    const isOverflowing = canScrollLeft || canScrollRight;

    return (
        <div
            style={{
                position: "relative",
                overflow: "hidden",
                display: "flex",
                justifyContent: isOverflowing ? "flex-start" : "center",
                alignItems: "center",
                width: "100%",
            }}
        >
            {isOverflowing && (
                <span
                    onClick={scrollLeft}
                    className={`${styles.arrowsForSlide} ${styles.leftSlideArrow}`}
                    style={{
                        zIndex: 3,
                        // boxShadow: `${bundleConfig?.bundles_design?.bundle_widget_bg} 3px 0 20px 10px`,
                        backgroundColor: bundleConfig?.bundles_design?.step_circle_color,
                        marginTop: "0px",
                        marginBottom: "10px",
                        marginLeft: "4px",
                    }}
                >
                    <AngleLeftIcon size={12} color={"white"} />
                </span>
            )}
            <div
                onScroll={checkScroll}
                className={styles.boxTilesWrapper}
                ref={scrollContainerRef}
                style={{
                    width: "100%",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    justifyContent: isOverflowing ? "flex-start" : "center",
                }}
            >
                {(fixedBoxes || []).map((box: FixedBoxConfig, idx: number) => (
                    <BoxTile key={idx} box={box} />
                ))}
            </div>
            {isOverflowing && (
                <span
                    onClick={scrollRight}
                    className={`${styles.arrowsForSlide} ${styles.rightSlideArrow}`}
                    style={{
                        zIndex: 3,
                        // boxShadow: `${bundleConfig?.bundles_design?.bundle_widget_bg} -3px 0 20px 10px`,
                        backgroundColor: bundleConfig?.bundles_design?.step_circle_color,
                        marginTop: "0px",
                        marginBottom: "10px",
                        marginRight: "4px",
                    }}
                >
                    <AngleRightIcon size={12} color={"white"} />
                </span>
            )}
        </div>
    );
};

const BoxStatusBar = ({
    fixedBoxes,
    upsellMessage,
    successMessage,
}: {
    fixedBoxes: FixedBoxConfig[];
    upsellMessage?: string;
    successMessage?: string;
}) => {
    const { actualConfigDiscountType, normalTotalQuantity, money_format, currency, bundleConfig } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    if (actualConfigDiscountType !== DISCOUNT_TYPES.FIXED_BOXES) return null;

    if (!fixedBoxes.length) return null;

    const boxSizes = fixedBoxes.map((box) => box.itemsCount);

    const nextBoxIdx = boxSizes.findIndex((size) => size > normalTotalQuantity);

    const isAllBoxesCompleted = nextBoxIdx === -1;
    if (isAllBoxesCompleted) {
        return (
            <div style={{ textAlign: "center" }}>
                <div
                    className={styles.boxStatusBarNew}
                    style={{
                        background: bundleConfig?.bundles_design?.fixed_boxes_bg_color || "#FFFFFF",
                        color: bundleConfig?.bundles_design?.fixed_boxes_text_color || "#000000",
                        fontSize: (bundleConfig?.bundles_design?.fixed_boxes_text_size + 2 || 14) + "px",
                    }}
                >
                    <span>{successMessage || "Box completed!"}</span>
                </div>
            </div>
        );
    }

    const nextBoxObj = fixedBoxes[nextBoxIdx];
    const remainingProducts = nextBoxObj.itemsCount - normalTotalQuantity;

    const upsellMsg = upsellMessage
        ? upsellMessage
              .replace("{noOfRemainingProducts}", remainingProducts.toString())
              .replace("{boxName}", nextBoxObj?.boxName || "")
              .replace(
                  "{price}",
                  String(getPriceLabel(nextBoxObj?.fixedPrice || 0, money_format, currency, false, "string") || ""),
              )
        : "";

    return (
        <div style={{ textAlign: "center" }}>
            <div
                className={styles.boxStatusBarNew}
                style={{
                    background: bundleConfig?.bundles_design?.fixed_boxes_bg_color || "#FFFFFF",
                    color: bundleConfig?.bundles_design?.fixed_boxes_text_color || "#000000",
                    fontSize: (bundleConfig?.bundles_design?.fixed_boxes_text_size + 2 || 14) + "px",
                }}
                dangerouslySetInnerHTML={{ __html: upsellMsg }}
            >
                {/* <span>{upsellMsg}</span> */}
            </div>
        </div>
    );
};

const BundleBuilderRightSection = () => {
    const [showCheckoutCta, setShowCheckoutCta] = useState<boolean>(false);
    const {
        steps,
        setActiveStep,
        activeStep,
        selectedProducts,
        selectedVariants,
        totalPrice,
        isMobile,
        bundleConfig,
        handleRemoveProduct,
        money_format,
        currency,
        expandProductList,
        handleBundleBuilderCheckout,
        standAlone,
        isNextAllowed,
        autoFillFreeGift,
        disableNextOnFields,
        checkingOut,
        nextErrorMsg,
        normalTotalQuantity,
        tierSuccessMessage,
        actualConfigDiscountType,
        discountType,
        baseSubtotal,
        discountedBundleTotal,
        showStrikePrice,
        discountValueToShow,
        userShopname,
        totalQuantity,
        isValidBoxSize,
        isDispensaryProgressBarEnabled,
    } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    useEffect(() => {
        if (steps?.length) {
            const isReviewEnabled = !!steps.find((step: ExtendedStepsType) => step?.review_step)?.is_enabled;
            if (!isReviewEnabled && activeStep >= steps.length - 1) {
                setShowCheckoutCta(true);
            } else {
                setShowCheckoutCta(false);
            }
        }
    }, [steps, activeStep]);

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="bottomSectionBar">
            <div
                style={{
                    background: bundleConfig?.bundles_design?.total_footer_background_color,
                    position: checkForEmbedId(bundleConfig.bundle_embed_id) ? "sticky" : "relative",
                    bottom: 0,
                    width: standAlone ? "" : "100%",
                    zIndex: 3,
                    border: `1px solid ${bundleConfig?.bundles_design?.total_footer_text_color}`,
                    borderRadius: 6,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        color: bundleConfig?.bundles_design?.total_footer_text_color,
                        lineHeight: "normal",
                        margin: 0,
                        paddingBlock: 15,
                        paddingInline: 23,
                        fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                        fontWeight: bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[0],
                        fontStyle: bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[1],
                    }}
                >
                    <span>{bundleConfig?.title}</span>
                    {actualConfigDiscountType === DISCOUNT_TYPES.FIXED_BOXES && <span>{totalQuantity} items</span>}
                </div>

                {actualConfigDiscountType === DISCOUNT_TYPES.FIXED_BOXES && (
                    <>
                        <BoxTilesWrapper fixedBoxes={bundleConfig?.fixed_boxes || []} />
                        <BoxStatusBar
                            fixedBoxes={bundleConfig?.fixed_boxes || []}
                            upsellMessage={bundleConfig?.fixed_boxes_upsell_message}
                            successMessage={bundleConfig?.fixed_boxes_success_message}
                        />
                    </>
                )}

                <hr
                    style={{
                        margin: "0 0 6px 0",
                        padding: 0,
                        backgroundColor: bundleConfig?.bundles_design?.total_footer_text_color,
                    }}
                />

                {selectedVariants?.length == 0 && (
                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="totalBottomBar">
                        <div
                            className={styles.placeholderItemWrapper}
                            style={{
                                borderColor: bundleConfig?.bundles_design?.total_footer_text_color,
                                color: bundleConfig?.bundles_design?.total_footer_text_color,
                                margin: "20px 25px",
                                padding: 10,
                                maxWidth: "unset",
                                minWidth: "unset",
                            }}
                        >
                            <PlusIcon size={20} color={bundleConfig?.bundles_design?.total_footer_text_color} />
                            <p
                                className={styles.emptyCardFooterText}
                                style={{
                                    fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                    fontWeight: bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[0],
                                    fontStyle: bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[1],
                                    color: "inherit",
                                }}
                            >
                                {bundleConfig?.empty_card_footer_text || "Add Product"}
                            </p>
                        </div>
                    </InspectorEditableBlock>
                )}
                <span
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                        padding: "0 14px 14px 14px",
                    }}
                >
                    {expandProductList && !!selectedVariants?.length && (
                        <>
                            <div
                                style={{
                                    padding: 10,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                    overflowY: "auto",
                                    maxHeight: "300px",
                                }}
                                className={styles.rightSectionsProducts}
                            >
                                {bundleConfig?.show_product_grid_view ? (
                                    <GridReviewProductCards
                                        bundleConfig={bundleConfig}
                                        selectedVariants={selectedVariants}
                                        showBrokenQuantity={!!bundleConfig?.show_broken_quantity_in_grid}
                                    />
                                ) : (
                                    selectedVariants
                                        ?.sort((a: any, b: any) => +a?.page - +b?.page)
                                        .map((sp: any, index: number) => (
                                            <ReviewProductCardRight
                                                key={index + sp?.title}
                                                product={sp}
                                                index={index}
                                                handleRemoveProduct={handleRemoveProduct}
                                                isMobile={isMobile}
                                                bundleConfig={bundleConfig}
                                                activeStep={activeStep}
                                                standAlone={standAlone}
                                            />
                                        ))
                                )}
                                {/* {isMobile &&
                                    bundleConfig?.review_step?.enable_addon_products &&
                                    !loadingAddons &&
                                    addonProducts.length > 0 && (
                                        <div style={{ margin: "10px 0" }}>
                                            <ReviewAddOnCarousel
                                                products={addonProducts}
                                                bundleConfig={bundleConfig}
                                                money_format={money_format}
                                                currency={currency}
                                                onAddProduct={handleAddAddonProduct}
                                                onProductRemove={handleRemoveAddonProduct}
                                                standAlone={standAlone}
                                            />
                                        </div>
                                    )}
                                {loadingAddons && (
                                    <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                        <Spinner
                                            size={30}
                                            color={bundleConfig?.bundles_design?.total_footer_text_color}
                                        />
                                    </div>
                                )} */}
                            </div>
                        </>
                    )}
                    <div
                        className={styles.bottomRightSection}
                        style={{
                            width:
                                standAlone && isMobile && activeStep > 0
                                    ? "80vw"
                                    : isMobile &&
                                        actualConfigDiscountType === "tier" &&
                                        bundleConfig?.discount_options?.length > 0
                                      ? "90%"
                                      : "",
                        }}
                    >
                        {isDispensaryProgressBarEnabled && (
                            <div
                                style={{
                                    width: "95%",
                                    minHeight: "32px",
                                    marginTop: "10px",
                                }}
                            >
                                <CapacityProgressBar
                                    selectedProducts={selectedProducts}
                                    bundleConfig={bundleConfig}
                                    mergeTotalCapacity={steps[activeStep]?.merge_total_capacity ?? true}
                                />
                            </div>
                        )}

                        <BundleProgressBar
                            bundleConfig={bundleConfig}
                            totalPrice={totalPrice}
                            totalQuantity={normalTotalQuantity}
                            currency={currency}
                            money_format={money_format}
                            tierSuccessMessage={tierSuccessMessage}
                            actualConfigDiscountType={actualConfigDiscountType}
                            messagePlacement="top"
                        />
                        <div
                            className={styles.totalWrapper}
                            style={{
                                ...(selectedProducts?.length == 0 && {
                                    display: "none",
                                }),
                            }}
                        >
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="totalBottomBar">
                                <div
                                    className={styles.totalLabel}
                                    style={{
                                        color: bundleConfig?.bundles_design?.total_footer_text_color,
                                        fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[0],
                                        fontStyle: bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[1],
                                    }}
                                >
                                    {bundleConfig?.footer_total_text}:{" "}
                                </div>
                            </InspectorEditableBlock>
                            {
                                <div className={styles.priceWrapper}>
                                    <InspectorEditableBlock
                                        bundleType={bundleConfig?.bundle_type}
                                        settingKey="totalBottomBarPrice"
                                    >
                                        <span
                                            className={styles.finalPrice}
                                            style={{
                                                color: bundleConfig?.bundles_design?.total_footer_price_color,
                                                fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.total_footer_text_style?.split(
                                                        " ",
                                                    )[1],
                                            }}
                                        >
                                            {getPriceLabel(discountedBundleTotal, money_format, currency)}
                                        </span>
                                    </InspectorEditableBlock>

                                    <InspectorEditableBlock
                                        bundleType={bundleConfig?.bundle_type}
                                        settingKey="totalBottomBarStrikeOffPrice"
                                    >
                                        <span
                                            className={styles.strikeOffPrice}
                                            style={{
                                                display:
                                                    showStrikePrice &&
                                                    !(bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED)
                                                        ? "inline"
                                                        : "none",
                                                fontSize: bundleConfig?.bundles_design.product_price_size,
                                                color: bundleConfig?.bundles_design.total_footer_strike_off_price_color,
                                                fontWeight:
                                                    bundleConfig?.bundles_design?.product_price_style?.split(" ")[0],
                                                fontStyle:
                                                    bundleConfig?.bundles_design?.product_price_style?.split(" ")[1],
                                            }}
                                        >
                                            {getPriceLabel(baseSubtotal, money_format, currency)}
                                        </span>
                                    </InspectorEditableBlock>
                                </div>
                            }
                            {!(bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED) && (
                                <InspectorEditableBlock
                                    bundleType={bundleConfig?.bundle_type}
                                    settingKey="totalBottomBarDiscount"
                                >
                                    <span
                                        className={styles.totalLabel}
                                        style={{
                                            color: bundleConfig?.bundles_design?.total_footer_discount_color,
                                            fontSize: bundleConfig?.bundles_design?.total_footer_text_size,
                                            fontWeight:
                                                bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[0],
                                            fontStyle:
                                                bundleConfig?.bundles_design?.total_footer_text_style?.split(" ")[1],
                                        }}
                                    >
                                        {getDiscountValueWithSign(
                                            discountType,
                                            discountValueToShow,
                                            currency,
                                            money_format,
                                            bundleConfig?.footer_text,
                                            bundleConfig?.free_text,
                                        )}
                                    </span>
                                </InspectorEditableBlock>
                            )}
                        </div>

                        {!!steps?.length && (
                            <div className={styles.bottomCtasRow}>
                                {activeStep > 0 && (
                                    <Tooltip text={""} tooltipWrapperStyle={{ width: "100%" }}>
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="previousCta"
                                            wrapWithDiv={true}
                                        >
                                            <button
                                                onClick={() => {
                                                    sessionStorage.setItem("goToStep", "prev");
                                                    setActiveStep((ps: BundleBuilderBundleContextType["activeStep"]) =>
                                                        ps == 0 ? ps : ps - 1,
                                                    );
                                                }}
                                                className={`${styles.bottomCta} ${styles.tertiary}  ${styles.previous} `}
                                                disabled={activeStep == 0}
                                                style={{
                                                    background: bundleConfig?.bundles_design?.tertiary_cta_bg_color,
                                                    color: bundleConfig?.bundles_design?.tertiary_cta_text_color,
                                                    border: `1px solid ${bundleConfig?.bundles_design?.tertiary_cta_bg_color}`,
                                                }}
                                            >
                                                {bundleConfig?.previous_cta_text}
                                            </button>
                                        </InspectorEditableBlock>
                                    </Tooltip>
                                )}
                                {!showCheckoutCta && (
                                    <Tooltip
                                        text={
                                            renderErrorsOnButton(nextErrorMsg, true).map(
                                                (line: string, idx: number) => <div key={idx}>{line}</div>,
                                            ) as string
                                        }
                                        position={"top"}
                                        tooltipWrapperStyle={{ width: "100%" }}
                                    >
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="nextCta"
                                        >
                                            <button
                                                style={{
                                                    background: bundleConfig?.bundles_design?.secondary_cta_bg_color,
                                                    color: bundleConfig?.bundles_design?.secondary_cta_text_color,
                                                    border: `1px solid ${bundleConfig?.bundles_design?.secondary_cta_bg_color}`,
                                                }}
                                                onClick={async () => {
                                                    const currentStep = steps[activeStep];
                                                    // Block next if current step conditions fail
                                                    if (!isNextAllowed(currentStep)) return;

                                                    const isMetalBird = METAL_BIRD_SHOPS.includes(userShopname || "");

                                                    // Default
                                                    if (isMetalBird) {
                                                        // MetalBird auto-advance through all free gift steps
                                                        let nextIndex = activeStep + 1;
                                                        while (nextIndex < steps.length) {
                                                            const stepProducts = selectedProducts.filter(
                                                                (sp: ProductObj) =>
                                                                    sp.page === nextIndex.toString() &&
                                                                    sp?.selectedVariants?.length > 0,
                                                            );
                                                            // Only auto-fill if nothing has been added yet
                                                            if (stepProducts.length === 0) {
                                                                await autoFillFreeGift(steps[nextIndex], nextIndex);
                                                            }

                                                            nextIndex++;
                                                        }
                                                        // If last step is a free gift, make sure we move to that step
                                                        const finalStep = Math.min(nextIndex, steps.length - 1);
                                                        // Final navigation after clearing free gift steps
                                                        sessionStorage.setItem("goToStep", "next");
                                                        setActiveStep(finalStep);
                                                        return;
                                                    }

                                                    sessionStorage.setItem("goToStep", "next");
                                                    setActiveStep((ps: BundleBuilderBundleContextType["activeStep"]) =>
                                                        ps == steps?.length - 1 ? ps : ps + 1,
                                                    );
                                                }}
                                                disabled={
                                                    disableNextOnFields ||
                                                    !isNextAllowed(steps[activeStep]) ||
                                                    activeStep >= steps?.length - 1
                                                }
                                                className={`${styles.bottomCta} ${styles.secondary} ${styles.next} `}
                                            >
                                                {bundleConfig?.next_cta_text}
                                            </button>
                                        </InspectorEditableBlock>
                                    </Tooltip>
                                )}
                                {showCheckoutCta && (
                                    <Tooltip
                                        text={
                                            renderErrorsOnButton(nextErrorMsg, true).map(
                                                (line: string, idx: number) => <div key={idx}>{line}</div>,
                                            ) as string
                                        }
                                        position={"top"}
                                        tooltipWrapperStyle={{ width: "100%" }}
                                    >
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="addToCartCta"
                                        >
                                            <button
                                                className={styles.bottomCta}
                                                style={{
                                                    gap: 10,
                                                    minWidth: 175,
                                                    background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                                                    color: bundleConfig?.bundles_design?.add_to_cart_text_color,
                                                    border: `1px solid ${bundleConfig?.bundles_design?.secondary_cta_bg_color}`,
                                                }}
                                                onClick={() => {
                                                    if (isNextAllowed(steps[activeStep])) {
                                                        standAlone && handleBundleBuilderCheckout();
                                                    }
                                                }}
                                                disabled={
                                                    disableNextOnFields ||
                                                    !isNextAllowed(steps[activeStep]) ||
                                                    selectedProducts?.length == 0 ||
                                                    !isValidBoxSize()
                                                }
                                            >
                                                {checkingOut ? (
                                                    <Spinner
                                                        size={18}
                                                        color={bundleConfig?.bundles_design?.add_to_cart_text_color}
                                                    />
                                                ) : (
                                                    <>
                                                        <span style={{ display: "flex", width: "100%" }}>
                                                            {bundleConfig?.checkout_cta_text}
                                                        </span>
                                                        <span
                                                            style={{
                                                                transform: "rotate(180deg)",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <LeftArrow color={"white"} size={18} />
                                                        </span>
                                                    </>
                                                )}
                                            </button>
                                        </InspectorEditableBlock>
                                    </Tooltip>
                                )}
                            </div>
                        )}
                    </div>
                </span>
            </div>
        </InspectorEditableBlock>
    );
};

export const getBoundaries = ({
    bundleConfig,
    steps,
    activeStep,
    selectedProducts,
    addedQuantity,
    activeSubStep,
    productId,
    isExempt,
}: {
    bundleConfig: any;
    steps: any[];
    activeStep: number;
    selectedProducts: any[];
    addedQuantity: number;
    activeSubStep: number;
    productId: string | number;
    isExempt?: boolean;
}) => {
    let max = Infinity;
    let min = 0;

    if (isExempt) {
        return { min, max };
    }

    if (bundleConfig?.limit_max_quantity_per_product) {
        max = Math.min(max, +bundleConfig.max_quantity_per_product);
    }

    // max = Math.min(max, maxBoxSize - (normalTotalQuantity - addedQuantity));

    const step = steps[activeStep];

    if (step?.step_conditions?.length && step?.show_step_conditions) {
        for (const cond of step.step_conditions) {
            const stepTotal = getCurrentPageSelectCount(selectedProducts, activeStep, -1);

            if (cond.basis === "items_count") {
                if (cond.type === "max_products") {
                    max = Math.min(max, cond.limit - (stepTotal - addedQuantity));
                }

                if (cond.type === "exact_products") {
                    max = Math.min(max, cond.limit);
                    min = Math.max(min, cond.limit);
                }
            }
        }
    }
    if (step?.enable_subSteps && step?.subSteps?.[activeSubStep]) {
        const currentSubStepObj = step.subSteps[activeSubStep];

        if (currentSubStepObj) {
            const ssTotal = getCurrentPageSelectCount(selectedProducts, activeStep, activeSubStep);

            // MAX PRODUCTS
            if (currentSubStepObj.subStep_condition_type === "max_products") {
                max = Math.min(max, currentSubStepObj.product_count_limit - (ssTotal - addedQuantity));
            }

            // EXACT PRODUCTS
            if (currentSubStepObj.subStep_condition_type === "exact_products") {
                max = Math.min(max, currentSubStepObj.product_count_limit);
                min = Math.max(min, currentSubStepObj.product_count_limit);
            }
        }
    }

    if (bundleConfig?.allow_conditional_logic && bundleConfig?.product_conditions?.length) {
        for (const cond of bundleConfig.product_conditions ?? []) {
            const match = cond.included_products.find((p: any) => p.id === productId);
            if (match && (cond as any).exact_quantity != null) {
                const exact = (cond as any).exact_quantity;
                max = Math.min(max, exact);
                min = Math.max(min, exact);
            }
        }
    }

    return { min: Math.max(0, min), max: Math.max(0, max) };
};

const ProductCard = ({
    product,
    index,
    setTrackVariant = () => {},
    handleAddProduct = () => {},
    disableCtas = false,
    currentStep,
    is_gift_step = false,
    subStepOverride,
}: {
    product: ProductObj;
    index: number;
    setTrackVariant: any;
    handleAddProduct: any;
    disableCtas?: boolean;
    currentStep: ExtendedStepsType;
    is_gift_step: boolean;
    subStepOverride?: number;
}) => {
    const [disPrice, setDisPrice] = useState(0);
    const [origPrice, setOrigPrice] = useState(0);
    const [actualOrigPrice, setActualOrigPrice] = useState(0); //this contain original price without compare at price
    const [addedQuantity, setAddedQuantity] = useState(0);
    const [localQty, setLocalQty] = useState(addedQuantity?.toString());
    const [customText, setCustomText] = useState("");
    const [dailyDose, setDailyDose] = useState("");
    const [noOfDays, setNoOfDays] = useState("");
    const [dosageDirty, setDosageDirty] = useState(false);

    useEffect(() => {
        setLocalQty(addedQuantity?.toString());
    }, [addedQuantity]);

    const [showVariantName, setShowVariantName] = useState("");
    const [selectedVariants, setSelectedVariants] = useState<Array<VariantsObj>>(
        new Array(product.quantity)
            ?.fill(product?.variants?.find((vv) => vv.availableForSale == true) || product?.variants?.[0])
            ?.map((variant) => ({
                ...variant,
                selling_plan: !product.oneTimePurchase
                    ? product.subscriptions && product?.subscriptions.find((sub) => sub.checked === true)?.id
                    : "",
                copyPrice: variant?.price,
            })),
    );

    const dosageCalculationEnabled = currentStep?.enable_dosage_calculation && isDispensaryCoStore;

    const totalNeeded = useMemo(() => {
        const d = parseFloat(dailyDose);
        const n = parseFloat(noOfDays);
        if (isNaN(d) || isNaN(n)) return 0;
        return d * n;
    }, [dailyDose, noOfDays]);

    const totalCost = useMemo(() => {
        const price = parseFloat(selectedVariants[0]?.price) || 0;
        return Math.floor(totalNeeded) * price;
    }, [totalNeeded, selectedVariants]);

    const dosageResultsRef = useRef<HTMLDivElement>(null);
    const showingResults = totalNeeded > 0 || totalCost > 0;
    const {
        isMobile,
        bundleConfig,
        standAlone,
        selectedProducts,
        setSelectedProducts,
        money_format,
        currency,
        steps,
        activeStep,
        activeSubStep,
        userShopname,
        normalTotalQuantity,
        maxBoxSize,
        anyCardShowingDosageResults,
        setAnyCardShowingDosageResults,
        dosageResultsHeight,
        setDosageResultsHeight,
    } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    useEffect(() => {
        if (dosageCalculationEnabled && showingResults && dosageResultsRef.current) {
            const h = dosageResultsRef?.current?.offsetHeight;
            setAnyCardShowingDosageResults(true);
            setDosageResultsHeight((prev) => Math.max(prev, h));
        }
    }, [showingResults, totalNeeded, totalCost]);

    // Reset when step changes
    useEffect(() => {
        if (dosageCalculationEnabled) {
            setAnyCardShowingDosageResults(false);
            setDosageResultsHeight(0);
        }
    }, [activeStep]);

    const subStepIdx = subStepOverride !== undefined ? subStepOverride : activeSubStep;
    const currentSubStep = steps[activeStep]?.enable_subSteps ? subStepIdx?.toString() : "0";

    const isMaxQuantityReached = () => {
        const vQty = selectedVariants?.[0]?.quantityAvailable;
        const variantStockLimitReached = bundleConfig?.disable_cta_when_stock_reached
            ? typeof vQty === "number"
                ? addedQuantity >= vQty
                : false
            : false;

        if (variantStockLimitReached) return true;

        if (product?.exclude_from_step_conditions) {
            return false; // Exempt products have no limit
        }
        const currentProduct = selectedProducts.find((sp: ProductObj) => sp.id === product.id);
        if (!currentProduct) return false;
        let count = 0;
        if (currentStep?.render_as_variants) {
            count = addedQuantity;
        } else {
            count = currentProduct.selectedVariants?.length || 0;
        }
        const perProductLimitReached = bundleConfig?.limit_max_quantity_per_product
            ? count >= +bundleConfig?.max_quantity_per_product
            : false;

        const boxLimitReached = normalTotalQuantity >= maxBoxSize;

        return perProductLimitReached || boxLimitReached;
    };

    const [quantityInputError, setQuantityInputError] = useState<string>("");

    function validateQuantityInput(value: number): string {
        if (isNaN(value) || value < 0) return "Quantity must be a positive number";
        const { min, max } = getBoundaries({
            bundleConfig,
            steps,
            activeStep,
            selectedProducts,
            addedQuantity,
            activeSubStep: subStepIdx,
            productId: product.id,
            isExempt: product?.exclude_from_step_conditions,
        });
        if (value > max) return `Max ${max} allowed`;
        if (value < min) return `Min ${min} required`;
        return "";
    }
    const updateQuantityUsingToggleFlow = (val: number) => {
        const diff = val - addedQuantity;

        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                handleAddProduct(
                    {
                        ...product,
                        selectedVariants,
                        render_as_variants: currentStep?.render_as_variants,
                        freeGift: is_gift_step,
                    },
                    "inc",
                    null,
                    currentSubStep,
                );
            }
        } else if (diff < 0) {
            for (let i = 0; i < Math.abs(diff); i++) {
                handleAddProduct(
                    {
                        ...product,
                        selectedVariants,
                        render_as_variants: currentStep?.render_as_variants,
                        freeGift: is_gift_step,
                    },
                    "dec",
                    null,
                    currentSubStep,
                );
            }
        }
    };

    useEffect(() => {
        if (
            !steps[activeStep]?.render_as_variants &&
            product?.variants?.length == 1 &&
            product.variants[0].title?.toLowerCase() != product?.title?.toLowerCase()
        ) {
            setShowVariantName(product.variants[0].title || "");
        } else {
            setShowVariantName("");
        }
    }, [product, steps[activeStep]?.render_as_variants]);

    useEffect(() => {
        if (product?.id && selectedProducts?.length > 0) {
            // Only count products from the CURRENT step
            const currentProduct = selectedProducts.find(
                (sp: ProductObj) =>
                    sp.id == product?.id && sp.page === activeStep?.toString() && sp.subStep === currentSubStep,
            );
            if (currentProduct?.id) {
                let qty = 0;
                currentProduct?.selectedVariants?.forEach((v: VariantsObj) => {
                    if (v.id == selectedVariants[0].id) {
                        qty = qty + 1;
                    }
                });
                setAddedQuantity(qty || 0);
            } else {
                setAddedQuantity(0);
            }
        } else {
            setAddedQuantity(0);
        }
    }, [product, selectedProducts, selectedVariants, activeStep, currentSubStep]);

    useEffect(() => {
        if (isLilSweetTreatStore && customText === "" && addedQuantity > 0) {
            const existing = selectedProducts.find(
                (sp) => sp.id === product?.id && sp.page === activeStep?.toString() && sp.subStep === currentSubStep,
            );
            if (existing?.custom_text) {
                setCustomText(existing.custom_text);
            }
        }
    }, [addedQuantity, currentSubStep]);

    useEffect(() => {
        if (dosageCalculationEnabled) {
            const existing = selectedProducts.find(
                (sp) => sp.id === product?.id && sp.page === activeStep?.toString() && sp.subStep === currentSubStep,
            );
            const currentVarAdded = existing?.selectedVariants?.find((v: any) => v.id === selectedVariants[0]?.id);
            if (currentVarAdded) {
                setDailyDose(currentVarAdded.dosage_daily_dose || "");
                setNoOfDays(currentVarAdded.dosage_no_of_days || "");
            } else {
                setDailyDose("");
                setNoOfDays("");
            }
            setDosageDirty(false);
        }
    }, [selectedVariants[0]?.id, dosageCalculationEnabled, currentSubStep, selectedProducts]);

    useEffect(() => {
        if (selectedVariants?.length) {
            let disP = bundleConfig?.apply_discount_on_compare_price
                ? +selectedVariants[0].compareAtPrice * product?.quantity
                : +selectedVariants[0].price * product?.quantity;
            const origP = bundleConfig?.use_compare_at_price
                ? +selectedVariants[0].compareAtPrice * product?.quantity
                : +selectedVariants[0].price * product?.quantity;
            const actualOrigP = +selectedVariants[0].price * product?.quantity;

            const dis = bundleConfig?.discount_value || 0;
            switch (bundleConfig?.discount_type) {
                case "percentage":
                    disP = disP - disP * (dis / 100);
                    break;
                default:
            }
            setDisPrice(Math.round(disP * 100) / 100);
            setOrigPrice(Math.round(origP * 100) / 100);
            setActualOrigPrice(Math.round(actualOrigP * 100) / 100);
        } else {
            setDisPrice(0);
            setOrigPrice(0);
            setActualOrigPrice(0);
        }
    }, [
        product,
        bundleConfig?.discount_type,
        bundleConfig?.discount_value,
        selectedVariants,
        bundleConfig?.apply_discount_on_compare_price,
        bundleConfig?.use_compare_at_price,
    ]);

    useEffect(() => {
        if (product.checked) {
            // Add productIdx to each selectedVariant
            const updatedSelectedVariants = selectedVariants?.map((variant: any) => ({
                ...variant,
                productIdx: index, // Add the product index
            }));
            product.selectedVariants = updatedSelectedVariants; // Assign updated variants to the product

            // Update trackVariant state
            setTrackVariant((prevVariants: any[]) => {
                const updatedVariants = [...prevVariants];
                updatedVariants[index] = updatedSelectedVariants; // Update the specific index with updated variants
                return updatedVariants;
            });

            let totalOriginalPrice = 0;
            let totalDiscountedPrice = 0;

            // Calculate total original price
            updatedSelectedVariants.forEach((variant: any) => {
                if (product.checked) {
                    const variantPrice = +variant?.price;
                    totalOriginalPrice += variantPrice;
                }
            });
            // Apply discount based on bundleConfig after summing the prices
            totalDiscountedPrice = totalOriginalPrice;
            const discountValue = bundleConfig?.discount_value || 0;

            switch (bundleConfig?.discount_type) {
                case "percentage":
                    totalDiscountedPrice = totalOriginalPrice - totalOriginalPrice * (discountValue / 100);
                    break;
                default:
                    break;
            }

            // Set the final calculated prices, rounded to 2 decimal places
            setDisPrice(Math.round(totalDiscountedPrice * 100) / 100);
            setOrigPrice(Math.round(totalOriginalPrice * 100) / 100);
            setActualOrigPrice(Math.round(totalOriginalPrice * 100) / 100);
        }
    }, [
        selectedVariants,
        product,
        bundleConfig,
        index,
        bundleConfig?.use_compare_at_price,
        bundleConfig?.apply_discount_on_compare_price,
    ]);

    const handleProductClick = (e: any) => {
        e?.preventDefault();
        if (bundleConfig?.disable_product_title_link) {
            return;
        }
        if (standAlone && !window.location.pathname.includes(product.handle)) {
            window.open(`https://${window?.location?.host}/products/${product.handle}`, "_blank");
        } else if (!window.location.pathname.includes(product.handle)) {
            window.open(`https://${shopify?.config?.shop}/products/${product.handle}`, "_blank");
        }
    };

    useEffect(() => {
        if (product.subscriptions && product.subscriptions.length > 0 && !product.oneTimePurchase) {
            product.isSubscribed = true;
        }
    }, [product, product.oneTimePurchase]);

    const effectiveMetafield = buildMetafieldFromSwatchOptions({
        product,
        bundleConfig,
    });
    const isProductAvailable = useMemo(() => {
        return product?.variants?.some(
            (vv) => (vv.quantityAvailable && vv.quantityAvailable > 0) || vv.availableForSale,
        );
    }, [product]);

    const isVariantAvailable = useMemo(() => {
        const v = selectedVariants?.[0];
        if (!v) return isProductAvailable;
        if (typeof v.quantityAvailable === "number") {
            return v.quantityAvailable > 0;
        }
        if (v.availableForSale !== undefined) {
            return v.availableForSale;
        }
        return isProductAvailable;
    }, [selectedVariants, isProductAvailable]);

    const [showProductInfoModal, setShowProductInfoModal] = useState(false);
    const isProductInfoModalEnabled =
        bundleConfig?.hide_product_info_modal !== true ||
        [AvailableBundleBuilderTemplates.HOVER_INFO_CARD, AvailableBundleBuilderTemplates.HOVER_ACTION_CARD].includes(
            bundleConfig?.selected_template_bb,
        );

    const renderVariantSelector = (
        <>
            {selectedVariants.map((_: any, i: number) =>
                userShopname === "typsy-beauty.myshopify.com" ? (
                    <Swatches
                        bundlesDesign={bundleConfig?.bundles_design}
                        key={i}
                        variants={product.variants}
                        handleChange={setSelectedVariants}
                        selected={selectedVariants}
                        options={product.options || []}
                        productCardIndex={i}
                        standAlone={standAlone}
                    />
                ) : bundleConfig?.show_swatches && effectiveMetafield ? (
                    <CustomSwatches
                        key={i}
                        variants={product.variants}
                        handleChange={setSelectedVariants}
                        selected={selectedVariants}
                        options={product.options || []}
                        productCardIndex={i}
                        standAlone={standAlone}
                        metafield={effectiveMetafield}
                        bundlesDesign={bundleConfig?.bundles_design}
                        bundleConfig={bundleConfig}
                    />
                ) : (
                    <VariantSelectorV2
                        key={i}
                        variants={product.variants}
                        handleChange={setSelectedVariants}
                        selected={selectedVariants}
                        options={product.options || []}
                        productCardIndex={i}
                        standAlone={standAlone}
                        metafield={effectiveMetafield}
                        bundlesDesign={bundleConfig?.bundles_design}
                        bundleConfig={bundleConfig}
                    />
                ),
            )}
        </>
    );

    const disableQuantitySelectorForPreselectedProducts = () => {
        if (!bundleConfig?.make_pre_selected_compulsory) {
            return false;
        }

        // Filter to find the product instance in the current step and substep
        const matchingProducts = selectedProducts.filter(
            (p: any) => p.id === product.id && p.page === activeStep?.toString() && p.subStep === currentSubStep,
        );

        // Find if any of these matching products are preselected
        const preSelectedProduct = matchingProducts.find((p: any) => p.isPreselected);

        if (!preSelectedProduct) {
            return false;
        }

        const curProductTotalSelectedVariantsLength = preSelectedProduct?.selectedVariants?.length || 0;

        const preselectedProductOriginalQuantity =
            bundleConfig?.pre_selected_products?.find((p: any) => p.id === product.id)?.quantity || 0;

        return curProductTotalSelectedVariantsLength <= preselectedProductOriginalQuantity;
    };

    const renderCustomTextInput = (
        <>
            {(steps[activeStep]?.enable_subSteps
                ? steps[activeStep].subSteps?.[subStepIdx]?.allow_product_custom_text
                : currentStep?.allow_product_custom_text) && (
                <div className={styles.customTextWrapper}>
                    <div
                        style={{
                            color: bundleConfig?.bundles_design?.product_name_color,
                        }}
                        className={styles.customTextLabel}
                    >
                        {(steps[activeStep]?.enable_subSteps
                            ? steps[activeStep].subSteps?.[subStepIdx]?.product_custom_text_label
                            : currentStep?.product_custom_text_label) || "Custom Text"}
                    </div>
                    <input
                        type="text"
                        placeholder={
                            (steps[activeStep]?.enable_subSteps
                                ? steps[activeStep].subSteps?.[subStepIdx]?.product_custom_text_placeholder
                                : currentStep?.product_custom_text_placeholder) || "Custom placeholder text"
                        }
                        value={customText}
                        onChange={(e) => {
                            const newVal = e.target.value;
                            setCustomText(newVal);

                            const allowText = steps[activeStep]?.enable_subSteps
                                ? steps[activeStep].subSteps?.[subStepIdx]?.allow_product_custom_text
                                : steps[activeStep]?.allow_product_custom_text;

                            if (allowText && addedQuantity > 0) {
                                setSelectedProducts((prev: ProductObj[]) =>
                                    prev.map((sp: ProductObj) => {
                                        if (
                                            sp.id === product.id &&
                                            sp.page === activeStep?.toString() &&
                                            sp.subStep === currentSubStep
                                        ) {
                                            return { ...sp, custom_text: newVal };
                                        }
                                        return sp;
                                    }),
                                );
                            }
                        }}
                        className={styles.customTextInput}
                        style={{
                            border: `1px solid ${bundleConfig?.bundles_design?.product_border_color || "#ccc"}`,
                        }}
                    />
                </div>
            )}
        </>
    );

    const qtyButtonsVisibility = bundleConfig?.form_id == "69d766fa913f0b8bded0a429" ? "hidden" : "visible";

    const renderDosageCalculation = (
        <div className={styles.dosageWrapper}>
            <div className={styles.dosageRow}>
                <span className={styles.dosageLabel}>Daily dose (g)</span>
                <input
                    type="number"
                    className={styles.dosageInput}
                    value={dailyDose}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                            setDailyDose(value);
                            if (addedQuantity > 0) setDosageDirty(true);
                        }
                    }}
                    onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    placeholder="e.g. 5"
                />
            </div>
            <div className={styles.dosageRow}>
                <span className={styles.dosageLabel}>Duration of compound prescription (days)</span>
                <input
                    type="number"
                    className={styles.dosageInput}
                    value={noOfDays}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                            setNoOfDays(value);
                            if (addedQuantity > 0) setDosageDirty(true);
                        }
                    }}
                    onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    placeholder="e.g. 30"
                />
            </div>
            {(totalNeeded > 0 || totalCost > 0) && (
                <div className={styles.dosageResultsContainer} ref={dosageResultsRef}>
                    {totalNeeded > 0 && (
                        <div className={styles.dosageResultRow}>
                            <span className={styles.dosageResultLabel}>Total needed</span>
                            <span className={styles.dosageResultValue}>{totalNeeded?.toFixed(2)} g</span>
                        </div>
                    )}
                    {totalCost > 0 && (
                        <div className={styles.dosageResultRow}>
                            <span className={styles.dosageResultLabel}>Cost</span>
                            <span className={styles.dosageResultValue}>
                                {getPriceLabel(totalCost, money_format, currency)}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    const isAddButtonDisabled =
        !isProductAvailable ||
        Math.floor(totalNeeded) <= 0 ||
        (Math.floor(totalNeeded) > 0 ? Math.floor(totalNeeded) : 1) >
            getBoundaries({
                bundleConfig,
                steps,
                activeStep,
                selectedProducts,
                addedQuantity,
                activeSubStep: subStepIdx,
                productId: product.id,
                isExempt: product?.exclude_from_step_conditions,
            }).max ||
        isMaxQuantityReached();

    const renderDispensaryQuantitySelector = (
        <>
            {renderDosageCalculation}
            {addedQuantity > 0 ? (
                <InspectorEditableBlock
                    bundleType={bundleConfig?.bundle_type}
                    settingKey="buyNowCta"
                    wrapWithDiv={true}
                >
                    <button
                        className={styles.bottomCta}
                        style={{
                            minHeight: 40,
                            maxHeight: "fit-content",
                            marginTop: "auto",
                            border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                            background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                            color: bundleConfig?.bundles_design.add_to_cart_text_color,
                            fontSize: bundleConfig?.bundles_design.add_to_cart_text_size,
                            fontWeight: bundleConfig?.bundles_design.add_to_cart_text_style?.split(" ")[0],
                            fontStyle: bundleConfig?.bundles_design.add_to_cart_text_style?.split(" ")[1],
                            wordBreak: "break-word",
                            opacity: isAddButtonDisabled || !dosageDirty ? 0.5 : 1,
                            cursor: isAddButtonDisabled || !dosageDirty ? "not-allowed" : "pointer",
                        }}
                        disabled={isAddButtonDisabled || !dosageDirty}
                        onClick={() => {
                            const newQty = Math.floor(totalNeeded) > 0 ? Math.floor(totalNeeded) : 1;
                            const newVariants = new Array(newQty).fill(selectedVariants[0])?.map((v) => ({
                                ...v,
                                dosage_daily_dose: dailyDose,
                                dosage_no_of_days: noOfDays,
                                dosage_total_needed: totalNeeded,
                            }));
                            const targetVariantId = selectedVariants[0]?.id;
                            setSelectedProducts((prev: any[]) =>
                                prev.map((sp: any) => {
                                    if (
                                        sp.id === product.id &&
                                        sp.page === activeStep?.toString() &&
                                        sp.subStep === currentSubStep
                                    ) {
                                        const otherVariants =
                                            sp.selectedVariants?.filter((v: any) => v.id !== targetVariantId) || [];
                                        return {
                                            ...sp,
                                            selectedVariants: [...otherVariants, ...newVariants],
                                        };
                                    }
                                    return sp;
                                }),
                            );
                            setDosageDirty(false);
                        }}
                    >
                        {`Add ${Math.floor(totalNeeded) > 0 ? Math.floor(totalNeeded) : 1} g`}
                    </button>
                </InspectorEditableBlock>
            ) : (
                <InspectorEditableBlock
                    bundleType={bundleConfig?.bundle_type}
                    settingKey="buyNowCta"
                    wrapWithDiv={true}
                >
                    <button
                        className={styles.bottomCta}
                        style={{
                            minHeight: 40,
                            maxHeight: "fit-content",
                            marginTop: "auto",
                            border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                            background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                            color: bundleConfig?.bundles_design.add_to_cart_text_color,
                            fontSize: bundleConfig?.bundles_design.add_to_cart_text_size,
                            fontWeight: bundleConfig?.bundles_design.add_to_cart_text_style?.split(" ")[0],
                            fontStyle: bundleConfig?.bundles_design.add_to_cart_text_style?.split(" ")[1],
                            wordBreak: "break-word",
                        }}
                        disabled={isAddButtonDisabled || disableCtas}
                        onClick={() => {
                            const productsToAdd = dosageCalculationEnabled
                                ? Math.floor(totalNeeded) > 0
                                    ? Math.floor(totalNeeded)
                                    : 1
                                : 1;
                            const variantsToAdd = new Array(productsToAdd).fill(selectedVariants[0])?.map((v) => ({
                                ...v,
                                dosage_daily_dose: dailyDose,
                                dosage_no_of_days: noOfDays,
                                dosage_total_needed: totalNeeded,
                            }));

                            handleAddProduct(
                                {
                                    ...product,
                                    selectedVariants: dosageCalculationEnabled ? variantsToAdd : selectedVariants,
                                    freeGift: is_gift_step,
                                    render_as_variants: currentStep?.render_as_variants,
                                    custom_text: customText,
                                },
                                "add",
                                null,
                                currentSubStep,
                            );
                            if (dosageCalculationEnabled) {
                                setDosageDirty(false);
                            }
                            setShowProductInfoModal(false);
                        }}
                    >
                        {isProductAvailable
                            ? dosageCalculationEnabled && Math.floor(totalNeeded) > 0
                                ? `Add ${Math.floor(totalNeeded)} g`
                                : bundleConfig?.buy_now_cta_text
                            : bundleConfig?.out_of_stock_text || "Out of stock!"}
                    </button>
                </InspectorEditableBlock>
            )}
            {dosageCalculationEnabled &&
                !(totalNeeded > 0 || totalCost > 0) &&
                anyCardShowingDosageResults &&
                dosageResultsHeight > 0 && (
                    <div style={{ minHeight: dosageResultsHeight, marginTop: 6, width: "100%" }}>&nbsp;</div>
                )}
        </>
    );

    const renderQuantitySelector = (
        <>
            {isLilSweetTreatStore &&
            addedQuantity > 0 &&
            (steps[activeStep]?.enable_subSteps
                ? steps[activeStep].subSteps?.[subStepIdx]?.allow_product_custom_text
                : steps[activeStep]?.allow_product_custom_text) ? (
                renderCustomTextInput
            ) : (
                <></>
            )}
            {dosageCalculationEnabled ? (
                renderDispensaryQuantitySelector
            ) : addedQuantity > 0 ? (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="quantitySelector">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            visibility: qtyButtonsVisibility,
                        }}
                    >
                        <div
                            className={styles.handleQtyWrapper}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                            }}
                        >
                            <button
                                className={styles.bottomCta}
                                style={{
                                    maxHeight: 40,
                                    minWidth: 10,
                                    paddingInline: 10,
                                    fontSize: 20,
                                    fontWeight: 650,
                                    border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                                    background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                                }}
                                onClick={() => {
                                    handleAddProduct(
                                        {
                                            ...product,
                                            selectedVariants,
                                            render_as_variants: currentStep?.render_as_variants,
                                            freeGift: is_gift_step,
                                            custom_text: customText,
                                        },
                                        "dec",
                                        null,
                                        currentSubStep,
                                    );
                                }}
                                disabled={disableQuantitySelectorForPreselectedProducts()}
                            >
                                -
                            </button>
                            <span
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexGrow: 1,
                                    minWidth: "40%",
                                    color: "#212121",
                                    fontSize: bundleConfig?.bundles_design.add_to_cart_text_size,
                                }}
                            >
                                {bundleConfig.allow_quantity_input ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <input
                                            type="text"
                                            min={0}
                                            className={styles.qtyInputBB}
                                            value={localQty}
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                                textAlign: "center",
                                                fontSize: "14px",
                                                border: `1px solid ${quantityInputError ? "red" : "#ccc"}`,
                                                borderRadius: "4px",
                                                outline: "none",
                                                background: "#fff",
                                            }}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                value = value.replace(/\D/g, "");

                                                setLocalQty(value);
                                                if (value === "") {
                                                    setQuantityInputError("Please enter a valid number");
                                                    return;
                                                }

                                                let val = parseInt(value);

                                                if (isNaN(val)) {
                                                    setQuantityInputError("Please enter a valid number");
                                                    return;
                                                }

                                                const { max } = getBoundaries({
                                                    bundleConfig,
                                                    steps,
                                                    activeStep,
                                                    selectedProducts,
                                                    addedQuantity,
                                                    activeSubStep: subStepIdx,
                                                    productId: product.id,
                                                    isExempt: product?.exclude_from_step_conditions,
                                                });

                                                if (val > max) {
                                                    val = max;
                                                    setLocalQty(max.toString());
                                                }

                                                const error = validateQuantityInput(val);
                                                setQuantityInputError(error);

                                                if (!error) {
                                                    updateQuantityUsingToggleFlow(val);
                                                }
                                            }}
                                            onBlur={() => {
                                                let val = parseInt(localQty);

                                                if (isNaN(val)) {
                                                    setLocalQty(addedQuantity.toString());
                                                    setQuantityInputError("");
                                                    return;
                                                }

                                                const { min, max } = getBoundaries({
                                                    bundleConfig,
                                                    steps,
                                                    activeStep,
                                                    selectedProducts,
                                                    addedQuantity,
                                                    activeSubStep: subStepIdx,
                                                    productId: product.id,
                                                    isExempt: product?.exclude_from_step_conditions,
                                                });

                                                if (val < min) {
                                                    val = min;
                                                    setLocalQty(min.toString());
                                                }

                                                if (val > max) {
                                                    val = max;
                                                    setLocalQty(max.toString());
                                                }

                                                const error = validateQuantityInput(val);
                                                setQuantityInputError(error);

                                                if (!error) {
                                                    updateQuantityUsingToggleFlow(val);
                                                }
                                            }}
                                        />
                                    </div>
                                ) : (
                                    addedQuantity
                                )}
                            </span>
                            <button
                                className={styles.bottomCta}
                                style={{
                                    maxHeight: 40,
                                    minWidth: 10,
                                    paddingInline: 10,
                                    fontSize: 16,
                                    fontWeight: 650,
                                    border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                                    background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                                }}
                                disabled={disableCtas || isMaxQuantityReached()}
                                onClick={() => {
                                    handleAddProduct(
                                        {
                                            ...product,
                                            selectedVariants,
                                            render_as_variants: currentStep?.render_as_variants,
                                            freeGift: is_gift_step,
                                            custom_text: customText,
                                        },
                                        "inc",
                                        null,
                                        currentSubStep,
                                    );
                                }}
                            >
                                +
                            </button>
                        </div>
                        {quantityInputError && (
                            <div
                                style={{
                                    color: "red",
                                    fontSize: "11px",
                                    marginTop: "4px",
                                    textAlign: "center",
                                    width: "100%",
                                }}
                            >
                                {quantityInputError}
                            </div>
                        )}
                    </div>
                </InspectorEditableBlock>
            ) : (
                <InspectorEditableBlock
                    bundleType={bundleConfig?.bundle_type}
                    settingKey="buyNowCta"
                    wrapWithDiv={true}
                >
                    <button
                        className={styles.bottomCta}
                        style={{
                            minHeight: 40,
                            maxHeight: "fit-content",
                            marginTop: "auto",
                            border: `1px solid ${bundleConfig?.bundles_design?.add_to_cart_bg_color}`,
                            background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                            color: bundleConfig?.bundles_design.add_to_cart_text_color,
                            fontSize: bundleConfig?.bundles_design.add_to_cart_text_size,
                            fontWeight: bundleConfig?.bundles_design.add_to_cart_text_style?.split(" ")[0],
                            fontStyle: bundleConfig?.bundles_design.add_to_cart_text_style?.split(" ")[1],
                            wordBreak: "break-word",
                        }}
                        disabled={
                            disableCtas ||
                            !isProductAvailable ||
                            (bundleConfig?.disable_cta_when_stock_reached && !isVariantAvailable) ||
                            isMaxQuantityReached()
                        }
                        onClick={() => {
                            handleAddProduct(
                                {
                                    ...product,
                                    selectedVariants,
                                    freeGift: is_gift_step,
                                    render_as_variants: currentStep?.render_as_variants,
                                    custom_text: customText,
                                },
                                "add",
                                null,
                                currentSubStep,
                            );
                            setShowProductInfoModal(false);
                        }}
                    >
                        {isProductAvailable && (!bundleConfig?.disable_cta_when_stock_reached || isVariantAvailable)
                            ? bundleConfig?.buy_now_cta_text
                            : bundleConfig?.out_of_stock_text || "Out of stock!"}
                    </button>
                </InspectorEditableBlock>
            )}
        </>
    );

    const effectiveActualOrigPrice = addedQuantity > 0 ? disPrice : actualOrigPrice;
    const effectiveDisPrice = bundleConfig?.show_product_price_with_compare_price
        ? effectiveActualOrigPrice
        : addedQuantity > 0
          ? disPrice
          : origPrice;

    const renderPriceArea = (
        <>
            {isProductAvailable &&
                (is_gift_step ? (
                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="freePriceTag">
                        <span
                            style={{
                                color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                                fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                                fontWeight: bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                                fontStyle: bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                            }}
                        >
                            Free
                        </span>
                    </InspectorEditableBlock>
                ) : (
                    <RenderPrice
                        product={product}
                        bundleConfig={bundleConfig}
                        money_format={money_format}
                        currency={currency}
                        disPrice={effectiveDisPrice}
                        selectedVariants={selectedVariants}
                        origPrice={origPrice}
                        isMobile={isMobile}
                    />
                ))}
        </>
    );

    const renderPreOrderMetafield = (
        <>
            <div
                style={{
                    fontSize: bundleConfig?.bundles_design.product_name_size - 2 + "px",
                    fontWeight: +bundleConfig?.bundles_design?.product_name_style?.split(" ")[0] - 100,
                    lineHeight: "normal",
                }}
                className={styles.meta3}
            >
                {/* @ts-expect-error shop specific */}
                {product?.metafield3?.value}
            </div>
        </>
    );

    const renderCustomTextMetafield = isLilSweetTreatStore && (
        <div
            style={{
                fontSize: 11,
                fontWeight: 450,
                textAlign: "center",
            }}
            className={styles.meta4}
        >
            {/* @ts-expect-error shop specific */}
            {product?.metafield4?.value}
        </div>
    );

    // used by "04gsde-ui.myshopify.com" shop
    const renderProductDescMetafield = (
        <>
            <div
                style={{
                    fontSize: bundleConfig?.bundles_design.product_name_size - 3 + "px",
                    fontWeight: +bundleConfig?.bundles_design?.product_name_style?.split(" ")[0] - 100,
                    lineHeight: "normal",
                }}
                className={styles.meta5}
            >
                {/* @ts-expect-error shop specific */}
                {product?.metafield5?.value}
            </div>
        </>
    );

    // used by "04gsde-ui.myshopify.com" shop
    const renderWeeklyDosageMetafield = (
        <>
            <div
                style={{
                    fontSize: bundleConfig?.bundles_design.product_name_size - 3 + "px",
                    fontWeight: +bundleConfig?.bundles_design?.product_name_style?.split(" ")[0] - 100,
                    lineHeight: "normal",
                }}
                className={styles.meta6}
            >
                {/* @ts-expect-error shop specific */}
                {product?.metafield6?.value}
            </div>
        </>
    );

    const renderSelectedTemplate = () => {
        switch (bundleConfig?.selected_template_bb) {
            case AvailableBundleBuilderTemplates.BASIC_CARD_INFO:
                return (
                    <InspectorEditableBlock
                        bundleType={bundleConfig?.bundle_type}
                        settingKey="productCard"
                        tagsKey={product.tags?.toString()}
                        productId={getProductId(product.id)}
                    >
                        <div
                            className={styles.productWrapper}
                            style={{
                                border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                borderRadius: bundleConfig?.bundles_design?.border_radius,
                                backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                minWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                                maxWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                            }}
                        >
                            <div className={styles.productInfoRight}>
                                <ProductImageWrapper
                                    product={product}
                                    handleProductClick={() => {
                                        if (!isProductInfoModalEnabled) return;
                                        setShowProductInfoModal(true);
                                    }}
                                    bundleConfig={{
                                        ...bundleConfig,
                                        bundles_design: {
                                            ...bundleConfig?.bundles_design,
                                            product_img_size: bundleConfig?.bundles_design.product_img_size
                                                ? "bb_" + bundleConfig?.bundles_design.product_img_size
                                                : "bb_small",
                                            product_img_border_radius: bundleConfig?.bundles_design?.border_radius,
                                        },
                                    }}
                                    overrideHeight={
                                        isMobile
                                            ? bundleConfig?.bundles_design?.product_custom_img_size_mobile
                                            : bundleConfig?.bundles_design?.product_custom_img_size
                                    }
                                    isMobile={isMobile}
                                    selectedVariants={selectedVariants}
                                    showHoverIcon={isProductInfoModalEnabled}
                                    renderQuantitySelector={renderQuantitySelector}
                                />

                                {showProductInfoModal && (
                                    <ProductInfoModal
                                        product={product}
                                        showProductInfoModal={showProductInfoModal}
                                        onClose={() => setShowProductInfoModal(false)}
                                        renderVariantSelector={renderVariantSelector}
                                        renderQuantitySelector={renderQuantitySelector}
                                        renderPriceArea={renderPriceArea}
                                        selectedVariants={selectedVariants}
                                        bundleConfig={bundleConfig}
                                        standAlone={standAlone}
                                    />
                                )}

                                <div
                                    className={styles.productMetaRight}
                                    style={{
                                        color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                                        fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                                        fontStyle:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                                        gap: isMobile
                                            ? +getPixelsForImage(
                                                  bundleConfig?.bundles_design?.product_img_size,
                                                  "number",
                                              ) /
                                                  10 +
                                              "px"
                                            : "0px",
                                        whiteSpace: "normal" /* Allows text to wrap onto the next line */,
                                        width: "100%",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: bundleConfig?.bundles_design.product_name_size,
                                            color: bundleConfig?.bundles_design?.product_name_color,
                                            fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                                            fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "stretch",
                                            flexDirection: "column",
                                            justifyContent: "stretch",
                                            gap: 10,
                                            cursor: bundleConfig?.disable_product_title_link ? "default" : "pointer",
                                        }}
                                        onClick={handleProductClick}
                                    >
                                        <span
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                gap: 4,
                                                width: "100%",
                                            }}
                                        >
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="productTitle"
                                                wrapWithDiv={true}
                                            >
                                                <div
                                                    className={styles.productTitle}
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 3,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        alignItems: isMobile ? "center" : "flex-start",
                                                        justifyContent: isMobile ? "space-between" : "flex-start",
                                                        gap: isMobile ? 4 : 8,
                                                        textAlign:
                                                            bundleConfig?.bundles_design
                                                                ?.product_card_title_alignment || "left",
                                                        width: "100%",
                                                    }}
                                                    title={
                                                        steps[activeStep]?.render_as_variants
                                                            ? product.parentName
                                                            : product?.title
                                                    }
                                                >
                                                    {steps[activeStep]?.render_as_variants
                                                        ? product.parentName
                                                        : product?.title}
                                                </div>
                                            </InspectorEditableBlock>

                                            {renderPreOrderMetafield}
                                            {renderProductDescMetafield}
                                            {renderWeeklyDosageMetafield}

                                            {showWeightInfo(standAlone) &&
                                                ((selectedVariants[0]?.weight > 0 &&
                                                    selectedVariants[0]?.weight_unit) ||
                                                    // @ts-expect-error shop specific
                                                    product?.metafield2?.value) && (
                                                    <span
                                                        style={{
                                                            display: "flex",
                                                            gap: 2,
                                                            justifyContent: "flex-start",
                                                            alignItems: "flex-start",
                                                            fontSize:
                                                                bundleConfig?.bundles_design.product_name_size -
                                                                2 +
                                                                "px",
                                                            fontWeight:
                                                                +bundleConfig?.bundles_design?.product_name_style?.split(
                                                                    " ",
                                                                )[0] - 100,
                                                            lineHeight: "normal",
                                                        }}
                                                    >
                                                        Weight:{" "}
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "flex-start",
                                                                alignItems: "center",
                                                                flexWrap: "nowrap",
                                                                gap: 2,
                                                            }}
                                                        >
                                                            {
                                                                // @ts-expect-error shop specific
                                                                product?.metafield2?.value ? (
                                                                    // @ts-expect-error shop specific
                                                                    <> {product?.metafield2?.value} </>
                                                                ) : (
                                                                    <>
                                                                        {selectedVariants[0].weight}
                                                                        {getWeightUnit(
                                                                            selectedVariants[0]?.weight_unit || "",
                                                                        )}
                                                                    </>
                                                                )
                                                            }
                                                        </span>
                                                    </span>
                                                )}
                                            {!SPRAY_IT_SHOPS.includes(userShopname || "") &&
                                                (!!steps[activeStep]?.render_as_variants || showVariantName) && (
                                                    <RenderVariantInfo
                                                        product={
                                                            showVariantName
                                                                ? { ...product, title: showVariantName }
                                                                : product
                                                        }
                                                    />
                                                )}
                                        </span>
                                    </div>
                                    {product.variants.length > 1 && bundleConfig?.show_swatches && (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "5px",
                                                width: "100%",
                                            }}
                                        >
                                            {renderVariantSelector}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {product.variants.length > 1 && !bundleConfig?.show_swatches && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "5px",
                                        width: "100%",
                                    }}
                                >
                                    {renderVariantSelector}
                                </div>
                            )}

                            {renderQuantitySelector}
                        </div>
                    </InspectorEditableBlock>
                );

            case AvailableBundleBuilderTemplates.IMG_FOCUS_CARD:
                return (
                    <InspectorEditableBlock
                        bundleType={bundleConfig?.bundle_type}
                        settingKey="productCard"
                        tagsKey={product.tags?.toString()}
                        productId={getProductId(product.id)}
                    >
                        <div
                            className={styles.productWrapper}
                            style={{
                                border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                borderRadius: bundleConfig?.bundles_design?.border_radius,
                                backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                minWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                                maxWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                            }}
                        >
                            <div className={styles.productInfoRight}>
                                <ProductImageWrapper
                                    product={product}
                                    handleProductClick={() => {
                                        if (!isProductInfoModalEnabled) return;
                                        setShowProductInfoModal(true);
                                    }}
                                    bundleConfig={{
                                        ...bundleConfig,
                                        bundles_design: {
                                            ...bundleConfig?.bundles_design,
                                            product_img_size: bundleConfig?.bundles_design.product_img_size
                                                ? "bb_" + bundleConfig?.bundles_design.product_img_size
                                                : "bb_small",
                                            product_img_border_radius: bundleConfig?.bundles_design?.border_radius,
                                        },
                                    }}
                                    overrideHeight={
                                        isMobile
                                            ? bundleConfig?.bundles_design?.product_custom_img_size_mobile
                                            : bundleConfig?.bundles_design?.product_custom_img_size
                                    }
                                    isMobile={isMobile}
                                    selectedVariants={selectedVariants}
                                    showHoverIcon={isProductInfoModalEnabled}
                                    renderQuantitySelector={renderQuantitySelector}
                                />

                                {showProductInfoModal && (
                                    <ProductInfoModal
                                        product={product}
                                        showProductInfoModal={showProductInfoModal}
                                        onClose={() => setShowProductInfoModal(false)}
                                        renderVariantSelector={renderVariantSelector}
                                        renderQuantitySelector={renderQuantitySelector}
                                        renderPriceArea={renderPriceArea}
                                        selectedVariants={selectedVariants}
                                        bundleConfig={bundleConfig}
                                        standAlone={standAlone}
                                    />
                                )}

                                <div
                                    className={styles.productMetaRight}
                                    style={{
                                        color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                                        fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                                        fontStyle:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                                        gap: isMobile
                                            ? +getPixelsForImage(
                                                  bundleConfig?.bundles_design?.product_img_size,
                                                  "number",
                                              ) /
                                                  10 +
                                              "px"
                                            : "0px",
                                        whiteSpace: "normal" /* Allows text to wrap onto the next line */,
                                        width: "100%",

                                        justifyContent: "flex-start",
                                    }}
                                >
                                    {product.variants.length > 1 && bundleConfig?.show_swatches && (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "5px",
                                                width: "100%",
                                            }}
                                        >
                                            {renderVariantSelector}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {product.variants.length > 1 && !bundleConfig?.show_swatches && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "5px",
                                        width: "100%",
                                    }}
                                >
                                    {renderVariantSelector}
                                </div>
                            )}

                            {renderQuantitySelector}
                        </div>
                    </InspectorEditableBlock>
                );

            case AvailableBundleBuilderTemplates.HOVER_ACTION_CARD:
                return (
                    <InspectorEditableBlock
                        bundleType={bundleConfig?.bundle_type}
                        settingKey="productCard"
                        tagsKey={product.tags?.toString()}
                        productId={getProductId(product.id)}
                    >
                        <div
                            className={styles.productWrapper}
                            style={{
                                border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                borderRadius: bundleConfig?.bundles_design?.border_radius,
                                backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                minWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                                maxWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                            }}
                        >
                            <div className={styles.productInfoRight}>
                                <ProductImageWrapper
                                    product={product}
                                    handleProductClick={() => {
                                        if (!isProductInfoModalEnabled) return;
                                        if (bundleConfig?.hide_product_info_modal && product?.variants?.length == 1)
                                            return;
                                        setShowProductInfoModal(true);
                                    }}
                                    bundleConfig={{
                                        ...bundleConfig,
                                        bundles_design: {
                                            ...bundleConfig?.bundles_design,
                                            product_img_size: bundleConfig?.bundles_design.product_img_size
                                                ? "bb_" + bundleConfig?.bundles_design.product_img_size
                                                : "bb_small",
                                            product_img_border_radius: bundleConfig?.bundles_design?.border_radius,
                                        },
                                    }}
                                    overrideHeight={
                                        isMobile
                                            ? bundleConfig?.bundles_design?.product_custom_img_size_mobile
                                            : bundleConfig?.bundles_design?.product_custom_img_size
                                    }
                                    isMobile={isMobile}
                                    selectedVariants={selectedVariants}
                                    showHoverIcon={isProductInfoModalEnabled}
                                    hoverIconType={isProductInfoModalEnabled ? "button" : undefined}
                                    renderQuantitySelector={renderQuantitySelector}
                                />

                                {showProductInfoModal && (
                                    <ProductInfoModal
                                        product={product}
                                        showProductInfoModal={showProductInfoModal}
                                        onClose={() => setShowProductInfoModal(false)}
                                        renderVariantSelector={renderVariantSelector}
                                        renderQuantitySelector={renderQuantitySelector}
                                        renderPriceArea={renderPriceArea}
                                        selectedVariants={selectedVariants}
                                        bundleConfig={bundleConfig}
                                        standAlone={standAlone}
                                    />
                                )}

                                <div
                                    className={styles.productMetaRight}
                                    style={{
                                        color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                                        fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                                        fontStyle:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                                        gap: isMobile
                                            ? +getPixelsForImage(
                                                  bundleConfig?.bundles_design?.product_img_size,
                                                  "number",
                                              ) /
                                                  10 +
                                              "px"
                                            : "0px",
                                        whiteSpace: "normal" /* Allows text to wrap onto the next line */,
                                        width: "100%",

                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: bundleConfig?.bundles_design.product_name_size,
                                            color: bundleConfig?.bundles_design?.product_name_color,
                                            fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                                            fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "stretch",
                                            flexDirection: "column",
                                            justifyContent: "stretch",
                                            gap: 10,
                                            cursor: bundleConfig?.disable_product_title_link ? "default" : "pointer",
                                        }}
                                        onClick={handleProductClick}
                                    >
                                        <span
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                gap: 4,
                                                width: "100%",
                                            }}
                                        >
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="productTitle"
                                                wrapWithDiv={true}
                                            >
                                                <div
                                                    className={styles.productTitle}
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        alignItems: isMobile ? "center" : "flex-start",
                                                        justifyContent: isMobile ? "space-between" : "flex-start",
                                                        gap: isMobile ? 4 : 8,
                                                        textAlign:
                                                            bundleConfig?.bundles_design
                                                                ?.product_card_title_alignment || "left",
                                                        width: "100%",
                                                    }}
                                                    title={
                                                        steps[activeStep]?.render_as_variants
                                                            ? product.parentName
                                                            : product?.title
                                                    }
                                                >
                                                    {steps[activeStep]?.render_as_variants
                                                        ? product.parentName
                                                        : product?.title}
                                                </div>
                                                {renderPreOrderMetafield}
                                            </InspectorEditableBlock>
                                            {(!!steps[activeStep]?.render_as_variants || showVariantName) && (
                                                <RenderVariantInfo
                                                    product={
                                                        showVariantName
                                                            ? { ...product, title: showVariantName }
                                                            : product
                                                    }
                                                />
                                            )}
                                        </span>
                                        {!(
                                            bundleConfig?.hide_prices_product_card &&
                                            bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED
                                        ) && renderPriceArea}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </InspectorEditableBlock>
                );

            case AvailableBundleBuilderTemplates.HOVER_INFO_CARD:
                return (
                    <InspectorEditableBlock
                        bundleType={bundleConfig?.bundle_type}
                        settingKey="productCard"
                        tagsKey={product.tags?.toString()}
                        productId={getProductId(product.id)}
                    >
                        <div
                            className={styles.productWrapper}
                            style={{
                                border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                borderRadius: bundleConfig?.bundles_design?.border_radius,
                                backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                minWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                                maxWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                            }}
                        >
                            <div className={styles.productInfoRight}>
                                <ProductImageWrapper
                                    product={product}
                                    handleProductClick={() => {
                                        if (!isProductInfoModalEnabled) return;
                                        if (bundleConfig?.hide_product_info_modal && product?.variants?.length == 1)
                                            return;
                                        setShowProductInfoModal(true);
                                    }}
                                    bundleConfig={{
                                        ...bundleConfig,
                                        bundles_design: {
                                            ...bundleConfig?.bundles_design,
                                            product_img_size: bundleConfig?.bundles_design.product_img_size
                                                ? "bb_" + bundleConfig?.bundles_design.product_img_size
                                                : "bb_small",
                                            product_img_border_radius: bundleConfig?.bundles_design?.border_radius,
                                        },
                                    }}
                                    overrideHeight={
                                        isMobile
                                            ? bundleConfig?.bundles_design?.product_custom_img_size_mobile
                                            : bundleConfig?.bundles_design?.product_custom_img_size
                                    }
                                    isMobile={isMobile}
                                    selectedVariants={selectedVariants}
                                    showHoverIcon={isProductInfoModalEnabled}
                                    hoverIconType={isProductInfoModalEnabled ? "button" : undefined}
                                    renderQuantitySelector={renderQuantitySelector}
                                />

                                {showProductInfoModal && (
                                    <ProductInfoModal
                                        product={product}
                                        showProductInfoModal={showProductInfoModal}
                                        onClose={() => setShowProductInfoModal(false)}
                                        renderVariantSelector={renderVariantSelector}
                                        renderQuantitySelector={renderQuantitySelector}
                                        renderPriceArea={renderPriceArea}
                                        selectedVariants={selectedVariants}
                                        bundleConfig={bundleConfig}
                                        standAlone={standAlone}
                                    />
                                )}

                                <div
                                    className={styles.productMetaRight}
                                    style={{
                                        color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                                        fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                                        fontStyle:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                                        gap: isMobile
                                            ? +getPixelsForImage(
                                                  bundleConfig?.bundles_design?.product_img_size,
                                                  "number",
                                              ) /
                                                  10 +
                                              "px"
                                            : "0px",
                                        whiteSpace: "normal" /* Allows text to wrap onto the next line */,
                                        width: "100%",

                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: bundleConfig?.bundles_design.product_name_size,
                                            color: bundleConfig?.bundles_design?.product_name_color,
                                            fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                                            fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "stretch",
                                            flexDirection: "column",
                                            justifyContent: "stretch",
                                            gap: 10,
                                            cursor: bundleConfig?.disable_product_title_link ? "default" : "pointer",
                                        }}
                                        onClick={handleProductClick}
                                    >
                                        <span
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                gap: 4,
                                                width: "100%",
                                            }}
                                        >
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="productTitle"
                                                wrapWithDiv={true}
                                            >
                                                <div
                                                    className={styles.productTitle}
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        alignItems: isMobile ? "center" : "flex-start",
                                                        justifyContent: isMobile ? "space-between" : "flex-start",
                                                        gap: isMobile ? 4 : 8,
                                                        textAlign: "center",
                                                        width: "100%",
                                                    }}
                                                    title={
                                                        steps[activeStep]?.render_as_variants
                                                            ? product.parentName
                                                            : product?.title
                                                    }
                                                >
                                                    {steps[activeStep]?.render_as_variants
                                                        ? product.parentName
                                                        : product?.title}
                                                </div>
                                            </InspectorEditableBlock>
                                            {renderPreOrderMetafield}
                                            {renderCustomTextMetafield}

                                            {(!!steps[activeStep]?.render_as_variants || showVariantName) && (
                                                <RenderVariantInfo
                                                    product={
                                                        showVariantName
                                                            ? { ...product, title: showVariantName }
                                                            : product
                                                    }
                                                />
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </InspectorEditableBlock>
                );

            default:
                return (
                    <InspectorEditableBlock
                        bundleType={bundleConfig?.bundle_type}
                        settingKey="productCard"
                        tagsKey={product.tags?.toString()}
                        productId={getProductId(product.id)}
                    >
                        <div
                            className={styles.productWrapper}
                            style={{
                                border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                borderRadius: bundleConfig?.bundles_design?.border_radius,
                                backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                minWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                                maxWidth: isMobile
                                    ? getBBCardWidth(bundleConfig?.product_card_mobile_size || "medium", "mobile")
                                    : getBBCardWidth(bundleConfig?.product_card_desktop_size || "medium", "desktop"),
                            }}
                        >
                            <div className={styles.productInfoRight}>
                                <ProductImageWrapper
                                    product={product}
                                    handleProductClick={() => {
                                        if (!isProductInfoModalEnabled) return;
                                        setShowProductInfoModal(true);
                                    }}
                                    bundleConfig={{
                                        ...bundleConfig,
                                        bundles_design: {
                                            ...bundleConfig?.bundles_design,
                                            product_img_size: bundleConfig?.bundles_design.product_img_size
                                                ? "bb_" + bundleConfig?.bundles_design.product_img_size
                                                : "bb_small",
                                            product_img_border_radius: bundleConfig?.bundles_design?.border_radius,
                                        },
                                    }}
                                    overrideHeight={
                                        isMobile
                                            ? bundleConfig?.bundles_design?.product_custom_img_size_mobile
                                            : bundleConfig?.bundles_design?.product_custom_img_size
                                    }
                                    isMobile={isMobile}
                                    selectedVariants={selectedVariants}
                                    showHoverIcon={isProductInfoModalEnabled}
                                />

                                {showProductInfoModal && (
                                    <ProductInfoModal
                                        product={product}
                                        showProductInfoModal={showProductInfoModal}
                                        onClose={() => setShowProductInfoModal(false)}
                                        renderVariantSelector={renderVariantSelector}
                                        renderQuantitySelector={renderQuantitySelector}
                                        renderPriceArea={renderPriceArea}
                                        selectedVariants={selectedVariants}
                                        bundleConfig={bundleConfig}
                                        standAlone={standAlone}
                                    />
                                )}

                                <div
                                    className={styles.productMetaRight}
                                    style={{
                                        color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                                        fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                                        fontStyle:
                                            bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                                        gap: isMobile
                                            ? +getPixelsForImage(
                                                  bundleConfig?.bundles_design?.product_img_size,
                                                  "number",
                                              ) /
                                                  10 +
                                              "px"
                                            : "0px",
                                        whiteSpace: "normal" /* Allows text to wrap onto the next line */,
                                        width: "100%",

                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: bundleConfig?.bundles_design.product_name_size,
                                            color: bundleConfig?.bundles_design?.product_name_color,
                                            fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                                            fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "stretch",
                                            flexDirection: "column",
                                            justifyContent: "stretch",
                                            gap: 10,
                                            cursor: bundleConfig?.disable_product_title_link ? "default" : "pointer",
                                        }}
                                        onClick={handleProductClick}
                                    >
                                        <span
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                gap: 4,
                                                width: "100%",
                                            }}
                                        >
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="productTitle"
                                                wrapWithDiv={true}
                                            >
                                                <div
                                                    className={styles.productTitle}
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        alignItems: isMobile ? "center" : "flex-start",
                                                        justifyContent: isMobile ? "space-between" : "flex-start",
                                                        gap: isMobile ? 4 : 8,
                                                        textAlign:
                                                            bundleConfig?.bundles_design
                                                                ?.product_card_title_alignment || "left",
                                                        width: "100%",
                                                    }}
                                                    title={
                                                        steps[activeStep]?.render_as_variants
                                                            ? product.parentName
                                                            : product?.title
                                                    }
                                                >
                                                    {steps[activeStep]?.render_as_variants
                                                        ? product.parentName
                                                        : product?.title}
                                                </div>
                                            </InspectorEditableBlock>

                                            {renderPreOrderMetafield}
                                            {renderProductDescMetafield}
                                            {renderWeeklyDosageMetafield}

                                            {showWeightInfo(standAlone) &&
                                                ((selectedVariants[0]?.weight > 0 &&
                                                    selectedVariants[0]?.weight_unit) ||
                                                    // @ts-expect-error shop specific
                                                    product?.metafield2?.value) && (
                                                    <span
                                                        style={{
                                                            display: "flex",
                                                            gap: 2,
                                                            justifyContent: "flex-start",
                                                            alignItems: "flex-start",
                                                            fontSize:
                                                                bundleConfig?.bundles_design.product_name_size -
                                                                2 +
                                                                "px",
                                                            fontWeight:
                                                                +bundleConfig?.bundles_design?.product_name_style?.split(
                                                                    " ",
                                                                )[0] - 100,
                                                            lineHeight: "normal",
                                                        }}
                                                    >
                                                        Weight:{" "}
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "flex-start",
                                                                alignItems: "center",
                                                                flexWrap: "nowrap",
                                                                gap: 2,
                                                            }}
                                                        >
                                                            {
                                                                // @ts-expect-error shop specific
                                                                product?.metafield2?.value ? (
                                                                    // @ts-expect-error shop specific
                                                                    <> {product?.metafield2?.value} </>
                                                                ) : (
                                                                    <>
                                                                        {selectedVariants[0].weight}
                                                                        {getWeightUnit(
                                                                            selectedVariants[0]?.weight_unit || "",
                                                                        )}
                                                                    </>
                                                                )
                                                            }
                                                        </span>
                                                    </span>
                                                )}
                                            {(!!steps[activeStep]?.render_as_variants || showVariantName) && (
                                                <RenderVariantInfo
                                                    product={
                                                        showVariantName
                                                            ? { ...product, title: showVariantName }
                                                            : product
                                                    }
                                                />
                                            )}
                                        </span>
                                        {!(
                                            bundleConfig?.hide_prices_product_card &&
                                            bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED
                                        ) && renderPriceArea}
                                    </div>
                                    {product.variants.length > 1 && bundleConfig?.show_swatches && (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "5px",
                                                width: "100%",
                                            }}
                                        >
                                            {renderVariantSelector}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {product.variants.length > 1 && !bundleConfig?.show_swatches && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "5px",
                                        width: "100%",
                                    }}
                                >
                                    {renderVariantSelector}
                                </div>
                            )}

                            {renderQuantitySelector}
                        </div>
                    </InspectorEditableBlock>
                );
        }
    };

    return renderSelectedTemplate();
};

const OrderSummary = () => {
    const orderSummaryRef = useRef<HTMLDivElement>(null);
    const sentinelRef = useRef<HTMLDivElement>(null);
    const [isFixed, setIsFixed] = useState<boolean>(false);
    const [summaryHeight, setSummaryHeight] = useState<number>(0);
    const {
        setActiveStep,
        selectedProducts,
        isMobile,
        bundleConfig,
        setFieldsData,
        money_format,
        currency,
        handleBundleBuilderCheckout,
        standAlone,
        checkingOut,
        boxQuantity,
        setSelectedProducts,
        discountAmount,
        discountType,
        discountValue,
        baseSubtotal,
        totalAddonPrice,
        addonsDiscountValue,
        discountedBundleTotal,
        showStrikePrice,
        discountValueToShow,
        userShopname,
        containerRef,
    } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    useEffect(() => {
        if (orderSummaryRef.current) {
            const height = orderSummaryRef.current.offsetHeight;
            if (height !== summaryHeight) {
                setSummaryHeight(height);
            }
        }
    }, [selectedProducts, discountedBundleTotal, isMobile]);

    useEffect(() => {
        const orderSummaryDiv = orderSummaryRef?.current;
        removeFixedBreakingStyles(orderSummaryDiv);

        if (!standAlone || !isMobile) {
            if (orderSummaryDiv) orderSummaryDiv.style.position = "sticky";
            return;
        }

        const handleScroll = () => {
            if (!sentinelRef.current || !containerRef.current) return;
            const sentinelRect = sentinelRef.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();

            const visibilityThreshold = window.innerHeight;
            const isContainerVisibleEnough = containerRect.top < visibilityThreshold;

            const shouldBeFixed =
                ["dev-store-0124.myshopify.com"].includes(userShopname) ||
                (isContainerVisibleEnough && sentinelRect.bottom > window.innerHeight + 5);

            setIsFixed(shouldBeFixed);
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [bundleConfig.bundle_embed_id, standAlone, summaryHeight, isMobile]);

    const handleSecondaryButtonCTAClick = () => {
        if (bundleConfig?.secondary_button_type === "start_again") {
            setSelectedProducts([]);
            setFieldsData([]);
            setActiveStep(0);
        } else {
            setActiveStep((ps: number) => ps - 1);
        }
    };

    return (
        <div
            ref={sentinelRef}
            style={{ minHeight: isFixed ? summaryHeight : "auto", width: isMobile ? "100%" : "auto" }}
        >
            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryCard">
                <div
                    className={styles.reviewSectionRight}
                    ref={orderSummaryRef}
                    style={{
                        borderRadius: 10,
                        position: isFixed ? "fixed" : isMobile ? "relative" : "sticky",
                        bottom: isFixed ? 0 : "auto",
                        left: isFixed ? 0 : "auto",
                        width: isFixed ? "100%" : isMobile ? "100%" : "auto",
                        zIndex: 2,
                        padding: "20px 10px",
                        background: bundleConfig?.bundles_design?.order_summary_bg_color,
                        ...(isMobile && {
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                        }),
                        ...(!isFixed &&
                            isMobile && {
                                margin: "auto",
                                left: 0,
                                right: 0,
                            }),
                    }}
                >
                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryTitle">
                        <div
                            className={styles.reviewSectionRightTitle}
                            style={{
                                fontSize: bundleConfig?.bundles_design?.order_summary_header_text_size,
                                color: bundleConfig?.bundles_design?.order_summary_header_text_color,
                                fontWeight:
                                    bundleConfig?.bundles_design?.order_summary_header_text_style?.split(" ")[0] ??
                                    "550",
                                fontStyle:
                                    bundleConfig?.bundles_design?.order_summary_header_text_style?.split(" ")[1] ??
                                    "normal",
                            }}
                        >
                            {bundleConfig?.order_summary_title}
                        </div>
                    </InspectorEditableBlock>
                    <div className={styles.summaryBox}>
                        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryRow">
                            <div
                                className={styles.summaryRow}
                                style={{
                                    fontSize: bundleConfig?.bundles_design?.order_summary_rows_text_size,
                                    color: bundleConfig?.bundles_design?.order_summary_rows_text_color,
                                    fontWeight:
                                        bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(" ")[0] ??
                                        "550",
                                    fontStyle:
                                        bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(" ")[1] ??
                                        "normal",
                                }}
                            >
                                <span className={styles.label}>{bundleConfig?.order_summary_subtotal}</span>
                                <span className={styles.val}>
                                    {bundleConfig?.discount_type == "fixed"
                                        ? getPriceLabel(discountValue * boxQuantity, money_format, currency)
                                        : getPriceLabel(baseSubtotal, money_format, currency)}
                                </span>
                            </div>
                        </InspectorEditableBlock>
                        {showStrikePrice && discountType !== DISCOUNT_TYPES.FIXED && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryRow">
                                <div
                                    className={styles.summaryRow}
                                    style={{
                                        fontSize: bundleConfig?.bundles_design?.order_summary_rows_text_size,
                                        color: bundleConfig?.bundles_design?.order_summary_rows_text_color,
                                        fontWeight:
                                            bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(
                                                " ",
                                            )[0] ?? "550",
                                        fontStyle:
                                            bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(
                                                " ",
                                            )[1] ?? "normal",
                                    }}
                                >
                                    <span className={styles.label}>
                                        {bundleConfig?.order_summary_discount}&nbsp;
                                        {bundleConfig?.discount_type == DISCOUNT_TYPES.PERCENTAGE && (
                                            <>
                                                (
                                                {getDiscountValueWithSign(
                                                    discountType,
                                                    discountValueToShow,
                                                    currency,
                                                    money_format,
                                                    bundleConfig?.footer_text,
                                                    bundleConfig?.free_text,
                                                )}
                                                )
                                            </>
                                        )}
                                    </span>
                                    <span className={styles.val}>
                                        - {getPriceLabel(discountAmount, money_format, currency)}
                                    </span>
                                </div>
                            </InspectorEditableBlock>
                        )}
                        {/* NEW SECTION FOR ADDONS */}
                        {totalAddonPrice > 0 && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryRow">
                                <div
                                    className={styles.summaryRow}
                                    style={{
                                        fontSize: bundleConfig?.bundles_design?.order_summary_rows_text_size,
                                        color: bundleConfig?.bundles_design?.order_summary_rows_text_color,
                                        fontWeight:
                                            bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(
                                                " ",
                                            )[0] ?? "550",
                                        fontStyle:
                                            bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(
                                                " ",
                                            )[1] ?? "normal",
                                    }}
                                >
                                    <span className={styles.label}>
                                        {bundleConfig?.review_step?.addon_products_total_lable}
                                    </span>
                                    <span className={styles.val}>
                                        {getPriceLabel(totalAddonPrice, money_format, currency)}
                                    </span>
                                </div>
                            </InspectorEditableBlock>
                        )}
                        {addonsDiscountValue > 0 && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryRow">
                                <div
                                    className={styles.summaryRow}
                                    style={{
                                        fontSize: bundleConfig?.bundles_design?.order_summary_rows_text_size,
                                        color: bundleConfig?.bundles_design?.order_summary_rows_text_color,
                                        fontWeight:
                                            bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(
                                                " ",
                                            )[0] ?? "550",
                                        fontStyle:
                                            bundleConfig?.bundles_design?.order_summary_rows_text_style?.split(
                                                " ",
                                            )[1] ?? "normal",
                                    }}
                                >
                                    <span className={styles.label}>
                                        {bundleConfig?.review_step?.addon_product_discount_label}
                                        {bundleConfig?.review_step?.discount_type === "percentage" &&
                                            ` (${bundleConfig?.review_step?.discount_value}% Off)`}
                                    </span>
                                    <span className={styles.val}>
                                        - {getPriceLabel(addonsDiscountValue, money_format, currency)}
                                    </span>
                                </div>
                            </InspectorEditableBlock>
                        )}
                        <span className={styles.summaryBoxSeparator}></span>
                        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="orderSummaryTotal">
                            <div
                                className={styles.summaryTotal}
                                style={{
                                    fontSize: bundleConfig?.bundles_design?.order_summary_header_text_size,
                                    color: bundleConfig?.bundles_design?.order_summary_header_text_color,
                                    fontWeight:
                                        bundleConfig?.bundles_design?.order_summary_header_text_style?.split(" ")[0] ??
                                        "550",
                                    fontStyle:
                                        bundleConfig?.bundles_design?.order_summary_header_text_style?.split(" ")[1] ??
                                        "normal",
                                }}
                            >
                                <span>{bundleConfig?.footer_total_text}</span>
                                <span>
                                    {getPriceLabel(
                                        discountedBundleTotal +
                                            (bundleConfig?.review_step?.apply_discount_on_addon_products
                                                ? totalAddonPrice - addonsDiscountValue
                                                : totalAddonPrice),
                                        money_format,
                                        currency,
                                    )}
                                </span>
                            </div>
                        </InspectorEditableBlock>
                    </div>
                    <div>
                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="reviewBottomCta"
                            wrapWithDiv={true}
                        >
                            <button
                                className={styles.bottomCta}
                                style={{
                                    gap: 10,
                                    background: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                                    color: bundleConfig?.bundles_design?.add_to_cart_text_color,
                                    border: `1px solid ${bundleConfig?.bundles_design?.secondary_cta_bg_color}`,
                                }}
                                disabled={selectedProducts?.length == 0}
                                onClick={() => {
                                    standAlone && handleBundleBuilderCheckout();
                                }}
                            >
                                {checkingOut ? (
                                    <Spinner size={18} color={bundleConfig?.bundles_design?.add_to_cart_text_color} />
                                ) : (
                                    <>
                                        <span
                                            className={styles.checkoutCtaText}
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            {bundleConfig?.checkout_cta_text}
                                        </span>
                                        <span
                                            style={{
                                                transform: "rotate(180deg)",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <LeftArrow color={"white"} size={18} />
                                        </span>
                                    </>
                                )}
                            </button>
                        </InspectorEditableBlock>
                        {isMobile && (
                            <InspectorEditableBlock
                                bundleType={bundleConfig?.bundle_type}
                                settingKey="reviewEditBundleCta"
                                wrapWithDiv={true}
                            >
                                <button
                                    className={styles.editBundle}
                                    onClick={handleSecondaryButtonCTAClick}
                                    style={{
                                        position: "relative",
                                        background: bundleConfig?.bundles_design?.edit_bundle_cta_bg_color,
                                        color: bundleConfig?.bundles_design?.edit_bundle_cta_text_color,
                                        border: `1px solid ${bundleConfig?.bundles_design?.edit_bundle_cta_bg_color}`,
                                        fontSize: bundleConfig?.bundles_design?.edit_bundle_cta_size,
                                        fontWeight:
                                            bundleConfig?.bundles_design?.edit_bundle_cta_style?.split(" ")[0] ?? "550",
                                        fontStyle:
                                            bundleConfig?.bundles_design?.edit_bundle_cta_style?.split(" ")[1] ??
                                            "normal",
                                        marginTop: 10,
                                        left: 0,
                                        right: 0,
                                        width: "100%",
                                    }}
                                >
                                    <LeftArrow color={bundleConfig?.bundles_design?.edit_bundle_cta_text_color} />
                                    {bundleConfig?.secondary_button_type === "start_again"
                                        ? bundleConfig?.start_again_cta_text
                                        : bundleConfig?.edit_cta_text}
                                </button>
                            </InspectorEditableBlock>
                        )}
                    </div>
                </div>
            </InspectorEditableBlock>
        </div>
    );
};

const SquareReviewProductCardWrapper = ({
    bundleConfig,
    selectedVariants = [],
    handleRemoveProduct,
}: {
    bundleConfig: any;
    selectedVariants: any[];
    handleRemoveProduct: (product: any) => void;
}) => {
    const { previewType } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);
    const totalRequiredCount = useMemo(() => {
        let count = 0;

        bundleConfig?.steps?.forEach((step: any) => {
            const condition = step?.show_step_conditions
                ? step?.step_conditions?.find(
                      (c: any) =>
                          c.basis === "items_count" && (c.type === "exact_products" || c.type === "min_products"),
                  )
                : 0;
            count += Number(condition?.limit) || 0;
        });

        return count;
    }, [bundleConfig]);

    const groupedSelected = useMemo(() => {
        const groups: { [key: string]: any } = {};

        selectedVariants.forEach((v: any) => {
            const key = `${v.id}-${v.page}-${v.subStep}`;
            const q = v.qty || v.quantity || 1;
            if (groups[key]) {
                groups[key].qty = (groups[key].qty || 0) + q;
            } else {
                groups[key] = { ...v, qty: q };
            }
        });

        return Object.values(groups).sort((a: any, b: any) => +a?.page - +b?.page);
    }, [selectedVariants]);

    const totalSelectedQuantity = useMemo(() => {
        return groupedSelected.reduce((total, v) => total + (v.qty || 1), 0);
    }, [groupedSelected]);

    const totalSlots = Math.max(
        1,
        Math.max(totalRequiredCount - (totalSelectedQuantity - groupedSelected.length), groupedSelected.length),
    );

    return (
        <div
            className={styles.squareReviewProductCardWrapper}
            style={{ ...(previewType == 1 && { flexDirection: "column" }) }}
        >
            {totalRequiredCount > 0 && (
                <div className={styles.selectionLabel}>
                    {totalSelectedQuantity}/{totalRequiredCount} Selected
                </div>
            )}

            <div
                className={styles.squareReviewProductCard}
                style={{ ...(previewType == 1 && { width: "90%", justifyContent: "flex-start" }) }}
            >
                {Array.from({ length: totalSlots }).map((_, index) => {
                    const product = groupedSelected[index];

                    if (product) {
                        return (
                            <SquareReviewProductCard
                                key={index + product?.title}
                                product={product}
                                index={index}
                                handleRemoveProduct={handleRemoveProduct}
                                bundleConfig={bundleConfig}
                            />
                        );
                    }

                    return (
                        <div key={index} className={styles.squareSlot}>
                            <PlusIcon size={16} color={bundleConfig?.bundles_design?.total_footer_text_color} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const SquareReviewProductCard = ({
    product,
    index,
    handleRemoveProduct,
    bundleConfig,
}: {
    product: ProductObj;
    index: number;
    handleRemoveProduct: any;
    bundleConfig: BundleBuilderConfigInterface;
}) => {
    const { selectedProducts, steps, activeStep, activeSubStep } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    // const origPrice = bundleConfig?.use_compare_at_price
    //     ? +(product.selectedVariants?.[0]?.compareAtPrice || 0) * (product?.quantity || 1)
    //     : +(product.selectedVariants?.[0]?.price || 0) * (product?.quantity || 1);

    const hideCrossIcon = () => {
        if (!bundleConfig?.make_pre_selected_compulsory) {
            return false;
        }
        if (!product?.isPreselected) {
            return false;
        }

        const isCurProductInFinalList = selectedProducts.find(
            (p: any) =>
                p.id === product.parentProduct &&
                p.page === product.page?.toString() &&
                p.subStep === product.subStep?.toString(),
        );

        if (!isCurProductInFinalList) {
            return false;
        }

        const curProductTotalSelectedVariants = isCurProductInFinalList?.selectedVariants || [];
        const preselectedProductOriginalQuantity =
            bundleConfig?.pre_selected_products?.find((p: any) => p.id === product.parentProduct)?.quantity || 0;

        return curProductTotalSelectedVariants.length <= preselectedProductOriginalQuantity;
    };

    const currentSubStep = steps[activeStep]?.enable_subSteps ? activeSubStep : 0;

    return (
        <div
            className={`${styles.squareProductCard} ${product.freeGift ? styles.dashedBorder : ""}`}
            key={"sp" + index}
        >
            {product.freeGift && (
                <div className={styles.giftTagSquare}>
                    <span className={styles.freeLabel}>Free</span>
                    {/* <span className={styles.originalPrice}>{getPriceLabel(origPrice, money_format, currency)}</span> */}
                </div>
            )}
            <img
                src={product.selectedVariants?.[0]?.image?.originalSrc || product.images?.[0]?.originalSrc}
                alt={product.title}
            />
            {
                // @ts-expect-error hack
                product.qty > 1 && <div className={styles.qtyBadgeSquare}>x{product.qty}</div>
            }
            {!hideCrossIcon() &&
                "page" in product &&
                activeStep == +(product?.page || 0) &&
                (!steps[activeStep]?.enable_subSteps ||
                    bundleConfig?.substep_layout === "sequential" ||
                    currentSubStep == +(product?.subStep || 0)) && (
                    <div
                        className={styles.removeIconSquare}
                        onClick={() => {
                            handleRemoveProduct(product.parentProduct, product.id, product?.subStep);
                        }}
                    >
                        <CloseIcon size={9} />
                    </div>
                )}
        </div>
    );
};

// renders selected products in the review area as a card grid instead of the default product bars.
// showBrokenQuantity: true shows one card per unit (duplicated cards); false groups duplicates behind a qty badge.
const GridReviewProductCards = ({
    bundleConfig,
    selectedVariants = [],
    showBrokenQuantity = true,
}: {
    bundleConfig: BundleBuilderConfigInterface;
    selectedVariants: any[];
    showBrokenQuantity?: boolean;
}) => {
    const { steps, activeStep, activeSubStep, handleAddProduct } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    const gridCards = useMemo(() => {
        if (!showBrokenQuantity) {
            return [...selectedVariants].sort((a, b) => +a?.page - +b?.page);
        }

        const cards: any[] = [];
        selectedVariants.forEach((v: any) => {
            const qty = v.qty || v.quantity || 1;
            for (let i = 0; i < qty; i++) {
                cards.push(v);
            }
        });
        return cards.sort((a, b) => +a?.page - +b?.page);
    }, [selectedVariants, showBrokenQuantity]);

    const currentSubStep = steps[activeStep]?.enable_subSteps ? activeSubStep : 0;

    return (
        <div className={styles.gridReviewProductCard}>
            {gridCards.map((product, index) => {
                const canRemove =
                    "page" in product &&
                    activeStep == +(product?.page || 0) &&
                    (!steps[activeStep]?.enable_subSteps ||
                        bundleConfig?.substep_layout === "sequential" ||
                        currentSubStep == +(product?.subStep || 0));

                return (
                    <div
                        className={`${styles.gridProductCard} ${product.freeGift ? styles.gridDashedBorder : ""}`}
                        key={`${product.id}-${index}`}
                    >
                        {product.freeGift && (
                            <div className={styles.gridGiftTag}>
                                <span className={styles.gridFreeLabel}>Free</span>
                            </div>
                        )}
                        <img
                            src={product.selectedVariants?.[0]?.image?.originalSrc || product.images?.[0]?.originalSrc}
                            alt={product.title}
                        />
                        {!showBrokenQuantity && product.qty > 1 && (
                            <div className={styles.gridQtyBadge}>x{product.qty}</div>
                        )}
                        {canRemove && (
                            <div
                                className={styles.gridRemoveIcon}
                                onClick={() => {
                                    handleAddProduct(
                                        {
                                            id: product.parentProduct,
                                            selectedVariants: [{ id: product.id }],
                                        },
                                        "dec",
                                        product?.page ?? null,
                                        product?.subStep ?? null,
                                    );
                                }}
                            >
                                <CloseIcon size={9} />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

// shop-specific: shows selected items as a duplicated-per-quantity grid inside a shopping-bag shape
const BagReviewGrid = ({
    bundleConfig,
    selectedVariants = [],
}: {
    bundleConfig: BundleBuilderConfigInterface;
    selectedVariants: any[];
}) => {
    const { steps, activeStep, activeSubStep, handleAddProduct, isMobile } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    const gridCards = useMemo(() => {
        const cards: any[] = [];
        selectedVariants.forEach((v: any) => {
            const qty = v.qty || v.quantity || 1;
            for (let i = 0; i < qty; i++) {
                cards.push(v);
            }
        });
        return cards.sort((a, b) => +a?.page - +b?.page);
    }, [selectedVariants]);

    const currentSubStep = steps[activeStep]?.enable_subSteps ? activeSubStep : 0;
    const emptySlotsCount = Math.max(0, 9 - gridCards.length);

    // the bag outline (svg) and the product grid (plain HTML overlay) both live inside .bagStage,
    // which is locked to the svg viewBox's own aspect ratio - so the overlay can be positioned
    // with plain percentages and always lines up with the drawn bag shape at any wrapper size.
    // The grid used to live inside the svg's <foreignObject>, but Safari clips/crops
    // foreignObject content when its host svg is scaled via viewBox rather than sized 1:1.
    return (
        <div className={styles.bagWrapper} style={{ margin: isMobile ? "25px auto" : "0 auto" }}>
            <div className={styles.bagStage}>
                <svg className={styles.bagSvg} viewBox="52 49 196 246" aria-hidden="true">
                    <path
                        d="M110 114 C110 40 190 40 190 114"
                        fill="none"
                        stroke={"#000"}
                        strokeWidth={14}
                        strokeLinecap="round"
                    />
                    <path
                        d="M92 110 L208 110 Q224 110 226 126 L244 272 Q246 290 228 290 L72 290 Q54 290 56 272 L74 126 Q76 110 92 110 Z"
                        fill="#ffffff"
                        stroke={"#000"}
                        strokeWidth={8}
                        strokeLinejoin="round"
                    />
                </svg>
                <div className={styles.bagGridOverlay}>
                    <div className={styles.bagGrid}>
                        {gridCards.map((product, index) => {
                            const canRemove =
                                "page" in product &&
                                activeStep == +(product?.page || 0) &&
                                (!steps[activeStep]?.enable_subSteps ||
                                    bundleConfig?.substep_layout === "sequential" ||
                                    currentSubStep == +(product?.subStep || 0));

                            return (
                                <div className={styles.bagGridCell} key={`${product.id}-${index}`}>
                                    <img
                                        src={
                                            product.selectedVariants?.[0]?.image?.originalSrc ||
                                            product.images?.[0]?.originalSrc
                                        }
                                        alt={product.title}
                                    />
                                    {canRemove && (
                                        <div
                                            className={styles.bagRemoveIcon}
                                            onClick={() => {
                                                handleAddProduct(
                                                    {
                                                        id: product.parentProduct,
                                                        selectedVariants: [{ id: product.id }],
                                                    },
                                                    "dec",
                                                    product?.page ?? null,
                                                    product?.subStep ?? null,
                                                );
                                            }}
                                        >
                                            <CloseIcon size={9} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                        {Array.from({ length: emptySlotsCount }).map((_, i) => (
                            <div className={styles.bagGridEmptyCell} key={`bag-empty-${i}`} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

// shop-specific: dedicated preview-wrapper layout for CUSTOM_CLICK_TO_ADD_GRID_SHOPS, isolated from the
// shared layout below so it can diverge for these shops without risking a regression for every other shop
const BagGridShopBundlePreview = ({
    bundleConfig,
    isTemplate,
    loadingProducts,
    listProducts,
    sequentialSubStepProducts,
    searchQuery,
    setSearchQuery,
    searchActive,
    setSearchActive,
    subStepDropdownOpen,
    setSubStepDropdownOpen,
    pageInfo,
    loadMoreTriggerRef,
    filteredListProducts,
    disableCtas,
    filterByQuery,
    handleSecondaryButtonCTAClick,
    setBoxQuantity,
    fieldsData,
    handleFields,
    setDisableNextOnFields,
}: {
    bundleConfig: BundleBuilderConfigInterface;
    isTemplate: boolean;
    loadingProducts: boolean;
    listProducts: ProductObj[];
    sequentialSubStepProducts: { [subStepIdx: number]: ProductObj[] };
    searchQuery: string;
    setSearchQuery: Dispatch<SetStateAction<string>>;
    searchActive: boolean;
    setSearchActive: Dispatch<SetStateAction<boolean>>;
    subStepDropdownOpen: boolean;
    setSubStepDropdownOpen: Dispatch<SetStateAction<boolean>>;
    pageInfo: any;
    loadMoreTriggerRef: any;
    filteredListProducts: ProductObj[];
    disableCtas: (step: ExtendedStepsType, aSS: number) => boolean;
    filterByQuery: (product: ProductObj) => boolean;
    handleSecondaryButtonCTAClick: () => void;
    setBoxQuantity: Dispatch<SetStateAction<number>>;
    fieldsData: { id: string; label: string; value: string }[];
    handleFields: any;
    setDisableNextOnFields: Dispatch<SetStateAction<boolean>>;
}) => {
    // everything else this layout needs (steps, activeStep, selectedProducts, handleAddProduct, boxQuantity, ...)
    // comes straight from the provider wrapping this component, instead of being threaded through as props
    const {
        bundleConfig: updatedBundleConfig, // context's "bundleConfig" key actually holds updatedBundleConfig
        standAlone,
        isMobile,
        steps,
        activeStep,
        activeSubStep,
        containerRef,
        checkingOut,
        selectedProducts,
        selectedVariants,
        userShopname,
        productListRef,
        handleAddProduct,
        boxQuantity,
        money_format,
        currency,
        addonProducts,
        loadingAddons,
        handleAddAddonProduct,
        handleRemoveAddonProduct,
    } = useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    // shared by both product grids below (sequential-substep and flat-list) so the card props/fallbacks
    // (disableCtas basis, subStepOverride) don't have to be duplicated at each call site
    const renderProductGridCard = (product: ProductObj, index: number, subStepIdxOverride?: number) => (
        <ProductCard
            key={product?.id + product?.variants[0]?.id}
            index={index}
            product={product}
            setTrackVariant={() => {}}
            handleAddProduct={handleAddProduct}
            is_gift_step={steps[activeStep]?.step_content_type === "free_gift"}
            disableCtas={
                product?.exclude_from_step_conditions
                    ? false
                    : disableCtas(steps[activeStep], subStepIdxOverride ?? activeSubStep)
            }
            currentStep={steps[activeStep]}
            subStepOverride={subStepIdxOverride}
        />
    );

    // centers the spinner in place of the grid while products are loading, on both product grids below
    const productGridLoadingStyle = loadingProducts
        ? { display: "flex" as const, justifyContent: "center" as const, alignItems: "center" as const }
        : undefined;

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="bundlePreviewWrapper">
            <div
                id="bundleBuilderPreviewWrapper"
                ref={containerRef}
                data-form-id={bundleConfig.form_id}
                className={`${styles.bundleBuilderPagesWrapper} ${styles.bagGridShopRoot}`}
                style={{
                    fontFamily:
                        bundleConfig?.bundles_design?.bundle_widget_font_family == "Custom Store Font"
                            ? "inherit"
                            : bundleConfig?.bundles_design?.bundle_widget_font_family,
                    ...(standAlone && { paddingTop: isMobile ? "1rem" : "20px", minHeight: "60vh" }),
                    padding: isMobile ? "18px" : "20px 40px",
                    background: bundleConfig?.bundles_design?.bundle_widget_bg,
                    marginBottom:
                        standAlone && +bundleConfig?.bundles_design?.bb_margin_bottom
                            ? bundleConfig?.bundles_design?.bb_margin_bottom
                            : 10,
                    marginTop:
                        standAlone && bundleConfig?.bundles_design?.bb_margin_top
                            ? bundleConfig?.bundles_design?.bb_margin_top
                            : 0,
                    ...(checkingOut && { pointerEvents: "none" }),
                    ...(loadingProducts && { height: "100vh", overflow: "hidden" }),
                }}
            >
                {!!bundleConfig?.top_html && (
                    <div
                        className={styles.bagGridShopTopHtml}
                        dangerouslySetInnerHTML={{ __html: bundleConfig.top_html }}
                    />
                )}

                {bundleConfig?.discount_type === DISCOUNT_TYPES.FIXED_BOXES &&
                    !(bundleConfig?.footer_layout === "right" && !isMobile) && (
                        <BoxTilesWrapper fixedBoxes={bundleConfig?.fixed_boxes || []} />
                    )}
                {checkingOut && <CheckingOutLoader color={"#fff"} />}
                {steps?.length && !bundleConfig?.hide_bundle_header && <StepsHeaderBar />}
                {/* Data Wrapper Starts */}

                {!steps[activeStep]?.review_step ? (
                    <>
                        {steps[activeStep]?.step_content_type !== "fields" ? (
                            <div
                                className={styles.bagGridShopStepLayout}
                                style={{
                                    ...(bundleConfig?.footer_layout === "right" && !isMobile
                                        ? {
                                              display: "grid",
                                              gridTemplateColumns: "4fr 1.2fr",
                                          }
                                        : {
                                              display: "flex",
                                              flexDirection: "row",
                                          }),
                                }}
                            >
                                <div
                                    className={styles.bagGridShopColumnsGrid}
                                    style={{
                                        ...(isMobile
                                            ? {
                                                  display: "grid",
                                                  gridTemplateColumns: "1fr",
                                                  width: "100%",
                                              }
                                            : {
                                                  display: "grid",
                                                  gridTemplateColumns: "2fr 1.2fr",
                                              }),
                                    }}
                                >
                                    <div className={styles.bagGridShopMainColumn}>
                                        <PageTitleSubtitleWrapper />

                                        {bundleConfig?.show_search_bar &&
                                            (!!listProducts?.length ||
                                                !!Object.keys(sequentialSubStepProducts)?.length) && (
                                                <div
                                                    className={styles.searchWrapper}
                                                    style={{
                                                        justifyContent: isMobile
                                                            ? (bundleConfig?.search_bar_alignment_mobile ?? "center")
                                                            : (bundleConfig?.search_bar_alignment_desktop ??
                                                              "flex-end"),
                                                        width: isMobile ? "90%" : "85%",
                                                    }}
                                                >
                                                    <div
                                                        className={`${styles.searchWrapperInput} ${
                                                            searchActive && styles.active
                                                        }`}
                                                    >
                                                        <input
                                                            className={styles.bagGridShopSearchInput}
                                                            value={searchQuery}
                                                            onFocus={() => setSearchActive(true)}
                                                            placeholder={"Search Products"}
                                                            onBlur={() => setSearchActive(false)}
                                                            onChange={(e) => setSearchQuery(e.target.value)}
                                                        />
                                                        <SearchIcon color={searchActive ? "black" : "#bdbdbd"} />
                                                    </div>
                                                </div>
                                            )}

                                        {steps[activeStep]?.enable_subSteps &&
                                            bundleConfig?.substep_layout !== "sequential" && (
                                                <>
                                                    {isMobile ? (
                                                        bundleConfig?.bundles_design?.mobile_substep_header_layout ===
                                                            "tabs" ||
                                                        bundleConfig?.bundles_design?.mobile_substep_header_layout ===
                                                            "scrollable_tabs" ? (
                                                            <RenderSubStepBadges />
                                                        ) : (
                                                            <RenderSubStepDropdown
                                                                subStepDropdownOpen={subStepDropdownOpen}
                                                                setSubStepDropdownOpen={setSubStepDropdownOpen}
                                                            />
                                                        )
                                                    ) : (
                                                        <RenderSubStepBadges />
                                                    )}
                                                </>
                                            )}

                                        {bundleConfig?.substep_layout === "sequential" &&
                                        steps[activeStep]?.enable_subSteps ? (
                                            <div className={styles.bagGridShopSequentialWrapper}>
                                                {steps[activeStep]?.subSteps?.map((subStep, subStepIdx) => {
                                                    if (subStep?.hidden) return null;
                                                    let subStepProducts = sequentialSubStepProducts[subStepIdx] || [];
                                                    if (
                                                        bundleConfig?.allow_conditional_logic &&
                                                        bundleConfig?.product_conditions?.length
                                                    ) {
                                                        subStepProducts = applyConditionsBB(
                                                            bundleConfig.product_conditions,
                                                            selectedProducts,
                                                            subStepProducts,
                                                        );
                                                    }
                                                    const baseProducts = flatProductAsVariants(
                                                        subStepProducts,
                                                        !!steps[activeStep]?.render_as_variants,
                                                    );
                                                    const filteredSubStepProducts =
                                                        bundleConfig?.hide_out_of_stock_products
                                                            ? baseProducts
                                                                  .filter(filterByQuery)
                                                                  ?.filter(filterInStockProducts)
                                                            : baseProducts.filter(filterByQuery);

                                                    return (
                                                        <div
                                                            key={subStepIdx}
                                                            className={styles.bagGridShopSubstepBlock}
                                                        >
                                                            {/* Substep Title Header */}
                                                            <div
                                                                className={styles.bagGridShopSubstepTitle}
                                                                style={{
                                                                    color:
                                                                        bundleConfig?.bundles_design
                                                                            ?.step_page_title_color || "#333",
                                                                    borderBottom: `2px solid ${bundleConfig?.bundles_design?.product_border_color || "rgba(0, 0, 0, 0.1)"}`,
                                                                }}
                                                            >
                                                                <span className={styles.bagGridShopSubstepTitleLabel}>
                                                                    {subStep.step_label}
                                                                </span>
                                                            </div>

                                                            <div
                                                                className={styles.bagGridShopProductGrid}
                                                                style={productGridLoadingStyle}
                                                            >
                                                                {loadingProducts ? (
                                                                    <Spinner
                                                                        size={"5vw"}
                                                                        color={
                                                                            bundleConfig?.bundles_design
                                                                                ?.add_to_cart_bg_color
                                                                        }
                                                                    />
                                                                ) : filteredSubStepProducts.length ? (
                                                                    filteredSubStepProducts.map((product, index) =>
                                                                        renderProductGridCard(
                                                                            product,
                                                                            index,
                                                                            subStepIdx,
                                                                        ),
                                                                    )
                                                                ) : (
                                                                    <div className={styles.productsEmpty}>
                                                                        No Products Available
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div
                                                ref={productListRef}
                                                className={`${styles.bagGridShopProductGrid} ${styles.bagGridShopProductGridPadded}`}
                                                style={productGridLoadingStyle}
                                            >
                                                {loadingProducts ? (
                                                    <Spinner
                                                        size={"5vw"}
                                                        color={bundleConfig?.bundles_design?.add_to_cart_bg_color}
                                                    />
                                                ) : filteredListProducts?.length ? (
                                                    filteredListProducts?.map((product, index) =>
                                                        renderProductGridCard(product, index),
                                                    )
                                                ) : (
                                                    <div className={styles.productsEmpty}>
                                                        {standAlone
                                                            ? "No Products Available"
                                                            : "Configure Steps to See Preview"}
                                                    </div>
                                                )}

                                                {listProducts.length > 0 && pageInfo?.hasNextPage && (
                                                    <span
                                                        ref={loadMoreTriggerRef}
                                                        className={styles.bagGridShopLoadMoreTrigger}
                                                    ></span>
                                                )}
                                            </div>
                                        )}

                                        {!!steps?.[activeStep]?.bottom_subtitle && (
                                            <InspectorEditableBlock
                                                bundleType={bundleConfig?.bundle_type}
                                                settingKey="stepSubTitle"
                                            >
                                                <div
                                                    className={styles.bottomSubtitle}
                                                    style={{
                                                        marginBottom: "6px",
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: steps?.[activeStep]?.bottom_subtitle,
                                                    }}
                                                ></div>
                                            </InspectorEditableBlock>
                                        )}
                                    </div>

                                    <BagReviewGrid bundleConfig={bundleConfig} selectedVariants={selectedVariants} />
                                </div>

                                {!isMobile && bundleConfig?.footer_layout == "right" && (
                                    <div className={styles.rightSectionBB}>
                                        <BundleBuilderRightSection />
                                    </div>
                                )}
                            </div>
                        ) : steps[activeStep]?.step_content_type == "fields" && steps[activeStep]?.fields?.length ? (
                            <div
                                ref={productListRef}
                                className={styles.bagGridShopFieldsWrapper}
                                style={{
                                    ...(bundleConfig?.footer_layout === "right" &&
                                        !isMobile && {
                                            display: "grid",
                                            gridTemplateColumns: "4fr 1.2fr",
                                            gap: "40px",
                                            alignItems: "start",
                                            position: "relative",
                                        }),
                                }}
                            >
                                <div
                                    className={`${styles.fieldsWrapper}`}
                                    style={{
                                        width: isMobile ? "auto" : "57vw",
                                        maxWidth: isMobile ? "auto" : "57vw",
                                    }}
                                >
                                    <PageTitleSubtitleWrapper />
                                    <div
                                        className={styles.bagGridShopFieldsInner}
                                        style={{ maxWidth: isMobile ? "100%" : 500 }}
                                    >
                                        <RenderFields
                                            fields={steps[activeStep].fields}
                                            bundleConfig={updatedBundleConfig}
                                            handleFields={handleFields}
                                            fieldsData={fieldsData}
                                            setDisableNextOnFields={setDisableNextOnFields}
                                            userShopname={userShopname || ""}
                                            stepIdx={activeStep}
                                        />
                                    </div>
                                </div>

                                {!isMobile && bundleConfig?.footer_layout == "right" && (
                                    <div className={styles.rightSectionBB}>
                                        <BundleBuilderRightSection />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <></>
                        )}
                    </>
                ) : (
                    // Review Step Starts
                    <div
                        className={`${styles.reviewBundleWrapper}`}
                        style={{
                            width: isMobile ? "100%" : "min-content",
                        }}
                    >
                        <div
                            className={`${styles.reviewBundleHeader}`}
                            style={{
                                ...(isMobile && { width: "91%", marginInline: "auto" }),
                            }}
                        >
                            <div
                                className={styles.reviewPageTitle}
                                style={{
                                    minHeight: "20px",
                                    ...(selectedProducts.length == 0 && { width: "57vw", marginInline: "auto" }),
                                }}
                            >
                                {!isMobile && (
                                    <button
                                        className={styles.editBundle}
                                        onClick={handleSecondaryButtonCTAClick}
                                        style={{
                                            background: bundleConfig?.bundles_design?.edit_bundle_cta_bg_color,
                                            color: bundleConfig?.bundles_design?.edit_bundle_cta_text_color,
                                            border: `1px solid ${bundleConfig?.bundles_design?.edit_bundle_cta_bg_color}`,
                                            fontSize: bundleConfig?.bundles_design?.edit_bundle_cta_size,
                                            fontWeight:
                                                bundleConfig?.bundles_design?.edit_bundle_cta_style?.split(" ")[0] ??
                                                "550",
                                            fontStyle:
                                                bundleConfig?.bundles_design?.edit_bundle_cta_style?.split(" ")[1] ??
                                                "normal",
                                        }}
                                    >
                                        <LeftArrow color={bundleConfig?.bundles_design?.edit_bundle_cta_text_color} />{" "}
                                        {bundleConfig?.secondary_button_type === "start_again"
                                            ? bundleConfig?.start_again_cta_text
                                            : bundleConfig?.edit_cta_text}
                                    </button>
                                )}
                                <InspectorEditableBlock
                                    bundleType={bundleConfig?.bundle_type}
                                    settingKey="reviewStepPageTitle"
                                >
                                    <span
                                        className={styles.bagGridShopReviewTitleText}
                                        style={{
                                            width: isMobile ? "80%" : "100%",
                                            alignItems: isMobile ? "baseline" : "center",
                                            fontSize: bundleConfig?.bundles_design?.step_page_title_size,
                                            color: bundleConfig?.bundles_design?.step_page_title_color,
                                            fontWeight:
                                                bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[0] ??
                                                "550",
                                            fontStyle:
                                                bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[1] ??
                                                "normal",
                                        }}
                                    >
                                        {bundleConfig?.review_step?.page_title}
                                    </span>
                                </InspectorEditableBlock>
                            </div>
                        </div>
                        {selectedProducts?.length ? (
                            <div
                                className={styles.reviewSection}
                                style={{
                                    margin: "0 auto",
                                    flexDirection: isMobile ? "column" : "row",
                                    width: isMobile ? "auto" : "max-content",
                                    gap: isMobile ? 30 : 20,
                                    minHeight: isMobile ? "" : "55vh",
                                }}
                            >
                                <div
                                    className={styles.reviewSectionLeft}
                                    style={{
                                        border: isMobile ? "none" : "1px solid rgba(0, 0, 0, 0.1)",
                                        gap: isMobile ? 15 : 10,
                                        maxHeight: isMobile ? "55vh" : "",
                                        padding: isMobile ? "10px" : "20px 25px",
                                        paddingBottom: isMobile ? 90 : 10,
                                        minHeight: "auto",
                                    }}
                                >
                                    <div
                                        className={styles.reviewTitleWrapper}
                                        style={{
                                            ...(isMobile && {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "baseline",
                                            }),
                                        }}
                                    >
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="bundleReadyText"
                                        >
                                            <div
                                                className={styles.reviewSectionLeftTitle}
                                                style={{
                                                    fontSize: bundleConfig?.bundles_design?.bundle_title_size,
                                                    color: bundleConfig?.bundles_design?.bundle_title_color,
                                                    fontWeight:
                                                        bundleConfig?.bundles_design?.bundle_title_style?.split(
                                                            " ",
                                                        )[0] ?? "550",
                                                    fontStyle:
                                                        bundleConfig?.bundles_design?.bundle_title_style?.split(
                                                            " ",
                                                        )[1] ?? "normal",
                                                }}
                                            >
                                                <span
                                                    className={styles.bagGridShopBundleReadyText}
                                                    dangerouslySetInnerHTML={{
                                                        __html: bundleConfig?.bundle_ready_text?.replace(
                                                            "{title}",
                                                            bundleConfig?.title,
                                                        ) as string,
                                                    }}
                                                ></span>
                                            </div>
                                        </InspectorEditableBlock>
                                        <span className={styles.bagGridShopQuantityActions}>
                                            <div className={styles.quantityContainer}>
                                                <button
                                                    className={`${styles.quantityButton} ${styles.bagGridShopQtyButton}`}
                                                    onClick={(e) => {
                                                        e?.stopPropagation();
                                                        setBoxQuantity((ps) => (ps <= 1 ? 1 : ps - 1));
                                                    }}
                                                >
                                                    <span className={styles.bagGridShopQtyMinusLabel}>-</span>
                                                </button>
                                                <div className={styles.quantity}>{boxQuantity}</div>
                                                <button
                                                    className={`${styles.quantityButton} ${styles.bagGridShopQtyButton}`}
                                                    onClick={(e) => {
                                                        e?.stopPropagation();
                                                        setBoxQuantity((ps) => ps + 1);
                                                    }}
                                                >
                                                    <span className={styles.bagGridShopQtyPlusLabel}>+</span>
                                                </button>
                                            </div>
                                        </span>
                                    </div>
                                    {!!selectedVariants?.length &&
                                        selectedVariants
                                            .sort((a, b) => a?.freeGift - b?.freeGift)
                                            .map((sp, index) => (
                                                <ReviewProductCard
                                                    key={index + sp?.title}
                                                    product={sp}
                                                    index={index}
                                                    handleRemoveProduct={() => {}}
                                                    isMobile={isMobile}
                                                    bundleConfig={updatedBundleConfig}
                                                    isReviewPage={true}
                                                    money_format={money_format}
                                                    currency={currency}
                                                    activeStep={activeStep}
                                                    freeGift={!!sp?.freeGift}
                                                    standAlone={standAlone}
                                                />
                                            ))}

                                    {isMobile &&
                                        bundleConfig?.review_step?.enable_addon_products &&
                                        !loadingAddons &&
                                        addonProducts.length > 0 && (
                                            <ReviewAddOnCarousel
                                                products={addonProducts}
                                                selectedProducts={selectedProducts}
                                                bundleConfig={updatedBundleConfig}
                                                money_format={money_format}
                                                currency={currency}
                                                onAddProduct={handleAddAddonProduct}
                                                onProductRemove={handleRemoveAddonProduct}
                                                standAlone={standAlone}
                                            />
                                        )}
                                    {loadingAddons && (
                                        <div className={styles.bagGridShopAddonsLoading}>
                                            <Spinner
                                                size={40}
                                                color={bundleConfig?.bundles_design?.add_to_cart_bg_color}
                                            />
                                        </div>
                                    )}
                                </div>
                                {isMobile ? (
                                    <OrderSummary />
                                ) : (
                                    <div className={styles.bagGridShopDesktopOrderSummary}>
                                        <OrderSummary />
                                        {bundleConfig?.review_step?.enable_addon_products &&
                                            !loadingAddons &&
                                            addonProducts.length > 0 && (
                                                <ReviewAddOnCarousel
                                                    products={addonProducts}
                                                    selectedProducts={selectedProducts}
                                                    bundleConfig={updatedBundleConfig}
                                                    money_format={money_format}
                                                    currency={currency}
                                                    onAddProduct={handleAddAddonProduct}
                                                    onProductRemove={handleRemoveAddonProduct}
                                                    standAlone={standAlone}
                                                />
                                            )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className={styles.bagGridShopNoProductsSelected}>
                                {bundleConfig.no_products_selected_text || "No Product(s) Selected"}
                            </div>
                        )}
                    </div>
                    // Review Step Ends
                )}
                {/* Data Wrapper Ends */}
                {!steps[activeStep]?.review_step &&
                    (isTemplate ? selectedProducts?.length > 0 : selectedProducts?.length >= 0) &&
                    !loadingProducts &&
                    (bundleConfig?.footer_layout != "right" || isMobile) && <BundleBuilderBottomSection />}
            </div>
        </InspectorEditableBlock>
    );
};

const ReviewProductCard = ({
    product,
    isMobile,
    bundleConfig,
    index,
    handleRemoveProduct = () => {},
    isReviewPage = false,
    money_format = "",
    currency = "",
    activeStep,
    freeGift = false,
}: {
    product: ProductObj;
    isMobile: boolean;
    bundleConfig: BundleBuilderConfigInterface;
    index: number;
    handleRemoveProduct: any;
    isReviewPage?: boolean;
    money_format?: any;
    currency?: any;
    activeStep: number;
    freeGift?: boolean;
    standAlone?: boolean;
}) => {
    const { selectedProducts, steps, activeSubStep, userShopname } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    const [disPrice, setDisPrice] = useState(0);
    const [origPrice, setOrigPrice] = useState(0);
    useEffect(() => {
        if (product?.selectedVariants?.length && !freeGift) {
            let disP = bundleConfig?.apply_discount_on_compare_price
                ? +product.selectedVariants[0].compareAtPrice * product?.quantity
                : +product.selectedVariants[0].price * product?.quantity;
            const origP = bundleConfig?.use_compare_at_price
                ? +product.selectedVariants[0].compareAtPrice * product?.quantity
                : +product.selectedVariants[0].price * product?.quantity;

            const dis = bundleConfig?.discount_value || 0;
            switch (bundleConfig?.discount_type) {
                case "percentage":
                    disP = disP - disP * (dis / 100);
                    break;
                default:
            }
            setDisPrice(Math.round(disP * 100) / 100);
            setOrigPrice(Math.round(origP * 100) / 100);
        } else {
            setDisPrice(0);
            setOrigPrice(0);
        }
    }, [
        product,
        bundleConfig?.discount_type,
        bundleConfig?.discount_value,
        bundleConfig?.use_compare_at_price,
        bundleConfig?.apply_discount_on_compare_price,
    ]);

    const hideCrossIcon = () => {
        if (!bundleConfig?.make_pre_selected_compulsory) {
            return false;
        }
        if (!product?.isPreselected) {
            return false;
        }

        // Check the actual product instance in selectedProducts that matches this card's page/substep

        const isCurProductInFinalList = selectedProducts.find(
            (p: any) =>
                p.id === product.parentProduct &&
                p.page === product.page?.toString() &&
                p.subStep === product.subStep?.toString(),
        );

        if (!isCurProductInFinalList) {
            return false;
        }

        const curProductTotalSelectedVariants = isCurProductInFinalList?.selectedVariants || [];
        const preselectedProductOriginalQuantity =
            bundleConfig?.pre_selected_products?.find((p: any) => p.id === product.parentProduct)?.quantity || 0;

        // Hide cross icon only if current quantity equals the original preselected quantity
        return curProductTotalSelectedVariants.length <= preselectedProductOriginalQuantity;
    };
    const isMetalBird = METAL_BIRD_SHOPS.includes(userShopname || "");

    console._log("asfdsadasfa== product", product);
    const currentSubStep = steps[activeStep]?.enable_subSteps ? activeSubStep : 0;

    const renderPreOrderMetafield = (
        <>
            <div
                style={{
                    fontSize: 11,
                    fontWeight: 450,
                }}
                className={styles.meta3}
            >
                {/* @ts-expect-error shop specific */}
                {product?.metafield3?.value}
            </div>
        </>
    );

    const renderCustomTextMetafield = isLilSweetTreatStore && (
        <div
            style={{
                fontSize: 11,
                fontWeight: 450,
            }}
            className={styles.meta4}
        >
            {/* @ts-expect-error shop specific */}
            {product?.metafield4?.value}
        </div>
    );

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="reviewProductCard">
            <div
                className={styles.selectedProduct}
                key={"sp" + index}
                style={{
                    ...(isMobile && { width: "100%", maxWidth: "100%" }),
                    ...(isReviewPage && { maxWidth: "100%", background: "#f5f5f5", width: "100%" }),
                    border: "1px solid #fff",
                    borderWidth: bundleConfig?.bundles_design?.review_product_border_width,
                    borderColor: bundleConfig?.bundles_design?.review_product_border_color,
                    borderRadius: bundleConfig?.bundles_design?.review_product_border_radius,
                }}
            >
                {!isReviewPage &&
                    !hideCrossIcon() &&
                    "page" in product &&
                    activeStep == +(product?.page || 0) &&
                    (!steps[activeStep]?.enable_subSteps ||
                        bundleConfig?.substep_layout === "sequential" ||
                        currentSubStep == +(product?.subStep || 0)) && (
                        <span
                            className={`${styles.removeSpProduct} 
                    `}
                            onClick={() => {
                                handleRemoveProduct(product.parentProduct, product.id, product?.subStep);
                            }}
                        >
                            <CloseIcon size={9} />
                        </span>
                    )}

                <div style={{ display: "flex", gap: 10, flexGrow: 1 }}>
                    <ProductImageWrapper
                        product={product}
                        handleProductClick={() => {}}
                        bundleConfig={{
                            ...bundleConfig,
                            bundle_type: BundleTypes.STANDARD,
                            original_bundle_type: BundleTypes.BUNDLE_BUILDER,
                            bundles_design: {
                                ...bundleConfig?.bundles_design,
                                product_img_border_width: bundleConfig?.bundles_design?.review_product_img_border_width,
                                product_img_border_color: bundleConfig?.bundles_design?.review_product_img_border_color,
                                product_img_border_radius:
                                    bundleConfig?.bundles_design?.review_product_img_border_radius,
                            },
                        }}
                        isMobile={isMobile}
                        selectedVariants={product.selectedVariants}
                    />
                    <div className={styles.spInfoWrapper}>
                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="productTitle"
                            wrapWithDiv={true}
                        >
                            <span
                                className={styles.spTitle}
                                style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    alignItems: isMobile ? "center" : "flex-start",
                                    justifyContent: isMobile ? "space-between" : "flex-start",
                                    gap: isMobile ? 4 : 8,
                                    lineHeight: "normal",
                                    width: "100%",
                                    fontSize: bundleConfig?.bundles_design.product_name_size,
                                    fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                                    fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                }}
                                title={product?.parentName}
                            >
                                {product?.parentName}
                            </span>
                        </InspectorEditableBlock>
                        {!SPRAY_IT_SHOPS.includes(userShopname || "") && product.parentName !== product.title && (
                            <InspectorEditableBlock
                                bundleType={bundleConfig?.bundle_type}
                                settingKey="productTitle"
                                wrapWithDiv={true}
                            >
                                <span
                                    className={styles.spTitle}
                                    style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 1,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        alignItems: isMobile ? "center" : "flex-start",
                                        justifyContent: isMobile ? "space-between" : "flex-start",
                                        gap: isMobile ? 4 : 8,
                                        width: "100%",
                                        fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                        fontWeight: 450,
                                        fontSize: 11,
                                        lineHeight: "normal",
                                    }}
                                    title={product?.title}
                                >
                                    {product.title}
                                </span>
                            </InspectorEditableBlock>
                        )}

                        {renderPreOrderMetafield}
                        {renderCustomTextMetafield}
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <span
                                className={styles.spQty}
                                style={{
                                    background: "#E9E9E9",
                                }}
                            >
                                x{" "}
                                <span
                                    style={{
                                        fontWeight: 550,
                                        fontSize: 12,
                                        color: "#505050",
                                    }}
                                >
                                    {
                                        // @ts-expect-error hack
                                        product?.qty
                                    }
                                </span>
                            </span>

                            {isMetalBird && !!product?.freeGift && (
                                <span
                                    className={styles.spQty}
                                    style={{
                                        background: "#E9E9E9",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                    }}
                                >
                                    <CiGift size={14} color="#505050" />
                                    <span
                                        style={{
                                            fontWeight: 550,
                                            fontSize: 12,
                                            color: "#505050",
                                        }}
                                    >
                                        Free gift
                                    </span>
                                </span>
                            )}
                        </span>
                    </div>
                </div>
                {isReviewPage && bundleConfig?.discount_type == "percentage" && (
                    <RenderPrice
                        product={product}
                        bundleConfig={bundleConfig}
                        money_format={money_format}
                        currency={currency}
                        disPrice={disPrice}
                        selectedVariants={product.selectedVariants}
                        origPrice={origPrice}
                        isMobile={isMobile}
                        isBottomBar={true}
                    />
                )}
            </div>
        </InspectorEditableBlock>
    );
};

// using when footer_layout is right
const ReviewProductCardRight = ({
    product,
    isMobile,
    bundleConfig,
    index,
    handleRemoveProduct = () => {},
    isReviewPage = false,
    money_format = "",
    currency = "",
    activeStep,
    freeGift = false,
}: {
    product: ProductObj;
    isMobile: boolean;
    bundleConfig: BundleBuilderConfigInterface;
    index: number;
    handleRemoveProduct: any;
    isReviewPage?: boolean;
    money_format?: any;
    currency?: any;
    activeStep: number;
    freeGift?: boolean;
    standAlone?: boolean;
}) => {
    const { selectedProducts, steps, activeSubStep, userShopname } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    const [disPrice, setDisPrice] = useState(0);
    const [origPrice, setOrigPrice] = useState(0);
    useEffect(() => {
        if (product?.selectedVariants?.length && !freeGift) {
            let disP = bundleConfig?.apply_discount_on_compare_price
                ? +product.selectedVariants[0].compareAtPrice * product?.quantity
                : +product.selectedVariants[0].price * product?.quantity;
            const origP = bundleConfig?.use_compare_at_price
                ? +product.selectedVariants[0].compareAtPrice * product?.quantity
                : +product.selectedVariants[0].price * product?.quantity;

            const dis = bundleConfig?.discount_value || 0;
            switch (bundleConfig?.discount_type) {
                case "percentage":
                    disP = disP - disP * (dis / 100);
                    break;
                default:
            }
            setDisPrice(Math.round(disP * 100) / 100);
            setOrigPrice(Math.round(origP * 100) / 100);
        } else {
            setDisPrice(0);
            setOrigPrice(0);
        }
    }, [
        product,
        bundleConfig?.discount_type,
        bundleConfig?.discount_value,
        bundleConfig?.use_compare_at_price,
        bundleConfig?.apply_discount_on_compare_price,
    ]);

    const hideCrossIcon = () => {
        if (!bundleConfig?.make_pre_selected_compulsory) {
            return false;
        }

        if (!product?.isPreselected) {
            return false;
        }

        // Check the actual product instance in selectedProducts that matches this card's page/substep
        const isCurProductInFinalList = selectedProducts.find(
            (p: any) =>
                p.id === product.parentProduct &&
                p.page === product.page?.toString() &&
                p.subStep === product.subStep?.toString(),
        );

        if (!isCurProductInFinalList) {
            return false;
        }

        const curProductTotalSelectedVariants = isCurProductInFinalList?.selectedVariants || [];
        const totalSelectedVariants = curProductTotalSelectedVariants.length;
        if (totalSelectedVariants <= 1) {
            return true;
        }

        const firstVariantId = curProductTotalSelectedVariants?.[0]?.id;
        const allSameVariant = curProductTotalSelectedVariants.every((variant: any) => variant.id === firstVariantId);

        if (allSameVariant) {
            return true;
        }

        return false;
    };

    const isMetalBird = METAL_BIRD_SHOPS.includes(userShopname || "");
    const currentSubStep = steps[activeStep]?.enable_subSteps ? activeSubStep : 0;

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="reviewProductCard">
            <div
                className={styles.selectedProductRight}
                key={"sp" + index}
                style={{
                    border: "1px solid #fff",
                    borderWidth: bundleConfig?.bundles_design?.review_product_border_width,
                    borderColor: bundleConfig?.bundles_design?.review_product_border_color,
                    borderRadius: bundleConfig?.bundles_design?.review_product_border_radius,
                }}
            >
                {!isReviewPage &&
                    !hideCrossIcon() &&
                    "page" in product &&
                    activeStep == +(product?.page || 0) &&
                    (!steps[activeStep]?.enable_subSteps ||
                        bundleConfig?.substep_layout === "sequential" ||
                        currentSubStep == +(product?.subStep || 0)) && (
                        <span
                            className={`${styles.removeSpProductRight} 
                    `}
                            style={{
                                right: "0",
                            }}
                            onClick={() => {
                                handleRemoveProduct(product.parentProduct, product.id, product?.subStep);
                            }}
                        >
                            <CloseIcon size={9} />
                        </span>
                    )}

                <div style={{ display: "flex", gap: 10, flexGrow: 1 }}>
                    <ProductImageWrapper
                        product={product}
                        handleProductClick={() => {}}
                        bundleConfig={{
                            ...bundleConfig,
                            bundle_type: BundleTypes.STANDARD,
                            original_bundle_type: BundleTypes.BUNDLE_BUILDER,
                            bundles_design: {
                                ...bundleConfig?.bundles_design,
                                product_img_border_width: bundleConfig?.bundles_design?.review_product_img_border_width,
                                product_img_border_color: bundleConfig?.bundles_design?.review_product_img_border_color,
                                product_img_border_radius:
                                    bundleConfig?.bundles_design?.review_product_img_border_radius,
                            },
                        }}
                        isMobile={isMobile}
                        overrideQtyVisibility={true}
                        selectedVariants={product.selectedVariants}
                    />
                    <div className={styles.spInfoWrapper}>
                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="productTitle"
                            wrapWithDiv={true}
                        >
                            <span
                                className={styles.spTitle}
                                style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    alignItems: isMobile ? "center" : "flex-start",
                                    justifyContent: isMobile ? "space-between" : "flex-start",
                                    gap: isMobile ? 4 : 8,
                                    lineHeight: "normal",
                                    width: "100%",
                                    fontSize: bundleConfig?.bundles_design.product_name_size,
                                    color: bundleConfig?.bundles_design?.product_name_color,
                                    fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                                    fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                }}
                                title={product?.parentName}
                            >
                                {product.parentName}
                            </span>
                        </InspectorEditableBlock>
                        {product.parentName !== product.title && (
                            <InspectorEditableBlock
                                bundleType={bundleConfig?.bundle_type}
                                settingKey="productTitle"
                                wrapWithDiv={true}
                            >
                                <span
                                    className={styles.spTitle}
                                    style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 1,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        alignItems: isMobile ? "center" : "flex-start",
                                        justifyContent: isMobile ? "space-between" : "flex-start",
                                        gap: isMobile ? 4 : 8,
                                        width: "100%",
                                        fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                                        fontWeight: 450,
                                        fontSize: 11,
                                        lineHeight: "normal",
                                    }}
                                    title={product?.title}
                                >
                                    {product.title}
                                </span>
                            </InspectorEditableBlock>
                        )}
                        {/* <span
                            className={styles.spQty}
                            style={{
                                background: "#E9E9E9",
                            }}
                        >
                            x{" "}
                            <span
                                style={{
                                    fontWeight: 550,
                                    fontSize: 12,
                                    color: "#505050",
                                }}
                            >
                                {
                                    // @ts-expect-error hack
                                    product?.qty
                                }
                            </span>
                        </span> */}
                        {isMetalBird && !!product?.freeGift && (
                            <span
                                className={styles.spQty}
                                style={{
                                    background: "#E9E9E9",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                }}
                            >
                                <CiGift size={14} color="#505050" />
                                <span
                                    style={{
                                        fontWeight: 550,
                                        fontSize: 12,
                                        color: "#505050",
                                    }}
                                >
                                    Free gift
                                </span>
                            </span>
                        )}
                    </div>
                </div>
                {isReviewPage && bundleConfig?.discount_type == "percentage" && (
                    <RenderPrice
                        product={product}
                        bundleConfig={bundleConfig}
                        money_format={money_format}
                        currency={currency}
                        disPrice={disPrice}
                        selectedVariants={product.selectedVariants}
                        origPrice={origPrice}
                        isMobile={isMobile}
                        isBottomBar={true}
                    />
                )}
            </div>
        </InspectorEditableBlock>
    );
};

const PageTitleSubtitleWrapper = () => {
    const { steps, activeStep, bundleConfig, isMobile } =
        useContext<BundleBuilderBundleContextType>(BundleBuilderBundleContext);

    return (
        <div className={styles.pageTitleSubtitleWrapper}>
            {!!steps?.[activeStep]?.page_title && (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="stepTitle">
                    <div
                        className={styles.pageTitleWrapper}
                        style={{
                            fontSize: bundleConfig?.bundles_design?.step_page_title_size,
                            color: bundleConfig?.bundles_design?.step_page_title_color,
                            fontWeight: bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[0] ?? "550",
                            fontStyle: bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[1] ?? "normal",
                            width: isMobile ? "100%" : "70%",
                        }}
                    >
                        {steps?.[activeStep]?.page_title}
                    </div>
                </InspectorEditableBlock>
            )}
            {!!steps?.[activeStep]?.page_subtitle && (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="stepSubTitle">
                    <div
                        className={styles.pageTitleWrapper}
                        style={{
                            fontSize: bundleConfig?.bundles_design?.step_page_subtitle_size,
                            color: bundleConfig?.bundles_design?.step_page_subtitle_color,
                            fontWeight: bundleConfig?.bundles_design?.step_page_subtitle_style?.split(" ")[0] ?? "550",
                            fontStyle:
                                bundleConfig?.bundles_design?.step_page_subtitle_style?.split(" ")[1] ?? "normal",
                            width: isMobile ? "100%" : "70%",
                            marginBottom: "6px",
                        }}
                    >
                        {steps?.[activeStep]?.page_subtitle}
                    </div>
                </InspectorEditableBlock>
            )}
            {!!steps?.[activeStep]?.header_subtitle && (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="stepSubTitle">
                    <div
                        className={styles.headerSubtitle}
                        dangerouslySetInnerHTML={{
                            __html: steps?.[activeStep]?.header_subtitle,
                        }}
                    ></div>
                </InspectorEditableBlock>
            )}
            {!!steps?.[activeStep]?.show_banner && (
                <div style={{ width: isMobile ? "90%" : "85%" }} id={`kefi-builder-banner-${activeStep}`}>
                    {isMobile
                        ? steps?.[activeStep]?.banner_mobile && (
                              <img
                                  src={steps[activeStep].banner_mobile}
                                  alt=""
                                  style={{
                                      width: "100%",
                                      maxHeight: "fit-content",
                                      borderRadius: "4px",
                                  }}
                              />
                          )
                        : steps?.[activeStep]?.banner_desktop && (
                              <img
                                  src={steps[activeStep].banner_desktop}
                                  alt=""
                                  style={{
                                      width: "100%",
                                      maxHeight: "fit-content",
                                      borderRadius: "4px",
                                  }}
                              />
                          )}
                </div>
            )}
        </div>
    );
};

export const BundleBuilderBundleContext = createContext<BundleBuilderBundleContextType | any>({});

export const BundleBuilderPreview = ({
    bundleConfig,
    appConfigContext,
    standAlone = false,
    previewType = null,
    isTemplate = false,
}: // inspectMode = false,
Props_BundleBuilderPreview) => {
    const { money_format, currency, sft } = appConfigContext;
    const searchParams = new URLSearchParams(window.location.search);
    const { isMobile: _isMobile } = useIsMobile();
    const appName = config.appName;
    const isMobile = previewType ? (previewType === 1 ? true : false) : _isMobile;
    const [activeStep, setActiveStep] = useState<number>(0);
    const [activeSubStep, setActiveSubStep] = useState<number>(0);
    const [disableNextOnFields, setDisableNextOnFields] = useState<boolean>(false);
    const [subStepDropdownOpen, setSubStepDropdownOpen] = useState<boolean>(false);
    const [steps, setSteps] = useState<ExtendedStepsType[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState<ProductObj[] | []>([]);
    const [expandProductList, setExpandProductList] = useState<boolean>(isMobile ? false : true);
    const [checkingOut, setCheckingOut] = useState<boolean>(false);
    const [listProducts, setListProducts] = useState<ProductObj[]>([]);
    const [sequentialSubStepProducts, setSequentialSubStepProducts] = useState<{ [subStepIdx: number]: ProductObj[] }>(
        {},
    );
    const [fieldsData, setFieldsData] = useState<{ id: string; label: string; value: string }[]>([]);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [selectedVariants, setSelectedVariants] = useState<any[]>([]);
    const [pageInfo, setPageInfo] = useState<any>(null); // 🆕 state to store page info
    const loadMoreTriggerRef = useRef<HTMLDivElement | null>(null);
    const productListRef = useRef<HTMLDivElement>(null);
    const abortControllerRef = useRef<AbortController | null>(null);
    const [boxQuantity, setBoxQuantity] = useState<number>(1);
    const [currentPageSelectCount, setCurrentPageSelectCount] = useState(0);
    const [currentPageSelectTotal, setCurrentPageSelectTotal] = useState(0);
    const [nextErrorMsg, setNextErrorMsg] = useState<string[]>([]);
    const [discountType, setDiscountType] = useState<DiscountTypes>("none");
    const [discountValue, setDiscountValue] = useState<number>(0);
    const [tierSuccessMessage, setTierSuccessMessage] = useState("");
    const [addonProducts, setAddonProducts] = useState<ProductObj[]>([]);
    const [loadingAddons, setLoadingAddons] = useState(false);
    const [dosageResultsHeight, setDosageResultsHeight] = useState<number>(0);
    const [anyCardShowingDosageResults, setAnyCardShowingDosageResults] = useState<boolean>(false);
    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    const containerRef = useRef<HTMLDivElement>(null);

    const maxBoxSize = useMemo(() => {
        if (bundleConfig?.discount_type !== DISCOUNT_TYPES.FIXED_BOXES) return Infinity;
        return Math.max(...(bundleConfig?.fixed_boxes?.map((box: any) => box?.itemsCount) || [0]));
    }, [bundleConfig?.discount_type, bundleConfig?.fixed_boxes]);

    useEffect(() => {
        setActiveSubStep(0);
    }, [activeStep]);

    const getNextTierOption = (validDiscount: BBTierOptions | null, compareWith: number): BBTierOptions | null => {
        const basis = bundleConfig?.tier_discount_basis;
        if (basis === "product_based") {
            return null;
        }
        const validDiscountIdx: number = bundleConfig?.discount_options.findIndex(
            (option) => (validDiscount as BBTierOptions)?.id === option.id,
        );
        if (validDiscountIdx >= bundleConfig?.discount_options?.length - 1) {
            return { completeStatus: true } as any;
        }
        for (
            let i = validDiscountIdx == -1 ? 0 : validDiscountIdx + 1;
            i < bundleConfig?.discount_options.length;
            i++
        ) {
            const opt = bundleConfig.discount_options[i];
            if (basis == "bundle_total") {
                if (opt && convertValueToLocal(opt.quantity) - compareWith > 0) {
                    return { ...opt, quantity: convertValueToLocal(opt.quantity) };
                }
            } else {
                if (opt && opt.quantity - compareWith > 0) {
                    return { ...opt };
                }
            }
        }

        return null;
    };

    const getApplicableTier = (
        tiers: BBTierOptions[],
        compareWith: number,
        selectedProductsInBundle: ProductObj[] = [],
        totalPrice?: number,
    ): BBTierOptions | null => {
        if (!tiers || tiers.length === 0) return null;
        const basis = bundleConfig?.tier_discount_basis;

        if (basis === "product_based") {
            let bestTier: BBTierOptions | null = null;
            let maxDiscountAmount = -1;

            for (const tier of tiers) {
                if (!tier.selected_products || tier.selected_products.length === 0) continue;

                const hasMatchingProduct = selectedProductsInBundle.some((bundleProd: any) =>
                    tier.selected_products?.some(
                        (tierProd: any) =>
                            getProductId(tierProd.id) === getProductId(bundleProd.id) ||
                            (tierProd.shopifyId && getProductId(tierProd.shopifyId) === getProductId(bundleProd.id)) ||
                            (bundleProd.shopifyId && getProductId(tierProd.id) === getProductId(bundleProd.shopifyId)),
                    ),
                );

                if (hasMatchingProduct) {
                    let currentAmount = 0;
                    const val = tier.discountValue || 0;
                    const currentTotalPrice = totalPrice || 0;

                    if (tier.discountType === "percentage") {
                        currentAmount = (currentTotalPrice * val) / 100;
                    } else if (tier.discountType === "flat") {
                        currentAmount = val;
                    } else if (tier.discountType === "fixed") {
                        currentAmount = Math.max(0, currentTotalPrice - val);
                    }

                    if (currentAmount > maxDiscountAmount) {
                        maxDiscountAmount = currentAmount;
                        bestTier = tier;
                    }
                }
            }
            return bestTier;
        }

        for (let i = 0; i < tiers.length; i++) {
            const current = tiers[i];
            const next = tiers[i + 1];
            const currentQ = basis == "bundle_total" ? convertValueToLocal(current.quantity) : current.quantity;
            let nextQ = 0;
            if (next) {
                nextQ = basis == "bundle_total" ? convertValueToLocal(next.quantity) : next.quantity;
            }
            if (current.addRange) {
                // qualifies if >= current.quantity but < next.quantity
                if (compareWith >= currentQ && (!next || compareWith < nextQ)) {
                    return current;
                }
            } else {
                // must exactly match the quantity
                if (compareWith === currentQ) {
                    return current;
                }
            }
        }

        return null;
    };

    const {
        totalPrice,
        totalCompareAtPrice,
        totalFreeGiftPrice,
        totalAddonPrice,
        addonsDiscountValue,
        baseSubtotal,
        baseSubtotalForDiscount,
        discountedBundleTotal,
        hasDiscount,
        showStrikePrice,
        discountAmount,
        discountAmountPercent,
        discountValueToShow,
    } = useMemo(() => {
        // ----- TOTALS -----
        let totalPrice = 0;
        let totalCompareAtPrice = 0;
        let totalFreeGiftPrice = 0;
        let totalAddonPrice = 0;
        // let addonItemsCount = 0;
        const addonDiscountType = bundleConfig?.review_step?.discount_type;
        const addonDiscountConfigValue = bundleConfig?.review_step?.discount_value || 0;
        let totalAddonDiscount = 0;

        selectedProducts.forEach((usp: any) => {
            usp.selectedVariants.forEach((sv: any) => {
                const price = Number(sv.price) || 0;
                const compareAt = Number(sv.compareAtPrice) || 0;

                if (!usp.freeGift && !usp.isAddon) {
                    totalPrice += price;
                    totalCompareAtPrice += compareAt;
                }

                if (usp.freeGift) totalFreeGiftPrice += price;
                if (usp.isAddon) {
                    totalAddonPrice += price;
                    // addonItemsCount += 1;
                    if (addonDiscountType === "flat" || addonDiscountType === "fixed") {
                        totalAddonDiscount += Math.min(price, addonDiscountConfigValue);
                    }
                }
            });
        });

        // ----- SUBTOTALS -----
        const baseSubtotal = (bundleConfig?.use_compare_at_price ? totalCompareAtPrice : totalPrice) * boxQuantity;
        const baseSubtotalForDiscount =
            (bundleConfig?.apply_discount_on_compare_price ? totalCompareAtPrice : totalPrice) * boxQuantity;

        let addonsDiscountValue = 0;

        if (
            totalAddonPrice > 0 &&
            addonDiscountConfigValue > 0 &&
            bundleConfig?.review_step?.apply_discount_on_addon_products
        ) {
            if (addonDiscountType === "percentage") {
                addonsDiscountValue = (totalAddonPrice * addonDiscountConfigValue) / 100;
            } else if (addonDiscountType === "flat" || addonDiscountType === "fixed") {
                addonsDiscountValue = totalAddonDiscount;
                if (addonsDiscountValue > totalAddonPrice) addonsDiscountValue = totalAddonPrice;
            }
        }

        let discountedBundleTotal = baseSubtotalForDiscount;
        switch (discountType) {
            case "percentage":
                discountedBundleTotal = (discountedBundleTotal * (100 - discountValue)) / 100;
                break;
            case "flat":
                discountedBundleTotal = discountedBundleTotal - discountValue * boxQuantity;
                break;
            case "fixed":
                discountedBundleTotal = discountValue * boxQuantity;
                break;
            default:
                discountedBundleTotal = baseSubtotalForDiscount;
        }

        const hasDiscount = discountedBundleTotal < baseSubtotal;
        const showStrikePrice = hasDiscount;
        const discountAmount = baseSubtotal - discountedBundleTotal;
        const discountAmountPercent = baseSubtotal > 0 ? Number(((discountAmount / baseSubtotal) * 100).toFixed(2)) : 0;
        const discountValueToShow = discountType === "percentage" ? discountAmountPercent : discountAmount;

        return {
            // totals
            totalPrice,
            totalCompareAtPrice,
            totalFreeGiftPrice,
            totalAddonPrice,
            addonsDiscountValue,
            // pricing
            baseSubtotal,
            baseSubtotalForDiscount,
            discountedBundleTotal,
            hasDiscount,
            showStrikePrice,
            discountAmount,
            discountAmountPercent,
            discountValueToShow,
        };
    }, [selectedProducts, boxQuantity, bundleConfig, discountType, discountValue]);

    const { totalQuantity, normalTotalQuantity, addonTotalQuantity, freeGiftTotalQuantity } = useMemo(() => {
        let ntq = 0;
        let fgq = 0;
        let aq = 0;

        selectedVariants.forEach((sv: ProductObj) => {
            const count = sv.selectedVariants?.length || 0;

            if (sv.freeGift) fgq += count;
            else if (sv.isAddon) aq += count;
            else ntq += count;
        });

        return {
            normalTotalQuantity: ntq,
            freeGiftTotalQuantity: fgq,
            addonTotalQuantity: aq,
            totalQuantity: ntq + fgq + aq,
        };
    }, [selectedVariants]);

    useEffect(() => {
        if (bundleConfig?.discount_type === "tier" && bundleConfig?.discount_options?.length > 0) {
            const allDiscountsOptions = [...bundleConfig.discount_options];

            // insted of totalQuantity , we should eleminate free gift and addon products quantity.
            const compareWith = bundleConfig.tier_discount_basis === "bundle_total" ? totalPrice : normalTotalQuantity;
            const applicableDiscount = getApplicableTier(
                allDiscountsOptions,
                compareWith,
                selectedProducts,
                totalPrice,
            );

            const nextTierOption = getNextTierOption(applicableDiscount, compareWith);
            const isTierCompleted =
                // @ts-expect-error required
                !!nextTierOption?.completeStatus &&
                !!bundleConfig?.discount_options.find((opt) => opt.showFinalSuccessMessage)?.showFinalSuccessMessage;

            setDiscountType(applicableDiscount?.discountType || "none");
            setDiscountValue(applicableDiscount?.discountValue || 0);

            if (nextTierOption?.ShowTierSuccessMessage && nextTierOption?.TierSuccessMessage) {
                const msg = nextTierOption.TierSuccessMessage.replace(
                    "{noOfRemainingProducts}",
                    (nextTierOption.quantity - compareWith).toString(),
                )
                    .replace(
                        "{remainingAmount}",
                        `${getPriceLabel(
                            Math.round((nextTierOption.quantity - compareWith) * 100) / 100,
                            money_format,
                            currency,
                            true,
                            "string",
                        )}`,
                    )
                    .replace(
                        "{discount}",
                        getDiscountValueWithSignString(
                            nextTierOption.discountType,
                            nextTierOption.discountValue || 0,
                            currency,
                            money_format,
                        ) as string,
                    );
                setTierSuccessMessage(msg);
            } else {
                if (isTierCompleted) {
                    setTierSuccessMessage(
                        bundleConfig?.discount_options.find((opt) => opt.showFinalSuccessMessage)
                            ?.finalSuccessMessage || "",
                    );
                } else setTierSuccessMessage("");
            }
        } else if (bundleConfig?.discount_type === DISCOUNT_TYPES.FIXED_BOXES) {
            const fixedBoxes: FixedBoxConfig[] = bundleConfig?.fixed_boxes || [];

            if (!fixedBoxes.length) {
                setDiscountType("none");
                setDiscountValue(0);
                return;
            }

            // Find highest applicable box
            const applicableBox = fixedBoxes.filter((box) => normalTotalQuantity >= box.itemsCount).pop();

            if (applicableBox) {
                setDiscountType("fixed");
                setDiscountValue(applicableBox.fixedPrice);
            } else {
                setDiscountType("none");
                setDiscountValue(0);
            }
        } else {
            setDiscountType(bundleConfig?.discount_type);
            setDiscountValue(bundleConfig?.discount_value);
            setTierSuccessMessage("");
        }
    }, [bundleConfig?.discount_type, bundleConfig?.discount_options, normalTotalQuantity, totalPrice]);

    console._log("discountvalue:::", discountType, discountValue, bundleConfig?.products);
    const updatedBundleConfig = {
        ...bundleConfig,
        discount_type: discountType,
        discount_value: discountValue,
    };
    // console._log("updatedBundleConfig", updatedBundleConfig, bundleConfig);

    useEffect(() => {
        // @ts-expect-error hack
        if (standAlone && bundleConfig?.form_id && bundleConfig?.shop) {
            updateBundleStats({
                id: bundleConfig?.form_id,
                key: "views",
                // @ts-expect-error hack
                shop: bundleConfig?.shop,
                appName: appName,
                view_type: 5,
            });
            trackAbVisitorEvent(bundleConfig as BundleBuilderConfigInterface, "view", 1, appName);
        }
    }, [bundleConfig?.form_id, standAlone]);

    useEffect(() => {
        let _steps: ExtendedStepsType[] = [];
        if (bundleConfig?.steps?.length) {
            _steps = [...(bundleConfig.steps.map((st) => ({ ...st, review_step: false })) as any)];
        }

        // Apply hidden steps conditions
        if (bundleConfig?.allow_conditional_logic && bundleConfig?.product_conditions?.length) {
            const { hiddenSteps, hiddenSubSteps } = getHiddenStepsBB(bundleConfig.product_conditions, selectedProducts);
            if (hiddenSteps.length > 0) {
                _steps = _steps.filter((step) => !hiddenSteps.includes(step.step_label));
            }

            if (hiddenSubSteps?.length > 0) {
                if (bundleConfig?.substep_layout == "sequential") {
                    _steps = _steps
                        .map((step) => {
                            if (step.enable_subSteps && step.subSteps?.length > 0) {
                                const updatedSubSteps = step.subSteps.map((subStep) => {
                                    const isHidden = hiddenSubSteps.includes(
                                        `${step.step_label}:${subStep.step_label}`,
                                    );
                                    return { ...subStep, hidden: isHidden };
                                });
                                return { ...step, subSteps: updatedSubSteps };
                            }
                            return step;
                        })
                        .filter((step) => !step.enable_subSteps || step.subSteps?.some((subStep) => !subStep.hidden));
                } else {
                    _steps = _steps
                        .map((step) => {
                            if (step.enable_subSteps && step.subSteps?.length > 0) {
                                const filteredSubSteps = step.subSteps.filter(
                                    (subStep) => !hiddenSubSteps.includes(`${step.step_label}:${subStep.step_label}`),
                                );
                                return { ...step, subSteps: filteredSubSteps };
                            }
                            return step;
                        })
                        .filter((step) => !step.enable_subSteps || step.subSteps?.length > 0);
                }
            }
        }

        if (bundleConfig?.review_step) {
            if (bundleConfig?.review_step?.is_enabled) {
                _steps = [..._steps, { ...bundleConfig?.review_step, review_step: true } as unknown as any];
            }
        }
        setSteps(_steps);
    }, [
        bundleConfig?.steps,
        bundleConfig?.review_step,
        bundleConfig?.allow_conditional_logic,
        bundleConfig?.product_conditions,
        selectedProducts,
    ]);

    useEffect(() => {
        if (activeStep >= steps.length && steps.length > 0) {
            setActiveStep(steps.length - 1);
        }
    }, [steps, activeStep]);

    useEffect(() => {
        if (steps?.length > 0) {
            steps.forEach((step, stepIdx) => {
                if (step.step_content_type === "fields" && (step as any).fields?.length > 0) {
                    (step as any).fields.forEach((field: any, fieldIdx: number) => {
                        if (field.default_value) {
                            setFieldsData((ps) => {
                                const fieldId = `${stepIdx}-${fieldIdx}`;
                                const exists = ps.find((fd) => fd.id === fieldId);
                                if (!exists) {
                                    return [
                                        ...ps,
                                        { id: fieldId, label: field.field_title, value: field.default_value },
                                    ];
                                }
                                return ps;
                            });
                        }
                    });
                }
            });
        }
    }, [steps]);

    useEffect(() => {
        setExpandProductList(
            isMobile
                ? [
                      "alpino-in.myshopify.com",
                      "dev-store-0124.myshopify.com",
                      "teststore20-2787.myshopify.com",
                      "atelierscents.myshopify.com",
                  ].includes(userShopname as string)
                    ? true
                    : false
                : true,
        );
    }, [isMobile]);

    useEffect(() => {
        if (selectedProducts?.length) {
            setSelectedVariants(() => {
                const arr = selectedProducts.flatMap((product) =>
                    product.selectedVariants.map((variant) => ({
                        ...product,
                        selectedVariants: product.selectedVariants.filter((psv) => psv.id == variant.id),
                        ...variant,
                        parentName: product?.parentName || product?.title,
                        parentProduct: product?.id,
                        page: product?.page,
                        subStep: product?.subStep,
                    })),
                );
                const grouped = arr.reduce((acc, variant) => {
                    const existing = acc.find(
                        (v) =>
                            v.id === variant.id &&
                            v.parentProduct === variant.parentProduct &&
                            v.page === variant.page &&
                            v.subStep === variant.subStep,
                    );

                    if (existing) {
                        existing.qty += 1;
                    } else {
                        acc.push({ ...variant, qty: 1 });
                    }

                    return acc;
                }, [] as any[]); // optionally type your array if needed

                return grouped;
            });
        } else {
            setSelectedVariants([]);
        }
    }, [selectedProducts]);

    const handleAddProduct = (
        product: any,
        optType: "" | "inc" | "dec" | "add" = "",
        pageId: string | null = null,
        subStepOverride: string | null = null,
    ) => {
        setSelectedProducts((ps) => {
            let updatedSelectedProducts = [...ps];

            if (optType == "add" && bundleConfig?.allow_conditional_logic) {
                updatedSelectedProducts = removeConditionalProductIfAny(bundleConfig?.product_conditions, ps, product);
            }

            const currentPage = pageId ?? activeStep?.toString();
            const currentSubStep =
                subStepOverride ?? (steps[activeStep]?.enable_subSteps ? activeSubStep?.toString() : "0");

            const pIdx = updatedSelectedProducts.findIndex(
                (sp) =>
                    sp.id === product.id &&
                    sp.page === currentPage &&
                    sp.subStep === currentSubStep &&
                    (isLilSweetTreatStore &&
                    (steps[activeStep]?.enable_subSteps
                        ? steps[activeStep].subSteps?.[parseInt(currentSubStep)]?.allow_product_custom_text
                        : steps[activeStep]?.allow_product_custom_text)
                        ? sp.custom_text === product.custom_text
                        : true),
            );
            if (pIdx >= 0) {
                updatedSelectedProducts = updatedSelectedProducts
                    .map((sp) => {
                        // Only modify products from the CURRENT step
                        if (sp.id !== product.id || sp.page !== currentPage || sp.subStep !== currentSubStep) return sp;

                        if (optType === "inc" || optType === "add") {
                            return {
                                ...sp,
                                page: pageId ?? activeStep?.toString(),
                                subStep: currentSubStep,
                                selectedVariants:
                                    steps[activeStep]?.enable_dosage_calculation && isDispensaryCoStore
                                        ? [...sp.selectedVariants, ...product.selectedVariants]
                                        : [...sp.selectedVariants, product.selectedVariants[0]],
                            };
                        } else if (optType === "dec") {
                            let variantIndex = -1;
                            variantIndex = sp.selectedVariants.findIndex(
                                (variant) => variant.id == product?.selectedVariants?.[0]?.id,
                            );
                            return {
                                ...sp,
                                page: pageId ?? activeStep?.toString(),
                                subStep: currentSubStep,
                                parentName: product?.title,
                                selectedVariants:
                                    sp.selectedVariants.length <= 1
                                        ? []
                                        : variantIndex >= 0
                                          ? sp.selectedVariants.filter((_, idx) => idx != variantIndex)
                                          : sp.selectedVariants.slice(0, -1),
                            };
                        }

                        return sp;
                    })
                    .filter((sp) => sp?.selectedVariants?.length > 0);
            } else {
                updatedSelectedProducts.push({
                    ...product,
                    page: pageId ?? activeStep?.toString(),
                    subStep: currentSubStep,
                });
            }

            return updatedSelectedProducts;
        });
    };

    const [showCheckoutModal, setShowCheckoutModal] = useState(false);

    const handleBundleBuilderCheckout = async () => {
        if (selectedProducts?.length == 0) return;
        setCheckingOut(true);
        const cartToken = await cartWatcher.cart.token;
        const appName = config.appName;

        updateBundleStats({
            id: bundleConfig?.form_id,
            key: "clicks",
            // @ts-expect-error hack
            shop: bundleConfig?.shop,
            appName: appName,
            view_type: 5,
        });
        trackAbVisitorEvent(bundleConfig as BundleBuilderConfigInterface, "click", 1, appName);
        const items: any[] = [];
        const freeItems: any[] = [];
        const addOnItems: any[] = [];
        selectedProducts?.forEach((p: any) => {
            p.selectedVariants.forEach((selected: VariantsObj) => {
                const itemFields = [...fieldsData.filter((ps) => !!ps?.value?.trim())];

                if (isLilSweetTreatStore) {
                    const productStepIndex = parseInt(p.page || "0");
                    const productStep = steps[productStepIndex];

                    const productSubStepIndex = parseInt(p.subStep || "0");
                    const productSubStep = productStep?.enable_subSteps
                        ? productStep.subSteps[productSubStepIndex]
                        : null;

                    const allowCustomText = productStep?.enable_subSteps
                        ? productSubStep?.allow_product_custom_text
                        : productStep?.allow_product_custom_text;

                    if (allowCustomText && p.custom_text) {
                        itemFields.push({
                            id: `custom-text-${p.id}`,
                            label: p.title || "Custom Text",
                            value: p.custom_text,
                        });
                    }
                }
                if (isDispensaryCoStore) {
                    const productStepIndex = parseInt(p.page || "0");
                    const productStep = steps[productStepIndex];

                    if (productStep?.enable_dosage_calculation) {
                        itemFields.push({
                            id: `product-title-${selected.id}`,
                            label: selected.title,
                            value: "",
                        });
                        if (selected.dosage_daily_dose) {
                            itemFields.push({
                                id: `daily-dose-${selected.id}`,
                                label: "Daily dose",
                                value: selected.dosage_daily_dose + " g",
                            });
                        }
                        if (selected.dosage_no_of_days) {
                            itemFields.push({
                                id: `no-of-days-${selected.id}`,
                                label: "Number of days",
                                value: selected.dosage_no_of_days,
                            });
                        }
                        if (selected.dosage_total_needed && Number(selected.dosage_total_needed) > 0) {
                            itemFields.push({
                                id: `total-needed-${selected.id}`,
                                label: "Total needed",
                                value: String(roundN(selected.dosage_total_needed, 3)) + " g",
                            });
                        }
                    }
                }
                if (p?.freeGift) {
                    freeItems.push({
                        id: `${selected.id.split("/")?.splice(-1)[0]}`,
                        quantity: selected?.quantity ? +selected.quantity : 1,
                        fields: itemFields,
                    });
                } else if (p?.isAddon) {
                    addOnItems.push({
                        id: `${selected.id.split("/")?.splice(-1)[0]}`,
                        quantity: selected?.quantity ? +selected.quantity : 1,
                        fields: itemFields,
                    });
                } else {
                    items.push({
                        id: `${selected.id.split("/")?.splice(-1)[0]}`,
                        quantity: selected?.quantity ? +selected.quantity : 1,
                        fields: itemFields,
                    });
                }
            });
        });

        await handleBundleCheckout({
            items,
            freeItems,
            addOnItems,
            formId: bundleConfig?.form_id || "",
            token: cartToken,
            boxQuantity: boxQuantity,
            redirectOptions: bundleConfig?.redirect_options,
            showPopupOnCartRedirect: bundleConfig?.show_popup_on_cart_redirect,
            setShowCheckoutModal,
            setLoadingState: setCheckingOut,
            bundleType: BundleTypes.BUNDLE_BUILDER,
            abVariantUuid: bundleConfig?._ab_variant_id,
            checkoutLabels: {
                checkout_box_label: bundleConfig.checkout_box_label,
                checkout_discount_label: bundleConfig.checkout_discount_label,
            },
        });
    };

    const handleRemoveProduct = (pId: string, vId: string, subStepOverride: string | null = null) => {
        setSelectedProducts((ps) => {
            const currentSubStep =
                subStepOverride ?? (steps[activeStep]?.enable_subSteps ? activeSubStep?.toString() : "0");

            const updatedSelectedProducts = ps
                .map((sp) => {
                    // Only remove from products on the CURRENT step AND subStep
                    if (sp.id === pId && sp.page === activeStep?.toString() && sp.subStep === currentSubStep) {
                        const remainingVariants = sp.selectedVariants.filter((v) => v.id !== vId);
                        return {
                            ...sp,
                            selectedVariants: remainingVariants,
                        };
                    }
                    return sp;
                })
                .filter((sp) => sp.selectedVariants.length > 0);

            return updatedSelectedProducts;
        });
    };

    const handleAddAddonProduct = (product: ProductObj, variant: VariantsObj) => {
        handleAddProduct(
            {
                ...product,
                selectedVariants: [variant],
                freeGift: false,
                render_as_variants: false,
                isAddon: true, // Mark as addon product
            },
            "add",
            activeStep?.toString(),
        );
    };

    const handleRemoveAddonProduct = useCallback(
        (variantId: string) => {
            setSelectedProducts((prevProducts) => {
                return prevProducts
                    .map((product) => {
                        if (product.page === activeStep?.toString()) {
                            // Find if this product contains the variant to remove
                            const variantIndex = product.selectedVariants.findIndex(
                                (variant) => variant.id === variantId,
                            );

                            if (variantIndex >= 0) {
                                // Create a copy of selectedVariants
                                const updatedVariants = [...product.selectedVariants];
                                // Remove only one instance of this variant
                                updatedVariants.splice(variantIndex, 1);
                                // If no variants left, return null to remove the product entirely
                                if (updatedVariants.length === 0) {
                                    return null;
                                }
                                return {
                                    ...product,
                                    selectedVariants: updatedVariants,
                                };
                            }
                        }
                        return product;
                    })
                    .filter(Boolean) as ProductObj[];
            });
        },
        [activeStep],
    );

    const handleFields = ({ id = "", label = "", value = "" }) => {
        if (!id) return;
        const idx = fieldsData.findIndex((fd) => fd.id === id);
        if (idx >= 0) {
            setFieldsData((ps) => {
                const fd = [...ps];
                fd[idx] = { id, label, value };
                return fd;
            });
        } else {
            setFieldsData((ps) => [...ps, { id, label, value }]);
        }
    };

    const loadMoreCollectionProducts = async (pgInfo: any = null, signal?: AbortSignal) => {
        if (loadingMore && pgInfo !== null) return; // Prevent multiple fetches
        const step = steps[activeStep]?.enable_subSteps
            ? steps[activeStep]?.subSteps[activeSubStep]
            : steps[activeStep];
        const gid = step?.collections[0]?.id;
        const id = gid?.split("/").pop() || "";
        if (!id) {
            if (!signal?.aborted) {
                setListProducts([]);
            }
            return;
        }
        setLoadingMore(true);
        try {
            const { products, pageInfo: newPageInfo } = await fetchCollectionProducts(
                id,
                sft,
                setLoadingMore,
                standAlone,
                fetchCount,
                pgInfo?.endCursor || null,
                signal,
            );

            if (signal?.aborted) return;

            const exemptIds = step?.exempt_product_ids || [];
            const productsWithExemption: ProductObj[] = products?.map((p: any) => ({
                ...p,
                exclude_from_step_conditions: bundleConfig?.allow_exclude_from_step_conditions
                    ? exemptIds.includes(p.id)
                    : false,
            }));

            setListProducts((prevProducts) => {
                const merged: ProductObj[] = pgInfo
                    ? [...prevProducts, ...productsWithExemption]
                    : productsWithExemption;
                const unique: ProductObj[] = bundleConfig?.hide_out_of_stock_products
                    ? (Array.from(new Map(merged.map((p: ProductObj) => [p.id, p])).values()) as ProductObj[]).filter(
                          filterInStockProducts,
                      )
                    : (Array.from(new Map(merged.map((p: ProductObj) => [p.id, p])).values()) as ProductObj[]);

                const finalList: ProductObj[] = (
                    bundleConfig?.allow_conditional_logic
                        ? applyConditionsBB(bundleConfig?.product_conditions, selectedProducts, unique)
                        : unique
                ) as ProductObj[];
                if (finalList.length == 0 && standAlone) {
                    const currentStepObj = steps[activeStep];
                    if (
                        currentStepObj?.enable_subSteps &&
                        activeSubStep < (currentStepObj?.subSteps?.length || 0) - 1
                    ) {
                        setActiveSubStep((prev) => prev + 1);
                    } else {
                        const goToStep = sessionStorage.getItem("goToStep");
                        setActiveStep((prev) => {
                            if (goToStep == "prev") {
                                return prev == 0 ? prev : prev - 1;
                            } else {
                                return prev == steps?.length - 1 ? prev : prev + 1;
                            }
                        });
                    }
                }
                return finalList;
            });
            setPageInfo(newPageInfo);
        } catch (error: any) {
            if (error?.name === "AbortError") {
                console._log("Load more fetch aborted.");
            } else {
                console.error("Error loading collection products:", error);
            }
        } finally {
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        // this only runs once at start, and fills the preselected products
        const getRealTimeProducts = async () => {
            const preSelected = bundleConfig?.pre_selected_products || [];

            const finalProducts = await getUpdatedVariants(preSelected, sft, bundleConfig?.steps, standAlone);
            setSelectedProducts(finalProducts);
        };

        getRealTimeProducts();
    }, [bundleConfig?.pre_selected_products]);

    console._log("ACTIVE STEP::::::::", steps[activeStep]);

    const getProductsStepWise = (step: any, signal: AbortSignal) => {
        switch (step?.product_selection) {
            case "collection":
                (async () => {
                    setLoadingProducts(true);
                    setLoadingMore(false);
                    try {
                        await loadMoreCollectionProducts(null, signal);
                        if (signal.aborted) return;
                        setLoadingProducts(false);
                    } catch (error: any) {
                        if (error?.name !== "AbortError") {
                            setLoadingProducts(false);
                        }
                    }
                })();
                break;
            case "specific":
                (async () => {
                    setLoadingProducts(true);
                    try {
                        const newConfig = await updateBundleConfigWithRealTimeProducts(
                            sft,
                            [{ ...bundleConfig, products: [...step.products] }],
                            standAlone,
                            null,
                            signal,
                        );

                        if (signal.aborted) return;

                        const rawList = bundleConfig?.hide_out_of_stock_products
                            ? newConfig[0]?.products?.filter(filterInStockProducts) || []
                            : newConfig[0]?.products || [];

                        let finalList: ProductObj[] = bundleConfig?.allow_conditional_logic
                            ? applyConditionsBB(bundleConfig?.product_conditions, selectedProducts, rawList)
                            : rawList;
                        const exemptIds = step?.exempt_product_ids || [];
                        finalList = finalList.map((item) => {
                            const mainItem = step.products.find((m: ProductObj) => m.id === item.id);
                            return {
                                ...item,
                                exclude_from_step_conditions: bundleConfig?.allow_exclude_from_step_conditions
                                    ? exemptIds.includes(item.id)
                                    : false,
                                variants: mainItem
                                    ? item.variants.filter(
                                          (v) => mainItem.variants.findIndex((t: VariantsObj) => t.id == v.id) >= 0,
                                      )
                                    : [],
                            };
                        });

                        if (finalList.length == 0 && standAlone) {
                            const currentStepObj = steps[activeStep];
                            if (
                                currentStepObj?.enable_subSteps &&
                                activeSubStep < (currentStepObj?.subSteps?.length || 0) - 1
                            ) {
                                setActiveSubStep((prev) => prev + 1);
                            } else {
                                const goToStep = sessionStorage.getItem("goToStep");
                                setActiveStep((prev) => {
                                    if (goToStep == "prev") {
                                        return prev == 0 ? prev : prev - 1;
                                    } else {
                                        return prev == steps?.length - 1 ? prev : prev + 1;
                                    }
                                });
                            }
                        }

                        setListProducts([...finalList]);
                        setLoadingProducts(false);
                    } catch (error: any) {
                        if (error?.name !== "AbortError") {
                            console.error("Error updating config products:", error);
                            setLoadingProducts(false);
                        }
                    }
                })();
                break;
            default:
                setListProducts([]);
                setLoadingProducts(false);
        }
    };

    const fetchProductsForSubStep = async (
        subStep: any,
        subStepIdx: number,
        stepIndex: number,
        signal: AbortSignal,
    ) => {
        if (!subStep) return;

        if (subStep.product_selection === "collection") {
            const gid = subStep.collections?.[0]?.id;
            const id = gid?.split("/").pop() || "";
            if (!id) {
                if (!signal.aborted) {
                    setSequentialSubStepProducts((prev) => ({ ...prev, [subStepIdx]: [] }));
                }
                return;
            }
            try {
                const { products } = (await fetchCollectionProducts(
                    id,
                    sft,
                    () => {},
                    standAlone,
                    fetchCount,
                    null,
                    signal,
                )) as { products: ProductObj[]; pageInfo: any };

                if (signal.aborted) return;

                const exemptIds = subStep.exempt_product_ids || [];
                const productsWithExemption = products?.map((p: any) => ({
                    ...p,
                    exclude_from_step_conditions: bundleConfig?.allow_exclude_from_step_conditions
                        ? exemptIds.includes(p.id)
                        : false,
                }));
                const unique = (
                    bundleConfig?.hide_out_of_stock_products
                        ? (
                              Array.from(
                                  new Map(productsWithExemption.map((p: any) => [p.id, p])).values(),
                              ) as ProductObj[]
                          ).filter(filterInStockProducts)
                        : (Array.from(
                              new Map(productsWithExemption.map((p: any) => [p.id, p])).values(),
                          ) as ProductObj[])
                ) as ProductObj[];

                const finalList = (
                    bundleConfig?.allow_conditional_logic
                        ? applyConditionsBB(bundleConfig?.product_conditions, selectedProducts, unique)
                        : unique
                ) as ProductObj[];

                setSequentialSubStepProducts((prev) => ({ ...prev, [subStepIdx]: finalList }));
            } catch (error: any) {
                if (error?.name !== "AbortError") {
                    console.error("Error loading products for sequential substep:", error);
                    setSequentialSubStepProducts((prev) => ({ ...prev, [subStepIdx]: [] }));
                }
            }
        } else if (subStep.product_selection === "specific") {
            try {
                const newConfig = (await updateBundleConfigWithRealTimeProducts(
                    sft,
                    [{ ...bundleConfig, products: [...subStep.products] }],
                    standAlone,
                    null,
                    signal,
                )) as BundleBuilderConfigInterface[];

                if (signal.aborted) return;

                const rawList = (
                    bundleConfig?.hide_out_of_stock_products
                        ? newConfig[0]?.products?.filter(filterInStockProducts) || []
                        : newConfig[0]?.products || []
                ) as ProductObj[];

                let finalList: ProductObj[] = (
                    bundleConfig?.allow_conditional_logic
                        ? applyConditionsBB(bundleConfig?.product_conditions, selectedProducts, rawList)
                        : rawList
                ) as ProductObj[];
                const exemptIds = subStep.exempt_product_ids || [];
                finalList = finalList.map((item) => {
                    const mainItem = subStep.products.find((m: ProductObj) => m.id === item.id);
                    return {
                        ...item,
                        exclude_from_step_conditions: bundleConfig?.allow_exclude_from_step_conditions
                            ? exemptIds.includes(item.id)
                            : false,
                        variants: mainItem
                            ? item.variants.filter(
                                  (v) => mainItem.variants.findIndex((t: VariantsObj) => t.id == v.id) >= 0,
                              )
                            : [],
                    };
                });

                setSequentialSubStepProducts((prev) => ({ ...prev, [subStepIdx]: finalList }));
            } catch (error: any) {
                if (error?.name !== "AbortError") {
                    console.error("Error loading specific products for sequential substep:", error);
                    setSequentialSubStepProducts((prev) => ({ ...prev, [subStepIdx]: [] }));
                }
            }
        }
    };

    useEffect(() => {
        if (bundleConfig?.substep_layout === "sequential" && steps[activeStep]?.enable_subSteps) {
            const controller = new AbortController();
            abortControllerRef.current = controller;
            const signal = controller.signal;
            setLoadingProducts(true);
            const subSteps = steps[activeStep]?.subSteps || [];
            const promises = subSteps.map((subStep, idx) => fetchProductsForSubStep(subStep, idx, activeStep, signal));
            Promise.all(promises).finally(() => {
                if (!signal.aborted) {
                    setLoadingProducts(false);
                }
            });
            return () => {
                controller.abort();
            };
        }
    }, [
        activeStep,
        steps[activeStep]?.enable_subSteps,
        standAlone ? steps[activeStep]?.subSteps?.length : steps[activeStep]?.subSteps,
        bundleConfig?.substep_layout,
        bundleConfig?.hide_out_of_stock_products,
    ]);

    useEffect(() => {
        const controller = new AbortController();
        abortControllerRef.current = controller;
        const signal = controller.signal;
        setPageInfo(null);
        setListProducts([]);

        if (bundleConfig?.substep_layout === "sequential" && steps[activeStep]?.enable_subSteps) {
            return () => {
                controller.abort();
            };
        }

        setSequentialSubStepProducts({});
        setLoadingMore(false);

        if (steps[activeStep]?.step_content_type !== "fields" && !steps[activeStep]?.enable_subSteps) {
            getProductsStepWise(steps[activeStep], signal);
        } else if (steps[activeStep]?.step_content_type !== "fields" && steps[activeStep]?.enable_subSteps) {
            getProductsStepWise(steps[activeStep].subSteps?.[activeSubStep], signal);
        } else {
            setLoadingProducts(false);
        }

        return () => {
            controller.abort();
        };
    }, [
        steps[activeStep]?.step_content_type,
        steps[activeStep]?.product_selection,
        steps[activeStep]?.products,
        steps[activeStep]?.collections,
        steps[activeStep]?.subSteps?.[activeSubStep],
        bundleConfig?.hide_out_of_stock_products,
        bundleConfig?.substep_layout,
    ]);

    // Fetch addon products for review step
    useEffect(() => {
        const fetchAddonProducts = async () => {
            if (!steps[activeStep]?.review_step || !bundleConfig?.review_step?.enable_addon_products) {
                setAddonProducts([]);
                return;
            }

            setLoadingAddons(true);

            try {
                if (bundleConfig.review_step.addon_product_selection === "specific") {
                    // Fetch specific products
                    const newConfig = await updateBundleConfigWithRealTimeProducts(
                        sft,
                        [{ ...bundleConfig, products: bundleConfig.review_step.addon_products || [] }],
                        standAlone,
                    );
                    const rawList = bundleConfig?.hide_out_of_stock_products
                        ? newConfig[0]?.products?.filter(filterInStockProducts) || []
                        : newConfig[0]?.products || [];
                    setAddonProducts(rawList);
                } else if (bundleConfig.review_step.addon_product_selection === "collection") {
                    // Fetch collection products
                    const collectionId = bundleConfig.review_step.collections?.[0]?.id?.split("/")?.pop();
                    if (collectionId) {
                        const { products } = await fetchCollectionProducts(
                            collectionId,
                            sft,
                            setLoadingAddons,
                            standAlone,
                            fetchCount,
                            null,
                        );
                        const rawList = bundleConfig?.hide_out_of_stock_products
                            ? products?.filter(filterInStockProducts) || []
                            : products || [];
                        setAddonProducts(rawList);
                    }
                }
            } catch (error) {
                console.error("Error fetching addon products:", error);
                setAddonProducts([]);
            } finally {
                setLoadingAddons(false);
            }
        };

        fetchAddonProducts();
    }, [activeStep, steps?.length, bundleConfig?.review_step, bundleConfig?.hide_out_of_stock_products]);

    useEffect(() => {
        if (standAlone && !checkForEmbedId(bundleConfig.bundle_embed_id)) {
            requestAnimationFrame(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            });
        }
    }, [activeStep, bundleConfig.bundle_embed_id]);

    useEffect(() => {
        const trigger = loadMoreTriggerRef.current;
        const scrollContainer = productListRef.current;

        if (!trigger || !scrollContainer || !pageInfo?.hasNextPage) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loadingMore) {
                    observer.disconnect();
                    loadMoreCollectionProducts(pageInfo, abortControllerRef.current?.signal);
                }
            },
            {
                root: scrollContainer,
                threshold: 0.2,
            },
        );

        observer.observe(trigger); // observe latest trigger

        return () => {
            observer.unobserve(trigger); // cleanup previous trigger
            observer.disconnect();
        };
    }, [pageInfo?.hasNextPage, loadMoreTriggerRef, listProducts.length]);

    useEffect(() => {
        const step = steps[activeStep];
        if (bundleConfig?.substep_layout === "sequential" && step?.enable_subSteps) {
            let totalCount = 0;
            let totalPrice = 0;
            step.subSteps?.forEach((_: any, idx: number) => {
                totalCount += Number(getCurrentPageSelectCount(selectedProducts, activeStep, idx)) || 0;
                totalPrice += Number(getCurrentPageSelectTotal(selectedProducts, activeStep, idx)) || 0;
            });
            setCurrentPageSelectCount(totalCount);
            setCurrentPageSelectTotal(totalPrice);
        } else {
            const subStepId = step?.enable_subSteps && step?.substep_rules_type === "step_level" ? -1 : activeSubStep;
            const count = getCurrentPageSelectCount(selectedProducts, activeStep, subStepId);
            const price = getCurrentPageSelectTotal(selectedProducts, activeStep, subStepId);
            setCurrentPageSelectCount(count);
            setCurrentPageSelectTotal(price);
        }
    }, [selectedProducts, activeStep, activeSubStep, steps, bundleConfig?.substep_layout]);

    const isNextAllowed = (step: ExtendedStepsType) => {
        if (!step?.step_content_type) {
            return true;
        }

        if (step?.enable_subSteps && step?.substep_rules_type === "no_rules") {
            return true;
        }

        if (step?.show_step_conditions === false && !step?.enable_subSteps) {
            return true;
        }

        if (step?.enable_subSteps && step?.subSteps?.length > 0 && step?.substep_rules_type !== "step_level") {
            let subStepFlag = true;
            step.subSteps.forEach((subStep: SubStepType, subStepId: number) => {
                if (subStep?.hidden && bundleConfig?.substep_layout == "sequential") return;
                if (!isNextAllowedSubSteps(subStep, subStepId)) {
                    subStepFlag = false;
                }
            });
            return subStepFlag;
        }

        // Custom text validation
        if (isLilSweetTreatStore && step?.allow_product_custom_text && !step?.enable_subSteps) {
            const stepProducts = selectedProducts.filter((sp) => sp.page === activeStep?.toString());
            if (stepProducts.some((sp) => !sp.custom_text || sp.custom_text.trim() === "")) {
                return false;
            }
        }
        return checkProductLimit(step?.step_conditions, +currentPageSelectCount, currentPageSelectTotal);
    };

    const isNextAllowedSubSteps = (subStep: SubStepType, subStepId: number) => {
        if (isLilSweetTreatStore && subStep?.allow_product_custom_text) {
            const subStepProducts = selectedProducts.filter(
                (sp) => sp.page === activeStep?.toString() && sp.subStep === subStepId?.toString(),
            );
            if (subStepProducts.some((sp) => !sp.custom_text || sp.custom_text.trim() === "")) {
                return false;
            }
        }

        return checkProductLimit(
            [
                {
                    basis: subStep.subStep_condition_basis || "items_count",
                    type: subStep.subStep_condition_type,
                    limit: subStep.product_count_limit,
                },
            ],
            +getCurrentPageSelectCount(selectedProducts, activeStep, subStepId),
            getCurrentPageSelectTotal(selectedProducts, activeStep, subStepId),
        );
    };

    const isAutoNextAllowed = (currentStep: any) => {
        if (!currentStep) return false;

        if (currentStep?.show_step_conditions === false && !currentStep?.enable_subSteps) {
            return false;
        }

        if (currentStep?.enable_subSteps && currentStep.substep_rules_type === "no_rules") {
            return false;
        }

        if (isLilSweetTreatStore && currentStep?.allow_product_custom_text && !currentStep?.enable_subSteps) {
            return false;
        }

        if (
            isLilSweetTreatStore &&
            currentStep?.enable_subSteps &&
            currentStep?.subSteps[activeSubStep]?.allow_product_custom_text
        ) {
            return false;
        }

        if (
            currentStep.enable_subSteps &&
            currentStep.subSteps?.length > 0 &&
            currentStep.substep_rules_type !== "step_level"
        ) {
            if (bundleConfig?.substep_layout === "sequential") {
                const allSubStepsMet = currentStep.subSteps?.every((subStep: any, subStepIdx: number) => {
                    if (subStep?.hidden) return true;
                    const subStepCount =
                        Number(getCurrentPageSelectCount(selectedProducts, activeStep, subStepIdx)) || 0;
                    const subStepTotal =
                        Number(getCurrentPageSelectTotal(selectedProducts, activeStep, subStepIdx)) || 0;
                    const subStepConditions = [
                        {
                            basis: subStep.subStep_condition_basis || "items_count",
                            type: subStep.subStep_condition_type,
                            limit: Number(subStep.product_count_limit),
                        },
                    ];
                    return shouldGoToNext(subStepConditions, subStepCount, subStepTotal);
                });
                return allSubStepsMet;
            }

            const subStep = currentStep.subSteps[activeSubStep];
            const subStepCount = Number(getCurrentPageSelectCount(selectedProducts, activeStep, activeSubStep)) || 0;
            const subStepTotal = Number(getCurrentPageSelectTotal(selectedProducts, activeStep, activeSubStep)) || 0;

            const subStepConditions = [
                {
                    basis: subStep.subStep_condition_basis || "items_count",
                    type: subStep.subStep_condition_type,
                    limit: Number(subStep.product_count_limit),
                },
            ];

            return shouldGoToNext(subStepConditions, subStepCount, subStepTotal);
        }

        if (currentStep.step_conditions) {
            return shouldGoToNext(currentStep.step_conditions, currentPageSelectCount, currentPageSelectTotal);
        }

        return false;
    };

    const isMetalBird = METAL_BIRD_SHOPS.includes(userShopname || "");
    useEffect(() => {
        const run = async () => {
            const currentStep = steps[activeStep];

            if (
                !bundleConfig?.auto_advance_when_condition_matched ||
                currentStep?.review_step ||
                (currentStep?.show_step_conditions === false && !currentStep?.enable_subSteps) ||
                loadingProducts ||
                activeStep >= steps.length - 1 // Already at last step
            ) {
                return;
            }

            const hasStepConditions = currentStep?.step_conditions?.length > 0;
            const hasSubStepConditions =
                currentStep?.enable_subSteps &&
                currentStep?.subSteps?.some(
                    (subStep: any) => subStep.subStep_condition_type && subStep.product_count_limit,
                );

            if (!hasStepConditions && !hasSubStepConditions) {
                return;
            }

            const nextAllowed = isAutoNextAllowed(currentStep);

            if (nextAllowed) {
                if (currentStep.enable_subSteps && currentStep.subSteps?.length > 0) {
                    if (bundleConfig?.substep_layout === "sequential") {
                        setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
                        setActiveSubStep(0);
                        return;
                    }
                    setActiveSubStep((prev) => {
                        const nextSub = prev + 1;
                        if (nextSub < currentStep.subSteps.length) {
                            return nextSub;
                        } else {
                            setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
                            return 0;
                        }
                    });
                    return;
                }
                const baseNext = activeStep + 1;
                if (currentStep.step_content_type === "free_gift") {
                    let nextIndex = baseNext;

                    if (isMetalBird) {
                        while (nextIndex < steps.length) {
                            const step = steps[nextIndex];

                            const stepProducts = selectedProducts.filter(
                                (sp: ProductObj) =>
                                    sp.page === nextIndex.toString() && sp?.selectedVariants?.length > 0,
                            );
                            // Auto-fill missing free gifts
                            if (stepProducts.length === 0) {
                                await autoFillFreeGift(step, nextIndex);
                            }
                            nextIndex++;
                        }
                    }
                    setActiveStep(Math.min(nextIndex, steps.length - 1));
                    return;
                }
                setActiveStep(Math.min(baseNext, steps.length - 1));
            }
        };
        run();
    }, [currentPageSelectCount, currentPageSelectTotal]);

    // useEffect to set Step/SubStep Error Msg
    useEffect(() => {
        if (steps[activeStep]?.step_content_type != "fields") {
            setDisableNextOnFields(false);
        }

        if (steps[activeStep]?.show_step_conditions === false && !steps[activeStep]?.enable_subSteps) {
            setNextErrorMsg([]);
            return;
        }

        if (steps[activeStep]?.enable_subSteps && steps[activeStep]?.substep_rules_type === "no_rules") {
            setNextErrorMsg([]);
            return;
        }

        if (
            steps[activeStep]?.enable_subSteps &&
            steps[activeStep]?.subSteps?.length &&
            steps[activeStep]?.substep_rules_type !== "step_level"
        ) {
            const msg: string[] = [];
            let subStepMsg = "";
            steps[activeStep]?.subSteps.forEach((subStep: SubStepType, idx: number) => {
                if (subStep?.hidden && bundleConfig?.substep_layout === "sequential") {
                    return;
                }
                subStepMsg = "";
                subStepMsg = getValidErrorMsg(
                    {
                        ...subStep,
                        basis: subStep?.subStep_condition_basis || "items_total",
                        type: subStep?.subStep_condition_type,
                    },
                    {
                        msg: subStep.step_error_msg,
                        limit: subStep.product_count_limit,
                        basis: subStep?.subStep_condition_basis || "items_total",
                        type: subStep?.subStep_condition_type,
                    },
                    getCurrentPageSelectCount(selectedProducts, activeStep, idx),
                    getCurrentPageSelectTotal(selectedProducts, activeStep, idx),
                    currency,
                    currencyToSymbols,
                );

                if (subStepMsg) {
                    msg.push(subStepMsg);
                }

                // Add custom text error msg for substep
                if (isLilSweetTreatStore && subStep?.allow_product_custom_text) {
                    const subStepProducts = selectedProducts.filter(
                        (sp) => sp.page === activeStep?.toString() && sp.subStep === idx?.toString(),
                    );
                    if (subStepProducts.some((sp) => !sp.custom_text || sp.custom_text.trim() === "")) {
                        msg.push(
                            `Please provide ${subStep?.product_custom_text_label || "custom text"} for all selected products.`,
                        );
                    }
                }
            });
            setNextErrorMsg(msg);
        } else {
            const msg: string[] = [];
            let stepMsg = "";
            const subStepId =
                steps[activeStep]?.enable_subSteps && steps[activeStep]?.substep_rules_type === "step_level" ? -1 : 0;
            if (steps[activeStep]?.step_conditions)
                steps[activeStep]?.step_conditions?.forEach((condition: StepConditionType) => {
                    stepMsg = "";
                    stepMsg = getValidErrorMsg(
                        steps[activeStep],
                        condition,
                        getCurrentPageSelectCount(selectedProducts, activeStep, subStepId),
                        getCurrentPageSelectTotal(selectedProducts, activeStep, subStepId),
                        currency,
                        currencyToSymbols,
                    );
                    if (stepMsg) {
                        msg.push(stepMsg);
                    }
                });

            // Add custom text error msg for step
            if (
                isLilSweetTreatStore &&
                steps[activeStep]?.allow_product_custom_text &&
                !steps[activeStep]?.enable_subSteps
            ) {
                const stepProducts = selectedProducts.filter((sp) => sp.page === activeStep?.toString());
                if (stepProducts.some((sp) => !sp.custom_text || sp.custom_text.trim() === "")) {
                    msg.push(
                        `Please provide ${steps[activeStep]?.product_custom_text_label || "custom text"} for all selected products.`,
                    );
                }
            }
            if (msg) {
                setNextErrorMsg(msg);
            } else {
                setNextErrorMsg([]);
            }
        }
    }, [currentPageSelectCount, activeStep, steps, activeSubStep, currentPageSelectTotal]);

    const disableCtas = (step: ExtendedStepsType, aSS: number) => {
        if (bundleConfig?.discount_type === DISCOUNT_TYPES.FIXED_BOXES && normalTotalQuantity >= maxBoxSize) {
            return true;
        }

        if (step?.show_step_conditions === false && !step?.enable_subSteps) {
            return false;
        }

        if (step?.enable_subSteps && step?.substep_rules_type === "no_rules") {
            return false;
        }

        // disable Product Card Add/Inc CTA
        if (step?.enable_subSteps && step?.subSteps?.length && step?.substep_rules_type !== "step_level") {
            const subStep = step.subSteps[aSS];
            const count = +getCurrentPageSelectCount(selectedProducts, activeStep, aSS);
            const price = getCurrentPageSelectTotal(selectedProducts, activeStep, aSS);
            return shouldDisableCta(
                [
                    {
                        basis: subStep?.subStep_condition_basis || "items_count",
                        type: subStep?.subStep_condition_type,
                        limit: subStep?.product_count_limit,
                    },
                ],
                count,
                price,
            );
        } else {
            return shouldDisableCta(step?.step_conditions, currentPageSelectCount, currentPageSelectTotal);
        }
    };

    const filterByQuery = (product: ProductObj) => {
        const query = searchQuery?.trim()?.toLowerCase() || "";
        if (!query) {
            return true;
        } else {
            if (product.handle?.toLowerCase().includes(query) || product.title?.toLowerCase().includes(query)) {
                return true;
            } else if (product.variants?.length) {
                let hasVariant = false;
                product?.variants.forEach((variant: VariantsObj) => {
                    if (variant?.title.toLowerCase()?.includes(query) && !hasVariant) {
                        hasVariant = true;
                    }
                });
                return hasVariant;
                // search variants array of VariantObj
            } else {
                return false;
            }
        }
    };

    const isValidBoxSize = () => {
        if (bundleConfig?.discount_type !== DISCOUNT_TYPES.FIXED_BOXES) return true;
        const fixedBoxes = bundleConfig?.fixed_boxes || [];
        return fixedBoxes.some((box: any) => box.itemsCount === normalTotalQuantity);
    };

    useEffect(() => {
        try {
            const wrapper = document.querySelector<HTMLElement>(styles.bundleBuilderPagesWrapper);
            if (!wrapper) return;
            // 1. Get the original value of --colorTextBody
            const originalValue = getComputedStyle(wrapper).getPropertyValue("--colorTextBody");
            // 2. Set to unset
            wrapper.style.setProperty("--colorTextBody", "unset");
            // 3. Cleanup: restore original value
            return () => {
                try {
                    if (originalValue) {
                        wrapper.style.setProperty("--colorTextBody", originalValue.trim());
                    } else {
                        wrapper.style.removeProperty("--colorTextBody");
                    }
                } catch (cleanupErr) {
                    console.error("Error restoring css var", cleanupErr);
                }
            };
        } catch (err) {
            console.error("Error updating css var", err);
        }
    }, []);

    const getFilteredListProducts = () => {
        if (bundleConfig?.allow_conditional_logic && bundleConfig?.product_conditions?.length) {
            return applyConditionsBB(bundleConfig.product_conditions, selectedProducts, listProducts);
        }
        return listProducts;
    };

    const baseProducts = flatProductAsVariants(getFilteredListProducts(), !!steps[activeStep]?.render_as_variants);
    const filteredListProducts = bundleConfig?.hide_out_of_stock_products
        ? baseProducts.filter(filterByQuery)?.filter(filterInStockProducts)
        : baseProducts.filter(filterByQuery);

    useEffect(() => {
        if (!loadingProducts) {
            const container: any = document.querySelector(`.${styles.bundleBuilderPagesWrapper}`);
            if (!container) return;
            container.style.opacity = "0";
            setTimeout(() => {
                container.style.opacity = "1";
            }, 100);
        }
    }, [loadingProducts]);

    const handleSecondaryButtonCTAClick = () => {
        if (bundleConfig?.secondary_button_type === "start_again") {
            setSelectedProducts([]);
            setFieldsData([]);
            setActiveStep(0);
        } else {
            sessionStorage.setItem("goToStep", "prev");
            setActiveStep((ps: number) => ps - 1);
        }
    };
    function buildSelectedVariants(product: ProductObj): VariantsObj[] {
        const firstAvailableVariant = product?.variants?.find((v) => v.availableForSale) || product?.variants?.[0];

        if (!firstAvailableVariant) return [];

        return [
            {
                ...firstAvailableVariant,
                selling_plan: !product.oneTimePurchase ? product.subscriptions?.find((sub) => sub.checked)?.id : "",
                copyPrice: firstAvailableVariant.price,
            },
        ];
    }

    const autoFillFreeGift = async (step: ExtendedStepsType, nextIndex: number) => {
        const limit = Number(
            step.show_step_conditions ? step.step_conditions.find((c) => c.type === "exact_products")?.limit : 0,
        );
        const products = step.products;

        if (!limit || !Array.isArray(products) || products.length === 0) return;

        // Number of products to "add" in first cycle (max each product once)
        const firstCycleCount = Math.min(products.length, limit);

        for (let i = 0; i < limit; i++) {
            const product = products[i % products.length];
            const opType = i < firstCycleCount ? "add" : "inc";
            const selectedVariants = buildSelectedVariants(product);

            handleAddProduct(
                {
                    ...product,
                    selectedVariants,
                    freeGift: true,
                    render_as_variants: step.render_as_variants,
                },
                opType,
                nextIndex.toString(),
            );
        }
    };

    const custom_css = bundleConfig?.bundles_settings?.custom_css || "";
    const custom_js = bundleConfig?.bundles_settings?.custom_js || "";

    useEffect(() => {
        const formId = bundleConfig.form_id || "";

        if (custom_css) {
            injectScopedCSS(custom_css, formId);
        }

        if (custom_js) {
            executeScopedJS(custom_js, formId);
        }

        return () => {
            document.querySelector(`style[data-form-id="${formId}"]`)?.remove();
        };
    }, [bundleConfig.form_id]);

    const dispensaryFilteredTotalQty =
        isDispensaryCoStore && steps.some((step) => step?.enable_capacity_progress_bar)
            ? selectedProducts.reduce(
                  (sum, product) =>
                      sum +
                      (product?.selectedVariants?.filter((variant: any) => isNaN(parseFloat(variant?.capacityValue)))
                          .length ?? 0),
                  0,
              )
            : totalQuantity;

    const dispensaryFilteredTotalCapacity =
        isDispensaryCoStore && steps.some((step) => step?.enable_capacity_progress_bar)
            ? selectedProducts.reduce(
                  (sum, product) =>
                      sum +
                      (product?.selectedVariants?.filter((variant: any) => !isNaN(parseFloat(variant?.capacityValue)))
                          .length ?? 0),
                  0,
              )
            : totalQuantity;

    const isDispensaryProgressBarEnabled =
        isDispensaryCoStore && steps[activeStep]?.enable_capacity_progress_bar && dispensaryFilteredTotalCapacity > 0;

    return (
        <BundleBuilderBundleContext.Provider
            value={{
                steps,
                setActiveStep,
                activeStep,
                setSelectedProducts,
                setFieldsData,
                selectedProducts,
                selectedVariants,
                isMobile,
                bundleConfig: updatedBundleConfig,
                handleRemoveProduct,
                money_format,
                handleAddProduct,
                autoFillFreeGift,
                currency,
                expandProductList,
                handleBundleBuilderCheckout,
                setExpandProductList,
                standAlone,
                previewType,
                productListRef,
                isNextAllowed,
                isNextAllowedSubSteps,
                getCurrentPageSelectCount,
                checkingOut,
                nextErrorMsg,
                boxQuantity,
                tierSuccessMessage,
                activeSubStep,
                setActiveSubStep,
                disableNextOnFields,
                // discount related fields
                discountType,
                discountValue,
                actualConfigDiscountType: bundleConfig?.discount_type,
                // review addon related fields
                handleAddAddonProduct,
                handleRemoveAddonProduct,
                addonProducts,
                loadingAddons,
                // Quantity related fields
                totalQuantity,
                normalTotalQuantity,
                addonTotalQuantity,
                freeGiftTotalQuantity,
                anyCardShowingDosageResults,
                setAnyCardShowingDosageResults,
                dosageResultsHeight,
                setDosageResultsHeight,
                // price related fields
                totalPrice,
                totalCompareAtPrice,
                totalFreeGiftPrice,
                totalAddonPrice,
                addonsDiscountValue,
                baseSubtotal,
                baseSubtotalForDiscount,
                discountedBundleTotal,
                hasDiscount,
                showStrikePrice,
                discountAmount,
                discountAmountPercent,
                discountValueToShow,
                // misc fields
                containerRef,
                userShopname,
                maxBoxSize,
                isValidBoxSize,
                dispensaryFilteredTotalQty,
                dispensaryFilteredTotalCapacity,
                isDispensaryProgressBarEnabled,
            }}
        >
            {searchParams.has("form_id") && (
                <div style={{ maxWidth: "90%", margin: "auto" }}>
                    <PreviewBanner />
                </div>
            )}

            {showCheckoutModal && (
                <CheckoutModal
                    showCheckoutModal={showCheckoutModal}
                    bundleConfig={bundleConfig}
                    onClose={() => {
                        setShowCheckoutModal(false);
                    }}
                />
            )}

            {IS_CUSTOM_CLICK_TO_ADD_GRID_SHOPS ? (
                <BagGridShopBundlePreview
                    bundleConfig={bundleConfig}
                    isTemplate={isTemplate}
                    loadingProducts={loadingProducts}
                    listProducts={listProducts}
                    sequentialSubStepProducts={sequentialSubStepProducts}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    searchActive={searchActive}
                    setSearchActive={setSearchActive}
                    subStepDropdownOpen={subStepDropdownOpen}
                    setSubStepDropdownOpen={setSubStepDropdownOpen}
                    pageInfo={pageInfo}
                    loadMoreTriggerRef={loadMoreTriggerRef}
                    filteredListProducts={filteredListProducts}
                    disableCtas={disableCtas}
                    filterByQuery={filterByQuery}
                    handleSecondaryButtonCTAClick={handleSecondaryButtonCTAClick}
                    setBoxQuantity={setBoxQuantity}
                    fieldsData={fieldsData}
                    handleFields={handleFields}
                    setDisableNextOnFields={setDisableNextOnFields}
                />
            ) : (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="bundlePreviewWrapper">
                    <div
                        id="bundleBuilderPreviewWrapper"
                        ref={containerRef}
                        data-form-id={bundleConfig.form_id}
                        className={styles.bundleBuilderPagesWrapper}
                        style={{
                            fontFamily:
                                bundleConfig?.bundles_design?.bundle_widget_font_family == "Custom Store Font"
                                    ? "inherit"
                                    : bundleConfig?.bundles_design?.bundle_widget_font_family,
                            ...(standAlone && { paddingTop: isMobile ? "1rem" : "20px", minHeight: "60vh" }),
                            width: "100%",
                            padding: "20px 0px 20px 0px",
                            background: bundleConfig?.bundles_design?.bundle_widget_bg,
                            margin: "auto",
                            marginBottom:
                                standAlone && +bundleConfig?.bundles_design?.bb_margin_bottom
                                    ? bundleConfig?.bundles_design?.bb_margin_bottom
                                    : 10,
                            marginTop:
                                standAlone && bundleConfig?.bundles_design?.bb_margin_top
                                    ? bundleConfig?.bundles_design?.bb_margin_top
                                    : 0,
                            ...(checkingOut && { pointerEvents: "none" }),
                            ...(loadingProducts && { height: "100vh", overflow: "hidden" }),
                            ...(standAlone &&
                                userShopname === "selkbag.myshopify.com" && {
                                    padding: isMobile ? "20px 0 0 0" : "110px 0 0 0",
                                }),
                        }}
                    >
                        {!!bundleConfig?.top_html && (
                            <div dangerouslySetInnerHTML={{ __html: bundleConfig.top_html }} />
                        )}

                        {"by-and-by-n7mzgwwg.myshopify.com" === userShopname && !!bundleConfig?.title && (
                            <div
                                className={styles.pageTitleWrapper}
                                style={{
                                    fontSize: bundleConfig?.bundles_design?.step_page_title_size,
                                    color: bundleConfig?.bundles_design?.step_page_title_color,
                                    fontWeight:
                                        bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[0] ?? "550",
                                    fontStyle:
                                        bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[1] ?? "normal",
                                    textAlign: "center",
                                    marginBottom: "12px",
                                }}
                            >
                                {bundleConfig.title}
                            </div>
                        )}

                        {bundleConfig?.discount_type === DISCOUNT_TYPES.FIXED_BOXES &&
                            !(bundleConfig?.footer_layout === "right" && !isMobile) && (
                                <BoxTilesWrapper fixedBoxes={bundleConfig?.fixed_boxes || []} />
                            )}
                        {checkingOut && <CheckingOutLoader color={"#fff"} />}
                        {steps?.length && !bundleConfig?.hide_bundle_header && <StepsHeaderBar />}
                        {/* Data Wrapper Starts */}

                        {!steps[activeStep]?.review_step ? (
                            <>
                                {steps[activeStep]?.step_content_type !== "fields" ? (
                                    <div
                                        style={{
                                            ...(bundleConfig?.footer_layout === "right" && !isMobile
                                                ? {
                                                      display: "grid",
                                                      gridTemplateColumns: "4fr 1.2fr",
                                                  }
                                                : {
                                                      display: "flex",
                                                      flexDirection: "row",
                                                  }),
                                            gap: "40px",
                                            alignItems: "start",
                                            position: "relative",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "10px",
                                                width: "100%",
                                            }}
                                        >
                                            <PageTitleSubtitleWrapper />

                                            {bundleConfig?.show_search_bar &&
                                                (!!listProducts?.length ||
                                                    !!Object.keys(sequentialSubStepProducts)?.length) && (
                                                    <div
                                                        className={styles.searchWrapper}
                                                        style={{
                                                            justifyContent: isMobile
                                                                ? (bundleConfig?.search_bar_alignment_mobile ??
                                                                  "center")
                                                                : (bundleConfig?.search_bar_alignment_desktop ??
                                                                  "flex-end"),
                                                            width: isMobile ? "90%" : "85%",
                                                        }}
                                                    >
                                                        <div
                                                            className={`${styles.searchWrapperInput} ${
                                                                searchActive && styles.active
                                                            }`}
                                                        >
                                                            <input
                                                                value={searchQuery}
                                                                onFocus={() => setSearchActive(true)}
                                                                placeholder={"Search Products"}
                                                                onBlur={() => setSearchActive(false)}
                                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                            />
                                                            <SearchIcon color={searchActive ? "black" : "#bdbdbd"} />
                                                        </div>
                                                    </div>
                                                )}

                                            {steps[activeStep]?.enable_subSteps &&
                                                bundleConfig?.substep_layout !== "sequential" && (
                                                    <>
                                                        {isMobile ? (
                                                            bundleConfig?.bundles_design
                                                                ?.mobile_substep_header_layout === "tabs" ||
                                                            bundleConfig?.bundles_design
                                                                ?.mobile_substep_header_layout === "scrollable_tabs" ? (
                                                                <RenderSubStepBadges />
                                                            ) : (
                                                                <RenderSubStepDropdown
                                                                    subStepDropdownOpen={subStepDropdownOpen}
                                                                    setSubStepDropdownOpen={setSubStepDropdownOpen}
                                                                />
                                                            )
                                                        ) : (
                                                            <RenderSubStepBadges />
                                                        )}
                                                    </>
                                                )}

                                            {bundleConfig?.substep_layout === "sequential" &&
                                            steps[activeStep]?.enable_subSteps ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "20px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    {steps[activeStep]?.subSteps?.map((subStep, subStepIdx) => {
                                                        if (subStep?.hidden) return null;
                                                        let subStepProducts =
                                                            sequentialSubStepProducts[subStepIdx] || [];
                                                        if (
                                                            bundleConfig?.allow_conditional_logic &&
                                                            bundleConfig?.product_conditions?.length
                                                        ) {
                                                            subStepProducts = applyConditionsBB(
                                                                bundleConfig.product_conditions,
                                                                selectedProducts,
                                                                subStepProducts,
                                                            );
                                                        }
                                                        const baseProducts = flatProductAsVariants(
                                                            subStepProducts,
                                                            !!steps[activeStep]?.render_as_variants,
                                                        );
                                                        const filteredSubStepProducts =
                                                            bundleConfig?.hide_out_of_stock_products
                                                                ? baseProducts
                                                                      .filter(filterByQuery)
                                                                      ?.filter(filterInStockProducts)
                                                                : baseProducts.filter(filterByQuery);

                                                        return (
                                                            <div
                                                                key={subStepIdx}
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: "20px",
                                                                }}
                                                            >
                                                                {/* Substep Title Header */}
                                                                <div
                                                                    style={{
                                                                        fontSize: "20px",
                                                                        fontWeight: 700,
                                                                        color:
                                                                            bundleConfig?.bundles_design
                                                                                ?.step_page_title_color || "#333",
                                                                        borderBottom: `2px solid ${bundleConfig?.bundles_design?.product_border_color || "rgba(0, 0, 0, 0.1)"}`,
                                                                        paddingBottom: "10px",
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        width: "90%",
                                                                        margin: "0 auto",
                                                                    }}
                                                                >
                                                                    <span>{subStep.step_label}</span>
                                                                </div>

                                                                <div
                                                                    className={`${styles.productsWrapper} ${
                                                                        isMobile && styles.productsWrapperMobile
                                                                    }`}
                                                                    style={{
                                                                        maxHeight: "auto",
                                                                        minWidth: "60%",
                                                                        paddingBottom: 10,
                                                                        gridTemplateColumns: `repeat(auto-fit, minmax(${getBBCardWidth(
                                                                            isMobile
                                                                                ? bundleConfig?.product_card_mobile_size ||
                                                                                      "medium"
                                                                                : bundleConfig?.product_card_desktop_size ||
                                                                                      "medium",
                                                                            isMobile ? "mobile" : "desktop",
                                                                        )}, ${getBBCardWidth(
                                                                            isMobile
                                                                                ? bundleConfig?.product_card_mobile_size ||
                                                                                      "medium"
                                                                                : bundleConfig?.product_card_desktop_size ||
                                                                                      "medium",
                                                                            isMobile ? "mobile" : "desktop",
                                                                        )}))`,
                                                                        gap: getGapForSize(
                                                                            isMobile
                                                                                ? bundleConfig?.product_card_mobile_size
                                                                                : bundleConfig?.product_card_desktop_size,
                                                                            isMobile,
                                                                        ),
                                                                        justifyContent: loadingProducts
                                                                            ? "center"
                                                                            : "flex-start",
                                                                    }}
                                                                >
                                                                    {loadingProducts ? (
                                                                        <div
                                                                            style={{
                                                                                minHeight: "20vh",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                margin: "auto",
                                                                            }}
                                                                        >
                                                                            <Spinner
                                                                                size={"5vw"}
                                                                                color={
                                                                                    bundleConfig?.bundles_design
                                                                                        ?.add_to_cart_bg_color
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ) : filteredSubStepProducts.length ? (
                                                                        filteredSubStepProducts.map(
                                                                            (product: ProductObj, index: number) => (
                                                                                <ProductCard
                                                                                    key={
                                                                                        product?.id +
                                                                                        product?.variants[0]?.id
                                                                                    }
                                                                                    index={index}
                                                                                    product={product}
                                                                                    setTrackVariant={() => {}}
                                                                                    handleAddProduct={handleAddProduct}
                                                                                    is_gift_step={
                                                                                        steps[activeStep]
                                                                                            ?.step_content_type ===
                                                                                        "free_gift"
                                                                                    }
                                                                                    disableCtas={
                                                                                        product?.exclude_from_step_conditions
                                                                                            ? false
                                                                                            : disableCtas(
                                                                                                  steps[activeStep],
                                                                                                  subStepIdx,
                                                                                              )
                                                                                    }
                                                                                    currentStep={steps[activeStep]}
                                                                                    subStepOverride={subStepIdx}
                                                                                />
                                                                            ),
                                                                        )
                                                                    ) : (
                                                                        <div className={styles.productsEmpty}>
                                                                            No Products Available
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div
                                                    ref={productListRef}
                                                    className={`${styles.productsWrapper} ${
                                                        isMobile && styles.productsWrapperMobile
                                                    }`}
                                                    style={{
                                                        maxHeight: "auto",
                                                        minWidth: "60%",
                                                        paddingBottom: 10,
                                                        minHeight:
                                                            listProducts.length == 0 && loadingMore ? "100vh" : "",
                                                        ...(!standAlone && { maxHeight: "52vh", overflowY: "auto" }),
                                                        gridTemplateColumns: `repeat(auto-fit, minmax(${getBBCardWidth(
                                                            isMobile
                                                                ? bundleConfig?.product_card_mobile_size || "medium"
                                                                : bundleConfig?.product_card_desktop_size || "medium",
                                                            isMobile ? "mobile" : "desktop",
                                                        )}, ${getBBCardWidth(
                                                            isMobile
                                                                ? bundleConfig?.product_card_mobile_size || "medium"
                                                                : bundleConfig?.product_card_desktop_size || "medium",
                                                            isMobile ? "mobile" : "desktop",
                                                        )}))`,
                                                        gap: getGapForSize(
                                                            isMobile
                                                                ? bundleConfig?.product_card_mobile_size
                                                                : bundleConfig?.product_card_desktop_size,
                                                            isMobile,
                                                        ),
                                                        ...(checkForEmbedId(bundleConfig?.bundle_embed_id) && {
                                                            paddingBottom: 30,
                                                        }),
                                                    }}
                                                >
                                                    {loadingProducts ? (
                                                        <div
                                                            style={{
                                                                minHeight: "30vh",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                margin: "auto",
                                                            }}
                                                        >
                                                            <Spinner
                                                                size={"5vw"}
                                                                color={
                                                                    bundleConfig?.bundles_design?.add_to_cart_bg_color
                                                                }
                                                            />
                                                        </div>
                                                    ) : filteredListProducts?.length ? (
                                                        <>
                                                            {filteredListProducts?.map(
                                                                (product: ProductObj, index: number) => {
                                                                    return (
                                                                        <ProductCard
                                                                            key={product?.id + product?.variants[0]?.id}
                                                                            index={index}
                                                                            product={product}
                                                                            setTrackVariant={() => {}}
                                                                            handleAddProduct={handleAddProduct}
                                                                            is_gift_step={
                                                                                steps[activeStep]?.step_content_type ===
                                                                                "free_gift"
                                                                            }
                                                                            disableCtas={
                                                                                product?.exclude_from_step_conditions
                                                                                    ? false
                                                                                    : disableCtas(
                                                                                          steps[activeStep],
                                                                                          activeSubStep,
                                                                                      )
                                                                            }
                                                                            currentStep={steps[activeStep]}
                                                                            // don't send subStepOverride in this case else condition fails
                                                                        />
                                                                    );
                                                                },
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className={styles.productsEmpty}>
                                                            {standAlone
                                                                ? "No Products Available"
                                                                : "Configure Steps to See Preview"}
                                                        </div>
                                                    )}

                                                    {listProducts.length > 0 && pageInfo?.hasNextPage && (
                                                        <span
                                                            ref={loadMoreTriggerRef}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "stretch",
                                                                height: 10,
                                                                width: "100%",
                                                            }}
                                                        ></span>
                                                    )}
                                                </div>
                                            )}

                                            {!!steps?.[activeStep]?.bottom_subtitle && (
                                                <InspectorEditableBlock
                                                    bundleType={bundleConfig?.bundle_type}
                                                    settingKey="stepSubTitle"
                                                >
                                                    <div
                                                        className={styles.bottomSubtitle}
                                                        style={{
                                                            marginBottom: "6px",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: steps?.[activeStep]?.bottom_subtitle,
                                                        }}
                                                    ></div>
                                                </InspectorEditableBlock>
                                            )}
                                        </div>

                                        {!isMobile && bundleConfig?.footer_layout == "right" && (
                                            <div className={styles.rightSectionBB}>
                                                <BundleBuilderRightSection />
                                            </div>
                                        )}
                                    </div>
                                ) : steps[activeStep]?.step_content_type == "fields" &&
                                  steps[activeStep]?.fields?.length ? (
                                    <div
                                        ref={productListRef}
                                        style={{
                                            ...(bundleConfig?.footer_layout === "right" &&
                                                !isMobile && {
                                                    display: "grid",
                                                    gridTemplateColumns: "4fr 1.2fr",
                                                    gap: "40px",
                                                    alignItems: "start",
                                                    position: "relative",
                                                }),
                                        }}
                                    >
                                        <div
                                            className={`${styles.fieldsWrapper}`}
                                            style={{
                                                width: isMobile ? "auto" : "57vw",
                                                maxWidth: isMobile ? "auto" : "57vw",
                                            }}
                                        >
                                            <PageTitleSubtitleWrapper />
                                            <div style={{ maxWidth: isMobile ? "100%" : 500, margin: "auto" }}>
                                                <RenderFields
                                                    fields={steps[activeStep].fields}
                                                    bundleConfig={updatedBundleConfig}
                                                    handleFields={handleFields}
                                                    fieldsData={fieldsData}
                                                    setDisableNextOnFields={setDisableNextOnFields}
                                                    userShopname={userShopname || ""}
                                                    stepIdx={activeStep}
                                                />
                                            </div>
                                        </div>

                                        {!isMobile && bundleConfig?.footer_layout == "right" && (
                                            <div className={styles.rightSectionBB}>
                                                <BundleBuilderRightSection />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </>
                        ) : (
                            // Review Step Starts
                            <div
                                className={`${styles.reviewBundleWrapper}`}
                                style={{
                                    width: isMobile ? "100%" : "min-content",
                                }}
                            >
                                <div
                                    className={`${styles.reviewBundleHeader}`}
                                    style={{
                                        ...(isMobile && { width: "91%", marginInline: "auto" }),
                                    }}
                                >
                                    <div
                                        className={styles.reviewPageTitle}
                                        style={{
                                            minHeight: "20px",
                                            ...(selectedProducts.length == 0 && {
                                                width: "57vw",
                                                marginInline: "auto",
                                            }),
                                        }}
                                    >
                                        {!isMobile && (
                                            <button
                                                className={styles.editBundle}
                                                onClick={handleSecondaryButtonCTAClick}
                                                style={{
                                                    background: bundleConfig?.bundles_design?.edit_bundle_cta_bg_color,
                                                    color: bundleConfig?.bundles_design?.edit_bundle_cta_text_color,
                                                    border: `1px solid ${bundleConfig?.bundles_design?.edit_bundle_cta_bg_color}`,
                                                    fontSize: bundleConfig?.bundles_design?.edit_bundle_cta_size,
                                                    fontWeight:
                                                        bundleConfig?.bundles_design?.edit_bundle_cta_style?.split(
                                                            " ",
                                                        )[0] ?? "550",
                                                    fontStyle:
                                                        bundleConfig?.bundles_design?.edit_bundle_cta_style?.split(
                                                            " ",
                                                        )[1] ?? "normal",
                                                }}
                                            >
                                                <LeftArrow
                                                    color={bundleConfig?.bundles_design?.edit_bundle_cta_text_color}
                                                />{" "}
                                                {!isMobile &&
                                                    (bundleConfig?.secondary_button_type === "start_again"
                                                        ? bundleConfig?.start_again_cta_text
                                                        : bundleConfig?.edit_cta_text)}
                                            </button>
                                        )}
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="reviewStepPageTitle"
                                        >
                                            <span
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    width: isMobile ? "80%" : "100%",
                                                    margin: "auto",
                                                    alignItems: isMobile ? "baseline" : "center",
                                                    justifyContent: "center",
                                                    fontSize: bundleConfig?.bundles_design?.step_page_title_size,
                                                    color: bundleConfig?.bundles_design?.step_page_title_color,
                                                    fontWeight:
                                                        bundleConfig?.bundles_design?.step_page_title_style?.split(
                                                            " ",
                                                        )[0] ?? "550",
                                                    fontStyle:
                                                        bundleConfig?.bundles_design?.step_page_title_style?.split(
                                                            " ",
                                                        )[1] ?? "normal",
                                                }}
                                            >
                                                {bundleConfig?.review_step?.page_title}
                                            </span>
                                        </InspectorEditableBlock>
                                    </div>
                                </div>
                                {selectedProducts?.length ? (
                                    <div
                                        className={styles.reviewSection}
                                        style={{
                                            margin: "0 auto",
                                            flexDirection: isMobile ? "column" : "row",
                                            width: isMobile ? "auto" : "max-content",
                                            gap: isMobile ? 30 : 20,
                                            minHeight: isMobile ? "" : "55vh",
                                        }}
                                    >
                                        <div
                                            className={styles.reviewSectionLeft}
                                            style={{
                                                border: isMobile ? "none" : "1px solid rgba(0, 0, 0, 0.1)",
                                                gap: isMobile ? 15 : 10,
                                                maxHeight: isMobile ? "55vh" : "",
                                                padding: isMobile ? "10px" : "20px 25px",
                                                paddingBottom: isMobile ? 90 : 10,
                                                minHeight: isMobile ? "auto" : "auto",
                                            }}
                                        >
                                            <div
                                                className={styles.reviewTitleWrapper}
                                                style={{
                                                    ...(isMobile && {
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "baseline",
                                                    }),
                                                }}
                                            >
                                                <InspectorEditableBlock
                                                    bundleType={bundleConfig?.bundle_type}
                                                    settingKey="bundleReadyText"
                                                >
                                                    <div
                                                        className={styles.reviewSectionLeftTitle}
                                                        style={{
                                                            fontSize: bundleConfig?.bundles_design?.bundle_title_size,
                                                            color: bundleConfig?.bundles_design?.bundle_title_color,
                                                            fontWeight:
                                                                bundleConfig?.bundles_design?.bundle_title_style?.split(
                                                                    " ",
                                                                )[0] ?? "550",
                                                            fontStyle:
                                                                bundleConfig?.bundles_design?.bundle_title_style?.split(
                                                                    " ",
                                                                )[1] ?? "normal",
                                                        }}
                                                    >
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: bundleConfig?.bundle_ready_text?.replace(
                                                                    "{title}",
                                                                    bundleConfig?.title,
                                                                ) as string,
                                                            }}
                                                        ></span>
                                                    </div>
                                                </InspectorEditableBlock>
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "flex-start",
                                                    }}
                                                >
                                                    <div className={styles.quantityContainer}>
                                                        <button
                                                            className={styles.quantityButton}
                                                            style={{
                                                                color: "#2d2d2d",
                                                            }}
                                                            onClick={(e) => {
                                                                e?.stopPropagation();
                                                                e?.stopPropagation();
                                                                setBoxQuantity((ps) => (ps <= 1 ? 1 : ps - 1));
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    fontSize: 19,
                                                                    fontWeight: 350,
                                                                    position: "relative",
                                                                    color: "inherit",
                                                                    top: -1,
                                                                }}
                                                            >
                                                                -
                                                            </span>
                                                        </button>
                                                        <div className={styles.quantity}>{boxQuantity}</div>
                                                        <button
                                                            className={styles.quantityButton}
                                                            onClick={(e) => {
                                                                e?.stopPropagation();
                                                                e?.stopPropagation();
                                                                setBoxQuantity((ps) => ps + 1);
                                                            }}
                                                            style={{
                                                                color: "#2d2d2d",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    fontSize: 14,
                                                                    fontWeight: 450,
                                                                    position: "relative",
                                                                    color: "inherit",
                                                                    marginTop: -3,
                                                                }}
                                                            >
                                                                +
                                                            </span>
                                                        </button>
                                                    </div>
                                                </span>
                                            </div>
                                            {!!selectedVariants?.length &&
                                                selectedVariants
                                                    .sort((a, b) => a?.freeGift - b?.freeGift)
                                                    .map((sp, index) => (
                                                        <ReviewProductCard
                                                            key={index + sp?.title}
                                                            product={sp}
                                                            index={index}
                                                            handleRemoveProduct={() => {}}
                                                            isMobile={isMobile}
                                                            bundleConfig={updatedBundleConfig}
                                                            isReviewPage={true}
                                                            money_format={money_format}
                                                            currency={currency}
                                                            activeStep={activeStep}
                                                            freeGift={!!sp?.freeGift}
                                                            standAlone={standAlone}
                                                        />
                                                    ))}

                                            {isMobile &&
                                                bundleConfig?.review_step?.enable_addon_products &&
                                                !loadingAddons &&
                                                addonProducts.length > 0 && (
                                                    <ReviewAddOnCarousel
                                                        products={addonProducts}
                                                        selectedProducts={selectedProducts}
                                                        bundleConfig={updatedBundleConfig}
                                                        money_format={money_format}
                                                        currency={currency}
                                                        onAddProduct={handleAddAddonProduct}
                                                        onProductRemove={handleRemoveAddonProduct}
                                                        standAlone={standAlone}
                                                    />
                                                )}
                                            {loadingAddons && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        padding: "40px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Spinner
                                                        size={40}
                                                        color={bundleConfig?.bundles_design?.add_to_cart_bg_color}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        {isMobile ? (
                                            <OrderSummary />
                                        ) : (
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <OrderSummary />
                                                {bundleConfig?.review_step?.enable_addon_products &&
                                                    !loadingAddons &&
                                                    addonProducts.length > 0 && (
                                                        <ReviewAddOnCarousel
                                                            products={addonProducts}
                                                            selectedProducts={selectedProducts}
                                                            bundleConfig={updatedBundleConfig}
                                                            money_format={money_format}
                                                            currency={currency}
                                                            onAddProduct={handleAddAddonProduct}
                                                            onProductRemove={handleRemoveAddonProduct}
                                                            standAlone={standAlone}
                                                        />
                                                    )}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div style={{ textAlign: "center" }}>
                                        {bundleConfig.no_products_selected_text || "No Product(s) Selected"}
                                    </div>
                                )}
                            </div>
                            // Review Step Ends
                        )}
                        {/* Data Wrapper Ends */}
                        {!steps[activeStep]?.review_step &&
                            (isTemplate ? selectedProducts?.length > 0 : selectedProducts?.length >= 0) &&
                            !loadingProducts &&
                            (bundleConfig?.footer_layout != "right" || isMobile) && <BundleBuilderBottomSection />}
                    </div>
                </InspectorEditableBlock>
            )}
        </BundleBuilderBundleContext.Provider>
    );
};

export default BundleBuilderBundle;
